//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
  private readonly config: IConfig;

  protected constructor(config: IConfig) {
    this.config = config;
  }

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      "X-Groopit-Version": "11",
    };
    if (this.config?.getXSRFToken) {
      options.headers = {
        ...options.headers,
        "X-XSRF-TOKEN": this.config.getXSRFToken(),
      };
    }
    if (this.config?.getAuthToken) {
      options.headers = {
        ...options.headers,
        Authorization: "Bearer " + this.config.getAuthToken(),
      };
    }
    if (this.config?.getOutlookBearerToken) {
      options.headers = {
        ...options.headers,
        Authorization: "OutlookBearer " + this.config.getOutlookBearerToken(),
      };
    }
    if (this.config?.getOutlookHostName) {
      options.headers = {
        ...options.headers,
        "Outlook-Host-Name": this.config.getOutlookHostName(),
      };
    }
    if (this.config?.getOutlookHostVersion) {
      options.headers = {
        ...options.headers,
        "Outlook-Host-Version": this.config.getOutlookHostVersion(),
      };
    }

    options.credentials = "same-origin";
    return Promise.resolve(options);
  };
}

export class AccountClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Logs in a user with a webapi token
     * @param suppress_nav (optional) 
     * @param supports_web_links (optional) 
     */
    tokenLogin(suppress_nav: boolean | undefined, supports_web_links: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/TokenLogin?";
        if (suppress_nav === null)
            throw new Error("The parameter 'suppress_nav' cannot be null.");
        else if (suppress_nav !== undefined)
            url_ += "suppress_nav=" + encodeURIComponent("" + suppress_nav) + "&";
        if (supports_web_links === null)
            throw new Error("The parameter 'supports_web_links' cannot be null.");
        else if (supports_web_links !== undefined)
            url_ += "supports_web_links=" + encodeURIComponent("" + supports_web_links) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTokenLogin(_response);
        });
    }

    protected processTokenLogin(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Logs in a user with a webapi token
     * @param suppress_nav (optional) 
     * @param supports_web_links (optional) 
     */
    tokenLoginV2(suppress_nav: boolean | undefined, supports_web_links: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/TokenLogin?";
        if (suppress_nav === null)
            throw new Error("The parameter 'suppress_nav' cannot be null.");
        else if (suppress_nav !== undefined)
            url_ += "suppress_nav=" + encodeURIComponent("" + suppress_nav) + "&";
        if (supports_web_links === null)
            throw new Error("The parameter 'supports_web_links' cannot be null.");
        else if (supports_web_links !== undefined)
            url_ += "supports_web_links=" + encodeURIComponent("" + supports_web_links) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTokenLoginV2(_response);
        });
    }

    protected processTokenLoginV2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AuthorizationClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    authorizeGET(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/authorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthorizeGET(_response);
        });
    }

    protected processAuthorizeGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    authorizePOST(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/authorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthorizePOST(_response);
        });
    }

    protected processAuthorizePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    logoutGET(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogoutGET(_response);
        });
    }

    protected processLogoutGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    logoutPOST(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogoutPOST(_response);
        });
    }

    protected processLogoutPOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exchange(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExchange(_response);
        });
    }

    protected processExchange(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exchange2(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExchange2(_response);
        });
    }

    protected processExchange2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    consent(tenantId: string | null | undefined, returnUrl: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/consent?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConsent(_response);
        });
    }

    protected processConsent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class GroopItClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Attempts to convert the string unstructuredData to the data model that has the
    id assignmentId.
     * @param assignmentId The data model to attempt to fit the unstructuredData
                data into.
     * @param returnUrl (optional) 
     * @param unstructuredData (optional) 
     * @return A populated view of the data model using the provided raw data.
     */
    populateFromUnstructuredData(assignmentId: string, returnUrl: string | null | undefined, unstructuredData: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Groopit/PopulateFromUnstructuredData/{assignmentId}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (unstructuredData !== null && unstructuredData !== undefined)
            content_.append("unstructuredData", unstructuredData.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPopulateFromUnstructuredData(_response);
        });
    }

    protected processPopulateFromUnstructuredData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Attempts to convert the file identified by the uploadIdentifier to the data model that has the
    id assignmentId.
     * @param assignmentId The data model to attempt to fit the file contents from uploadIdentifier
                data into.
     * @param returnUrl (optional) 
     * @param uploadIdentifier (optional) 
     * @param generateMultipleModels (optional) 
     * @param generateFromGroupedData (optional) 
     * @param fileName (optional) 
     * @return A populated view of the data model using the provided raw data.
     */
    populateFromFile(assignmentId: string, returnUrl: string | null | undefined, uploadIdentifier: string | null | undefined, generateMultipleModels: boolean | undefined, generateFromGroupedData: boolean | undefined, fileName: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Groopit/PopulateFromFile/{assignmentId}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadIdentifier !== null && uploadIdentifier !== undefined)
            content_.append("uploadIdentifier", uploadIdentifier.toString());
        if (generateMultipleModels === null || generateMultipleModels === undefined)
            throw new Error("The parameter 'generateMultipleModels' cannot be null.");
        else
            content_.append("generateMultipleModels", generateMultipleModels.toString());
        if (generateFromGroupedData === null || generateFromGroupedData === undefined)
            throw new Error("The parameter 'generateFromGroupedData' cannot be null.");
        else
            content_.append("generateFromGroupedData", generateFromGroupedData.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("fileName", fileName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPopulateFromFile(_response);
        });
    }

    protected processPopulateFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Redirects to the Create view after extracting data model from the extracted data model index
     * @param assignmentId The Id of the Assignment Entity to build the view from.
     * @param extractedDataModelIndex The index used to select the Assignment in the list of Assignments.
     * @param returnUrl (optional) 
     * @param extractedDataModels (optional) 
     * @param id (optional) 
     * @param value (optional) 
     * @param includeSource (optional) 
     */
    getFromExtractedDataModel(assignmentId: string, extractedDataModelIndex: number, returnUrl: string | null | undefined, extractedDataModels: string | null | undefined, id: string | undefined, value: string | null | undefined, includeSource: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Groopit/GetFromExtractedDataModel/{assignmentId}/{extractedDataModelIndex}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (extractedDataModelIndex === undefined || extractedDataModelIndex === null)
            throw new Error("The parameter 'extractedDataModelIndex' must be defined.");
        url_ = url_.replace("{extractedDataModelIndex}", encodeURIComponent("" + extractedDataModelIndex));
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (extractedDataModels !== null && extractedDataModels !== undefined)
            content_.append("extractedDataModels", extractedDataModels.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (value !== null && value !== undefined)
            content_.append("Value", value.toString());
        if (includeSource === null || includeSource === undefined)
            throw new Error("The parameter 'includeSource' cannot be null.");
        else
            content_.append("IncludeSource", includeSource.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFromExtractedDataModel(_response);
        });
    }

    protected processGetFromExtractedDataModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getFromSuggestedAssignment(suggestedAssignmentId: number, returnUrl: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Groopit/GetFromSuggestedAssignment/{suggestedAssignmentId}?";
        if (suggestedAssignmentId === undefined || suggestedAssignmentId === null)
            throw new Error("The parameter 'suggestedAssignmentId' must be defined.");
        url_ = url_.replace("{suggestedAssignmentId}", encodeURIComponent("" + suggestedAssignmentId));
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFromSuggestedAssignment(_response);
        });
    }

    protected processGetFromSuggestedAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Attempts to convert the file at uri to the data model that has the
    id assignmentId.
     * @param assignmentId The data model to attempt to fit the file contents from the file at
                uri into.
     * @param returnUrl (optional) 
     * @param uri (optional) 
     * @return A populated view of the data model using the provided raw data.
     */
    populateFromUri(assignmentId: string, returnUrl: string | null | undefined, uri: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Groopit/PopulateFromUri/{assignmentId}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uri !== null && uri !== undefined)
            content_.append("uri", uri.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPopulateFromUri(_response);
        });
    }

    protected processPopulateFromUri(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Shares all the extracted data models.
     * @param assignmentId The Id of the Assignment Entity to build the view from.
     * @param extractedDataModels (optional) Serialized JSON array of list of Assignments.
     */
    shareAll(assignmentId: string, extractedDataModels: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Groopit/ShareAll/{assignmentId}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (extractedDataModels !== undefined && extractedDataModels !== null)
            url_ += "extractedDataModels=" + encodeURIComponent("" + extractedDataModels) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processShareAll(_response);
        });
    }

    protected processShareAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setFollowUpFields(groopitId: string, components: ComponentDataEditorViewModel[] | null | undefined): Promise<FollowUpEditorResponseDTO> {
        let url_ = this.baseUrl + "/Groopit/{groopitId}/FollowUp?";
        if (groopitId === undefined || groopitId === null)
            throw new Error("The parameter 'groopitId' must be defined.");
        url_ = url_.replace("{groopitId}", encodeURIComponent("" + groopitId));
        if (components !== undefined && components !== null)
            components && components.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Components[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetFollowUpFields(_response);
        });
    }

    protected processSetFollowUpFields(response: Response): Promise<FollowUpEditorResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FollowUpEditorResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FollowUpEditorResponseDTO>(null as any);
    }
}

export class InsightsClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns an Insight via ID
     * @param edit (optional) 
     */
    getInsight(id: string, edit: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Insights/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (edit === null)
            throw new Error("The parameter 'edit' cannot be null.");
        else if (edit !== undefined)
            url_ += "edit=" + encodeURIComponent("" + edit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsight(_response);
        });
    }

    protected processGetInsight(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Returns an Insight via ID
     */
    getDataInsight(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Insights/Data/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataInsight(_response);
        });
    }

    protected processGetDataInsight(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TenantClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    scimSettings(id: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/tenant/ScimSettings?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processScimSettings(_response);
        });
    }

    protected processScimSettings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AssignmentsClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(key: string): Promise<Assignment> {
        let url_ = this.baseUrl + "/odata/Assignments({key})";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Assignment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Assignment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assignment>(null as any);
    }

    get2(key: string): Promise<Assignment> {
        let url_ = this.baseUrl + "/odata/Assignments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: Response): Promise<Assignment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Assignment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assignment>(null as any);
    }

    getAll(): Promise<Assignment[]> {
        let url_ = this.baseUrl + "/odata/Assignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Assignment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assignment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assignment[]>(null as any);
    }

    getAll2(): Promise<Assignment[]> {
        let url_ = this.baseUrl + "/odata/Assignments/$count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll2(_response);
        });
    }

    protected processGetAll2(response: Response): Promise<Assignment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assignment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assignment[]>(null as any);
    }

    getPosts(key: string, authorization: string | null | undefined, token: string | null | undefined): Promise<Post[]> {
        let url_ = this.baseUrl + "/Assignments/{key}/Posts?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPosts(_response);
        });
    }

    protected processGetPosts(response: Response): Promise<Post[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post[]>(null as any);
    }

    getPosts2(key: string, authorization: string | null | undefined, token: string | null | undefined): Promise<Post[]> {
        let url_ = this.baseUrl + "/odata/Assignments({key})/Posts?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPosts2(_response);
        });
    }

    protected processGetPosts2(response: Response): Promise<Post[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post[]>(null as any);
    }

    getPosts3(key: string, authorization: string | null | undefined, token: string | null | undefined): Promise<Post[]> {
        let url_ = this.baseUrl + "/odata/Assignments/{key}/Posts?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPosts3(_response);
        });
    }

    protected processGetPosts3(response: Response): Promise<Post[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post[]>(null as any);
    }

    getPosts4(key: string, authorization: string | null | undefined, token: string | null | undefined): Promise<Post[]> {
        let url_ = this.baseUrl + "/odata/Assignments({key})/Posts/$count?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPosts4(_response);
        });
    }

    protected processGetPosts4(response: Response): Promise<Post[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post[]>(null as any);
    }

    getPosts5(key: string, authorization: string | null | undefined, token: string | null | undefined): Promise<Post[]> {
        let url_ = this.baseUrl + "/odata/Assignments/{key}/Posts/$count?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPosts5(_response);
        });
    }

    protected processGetPosts5(response: Response): Promise<Post[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post[]>(null as any);
    }
}

export class AIApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    suggestDataModels(input: string): Promise<SuggestDataModelsResultDTO> {
        let url_ = this.baseUrl + "/api/ai/suggest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSuggestDataModels(_response);
        });
    }

    protected processSuggestDataModels(response: Response): Promise<SuggestDataModelsResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestDataModelsResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuggestDataModelsResultDTO>(null as any);
    }

    getPopulateDataModelResult(jobId: string): Promise<AiPopulateDataModelResultDTO> {
        let url_ = this.baseUrl + "/api/ai/populate/status/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPopulateDataModelResult(_response);
        });
    }

    protected processGetPopulateDataModelResult(response: Response): Promise<AiPopulateDataModelResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiPopulateDataModelResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiPopulateDataModelResultDTO>(null as any);
    }

    populateDataModel(assignmentId: string, input: AiPopulateDataModelDTO): Promise<AiPopulateDataModelResultDTO> {
        let url_ = this.baseUrl + "/api/ai/populate/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPopulateDataModel(_response);
        });
    }

    protected processPopulateDataModel(response: Response): Promise<AiPopulateDataModelResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiPopulateDataModelResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiPopulateDataModelResultDTO>(null as any);
    }

    populateAndShareDataModel(assignmentId: string, input: AiPopulateAndShareDataModelInputDTO): Promise<AiPopulateAndShareDataModelResultDTO> {
        let url_ = this.baseUrl + "/api/ai/populate-and-share/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPopulateAndShareDataModel(_response);
        });
    }

    protected processPopulateAndShareDataModel(response: Response): Promise<AiPopulateAndShareDataModelResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiPopulateAndShareDataModelResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiPopulateAndShareDataModelResultDTO>(null as any);
    }

    getPopulateAndShareDataModelResult(jobId: string): Promise<AiPopulateAndShareDataModelResultDTO> {
        let url_ = this.baseUrl + "/api/ai/populate-and-share/status/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPopulateAndShareDataModelResult(_response);
        });
    }

    protected processGetPopulateAndShareDataModelResult(response: Response): Promise<AiPopulateAndShareDataModelResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiPopulateAndShareDataModelResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiPopulateAndShareDataModelResultDTO>(null as any);
    }

    startChatWithYourData(startChatWithYourDataRequest: StartChatWithYourDataRequest): Promise<ChatWithYourDataResponse> {
        let url_ = this.baseUrl + "/api/ai/start-chat-with-your-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startChatWithYourDataRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartChatWithYourData(_response);
        });
    }

    protected processStartChatWithYourData(response: Response): Promise<ChatWithYourDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatWithYourDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ChatWithYourDataErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatWithYourDataResponse>(null as any);
    }

    continueChatWithYourData(chatWithYourDataEntry: ChatWithYourDataEntry): Promise<ChatWithYourDataResponse> {
        let url_ = this.baseUrl + "/api/ai/continue-chat-with-your-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chatWithYourDataEntry);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processContinueChatWithYourData(_response);
        });
    }

    protected processContinueChatWithYourData(response: Response): Promise<ChatWithYourDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatWithYourDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ChatWithYourDataErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatWithYourDataResponse>(null as any);
    }

    loadConversationLineEntries(conversationId: string): Promise<ChatWithYourDataLineEntry[]> {
        let url_ = this.baseUrl + "/api/ai/chat-with-your-data-conversation-line-entries/{conversationId}";
        if (conversationId === undefined || conversationId === null)
            throw new Error("The parameter 'conversationId' must be defined.");
        url_ = url_.replace("{conversationId}", encodeURIComponent("" + conversationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadConversationLineEntries(_response);
        });
    }

    protected processLoadConversationLineEntries(response: Response): Promise<ChatWithYourDataLineEntry[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatWithYourDataLineEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatWithYourDataLineEntry[]>(null as any);
    }

    clearChatWithYourDataConversation(groopId: string): Promise<ChatWithYourDataLineEntry[]> {
        let url_ = this.baseUrl + "/api/ai/clear-chat-with-your-data/{groopId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClearChatWithYourDataConversation(_response);
        });
    }

    protected processClearChatWithYourDataConversation(response: Response): Promise<ChatWithYourDataLineEntry[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatWithYourDataLineEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatWithYourDataLineEntry[]>(null as any);
    }

    getChatWithYourDataConversations(groopId: string): Promise<ChatWithYourDataConversation[]> {
        let url_ = this.baseUrl + "/api/ai/chat-with-your-data-conversations/{groopId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChatWithYourDataConversations(_response);
        });
    }

    protected processGetChatWithYourDataConversations(response: Response): Promise<ChatWithYourDataConversation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatWithYourDataConversation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatWithYourDataConversation[]>(null as any);
    }
}

export class AssignmentApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves an assignment by ID
     * @param assignmentId Id of the Assignment
     * @return Assigment
     */
    getAssignment(assignmentId: string): Promise<AssignmentDTO> {
        let url_ = this.baseUrl + "/api/assignments/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignment(_response);
        });
    }

    protected processGetAssignment(response: Response): Promise<AssignmentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDTO>(null as any);
    }

    deleteAssignmentModel(assignmentId: string): Promise<AssignmentDTO> {
        let url_ = this.baseUrl + "/api/assignments/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssignmentModel(_response);
        });
    }

    protected processDeleteAssignmentModel(response: Response): Promise<AssignmentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDTO>(null as any);
    }

    putAssignmentModel(id: string, assignmentModel: ModifyAssignmentDTO): Promise<AssignmentDTO> {
        let url_ = this.baseUrl + "/api/assignments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignmentModel);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutAssignmentModel(_response);
        });
    }

    protected processPutAssignmentModel(response: Response): Promise<AssignmentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDTO>(null as any);
    }

    createAssignmentModel(assignmentModel: ModifyAssignmentDTO): Promise<AssignmentDTO> {
        let url_ = this.baseUrl + "/api/assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignmentModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAssignmentModel(_response);
        });
    }

    protected processCreateAssignmentModel(response: Response): Promise<AssignmentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AssignmentDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDTO>(null as any);
    }

    /**
     * Query available Options for a given Component(MultipleChoiceExtended)
     * @param assignmentId ID of the assignment
     * @param componentId ID of the component
     * @param query (optional) 
     * @param groupToken (optional) 
     * @param limit (optional) 
     * @return List[String]
     */
    getComponentOptions(assignmentId: string, componentId: number, query: string | null | undefined, groupToken: string | null | undefined, limit: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/assignments/{assignmentId}/ComponentOptions/{componentId}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (groupToken !== undefined && groupToken !== null)
            url_ += "groupToken=" + encodeURIComponent("" + groupToken) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComponentOptions(_response);
        });
    }

    protected processGetComponentOptions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getInheritedData(assignmentId: string, componentId: number, primaryDataId: string | null | undefined): Promise<ComponentDataDTO[]> {
        let url_ = this.baseUrl + "/api/assignments/{assignmentId}/ExternalServiceInheritedData/{componentId}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        if (primaryDataId !== undefined && primaryDataId !== null)
            url_ += "primaryDataId=" + encodeURIComponent("" + primaryDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInheritedData(_response);
        });
    }

    protected processGetInheritedData(response: Response): Promise<ComponentDataDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentDataDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentDataDTO[]>(null as any);
    }

    getColumnMappings(assignmentId: string, uploadId: string | undefined): Promise<ColumnMappings> {
        let url_ = this.baseUrl + "/api/assignments/{assignmentId}/GetColumnMappings?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (uploadId === null)
            throw new Error("The parameter 'uploadId' cannot be null.");
        else if (uploadId !== undefined)
            url_ += "uploadId=" + encodeURIComponent("" + uploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetColumnMappings(_response);
        });
    }

    protected processGetColumnMappings(response: Response): Promise<ColumnMappings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ColumnMappings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ColumnMappings>(null as any);
    }

    bulkImport(assignmentId: string, uploadId: string | undefined, columnMappings: ColumnMapping[]): Promise<BulkImportResult> {
        let url_ = this.baseUrl + "/api/assignments/{assignmentId}/BulkImport?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (uploadId === null)
            throw new Error("The parameter 'uploadId' cannot be null.");
        else if (uploadId !== undefined)
            url_ += "uploadId=" + encodeURIComponent("" + uploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(columnMappings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkImport(_response);
        });
    }

    protected processBulkImport(response: Response): Promise<BulkImportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkImportResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkImportResult>(null as any);
    }
}

export class CopilotApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a list of all groups whose data is accessible via the API
     * @return [string]
     */
    getGroups(): Promise<Group[]> {
        let url_ = this.baseUrl + "/api/copilot/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: Response): Promise<Group[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Group.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group[]>(null as any);
    }

    /**
     * Returns the list of forms for the given group
     * @param groupName (optional) 
     * @return [string]
     */
    getDataModel(groupName: string | null | undefined): Promise<DataModel[]> {
        let url_ = this.baseUrl + "/api/copilot/datamodels?";
        if (groupName !== undefined && groupName !== null)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataModel(_response);
        });
    }

    protected processGetDataModel(response: Response): Promise<DataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataModel[]>(null as any);
    }

    /**
     * Returns the reports for the given form
     * @param groupName (optional) name of the group
     * @param dataModelName (optional) name of the data model
     * @param begin (optional) optional starting timestamp in UTC
     * @param end (optional) optional ending timestamp in UTC
     * @param query (optional) optional text query to search on
     * @param page (optional) the page number to start on
     * @param perPage (optional) the maximum number of results to return
     */
    getReports(groupName: string | null | undefined, dataModelName: string | null | undefined, begin: Date | null | undefined, end: Date | null | undefined, query: string | null | undefined, page: number | undefined, perPage: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/copilot/insights?";
        if (groupName !== undefined && groupName !== null)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        if (dataModelName !== undefined && dataModelName !== null)
            url_ += "dataModelName=" + encodeURIComponent("" + dataModelName) + "&";
        if (begin !== undefined && begin !== null)
            url_ += "begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReports(_response);
        });
    }

    protected processGetReports(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSchema(groupName: string | null | undefined, dataModelName: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/copilot/schema?";
        if (groupName !== undefined && groupName !== null)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        if (dataModelName !== undefined && dataModelName !== null)
            url_ += "dataModelName=" + encodeURIComponent("" + dataModelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSchema(_response);
        });
    }

    protected processGetSchema(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DataExportApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a list of all groups whose data is accessible via the API
     * @return [GroopDataExportDTO]
     */
    getGroups(): Promise<GroopDataExportDTO[]> {
        let url_ = this.baseUrl + "/api/data/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: Response): Promise<GroopDataExportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopDataExportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDataExportDTO[]>(null as any);
    }

    /**
     * Returns the list of forms for the given group
     * @param groupId the group
     * @return [AssignmentDataExportDTO]
     */
    getForms(groupId: string): Promise<AssignmentDataExportDTO[]> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/forms";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForms(_response);
        });
    }

    protected processGetForms(response: Response): Promise<AssignmentDataExportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentDataExportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDataExportDTO[]>(null as any);
    }

    /**
     * Returns the reports for the given form
     * @param groupId the group
     * @param formId the form
     * @param begin (optional) optional starting timestamp
     * @param end (optional) optional ending timestamp
     * @param query (optional) optional text query to search on
     * @param page (optional) the page number to start on
     * @param perPage (optional) the maximum number of results to return
     * @return [GroopItDataExportDTO]
     */
    getReports(groupId: string, formId: string, begin: Date | null | undefined, end: Date | null | undefined, query: string[] | null | undefined, page: number | undefined, perPage: number | undefined): Promise<GroopItDataExportDTO[]> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/forms/{formId}/reports?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (begin !== undefined && begin !== null)
            url_ += "begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (query !== undefined && query !== null)
            query && query.forEach(item => { url_ += "query=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReports(_response);
        });
    }

    protected processGetReports(response: Response): Promise<GroopItDataExportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopItDataExportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItDataExportDTO[]>(null as any);
    }

    /**
     * Returns the reports for the given group
     * @param groupId the group
     * @param begin (optional) optional starting timestamp
     * @param end (optional) optional ending timestamp
     * @param query (optional) optional text query to search on
     * @param page (optional) the page number to start on
     * @param perPage (optional) the maximum number of results to return
     * @return [GroopItDataExportDTO]
     */
    getReports2(groupId: string, begin: Date | null | undefined, end: Date | null | undefined, query: string[] | null | undefined, page: number | undefined, perPage: number | undefined): Promise<GroopItDataExportDTO[]> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/reports?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (begin !== undefined && begin !== null)
            url_ += "begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (query !== undefined && query !== null)
            query && query.forEach(item => { url_ += "query=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReports2(_response);
        });
    }

    protected processGetReports2(response: Response): Promise<GroopItDataExportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopItDataExportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItDataExportDTO[]>(null as any);
    }

    /**
     * Registers a webhook to be called whenever CREATE/UPDATE events happen for reports in the given form
     * @param groupId the group to watch
     * @param formId the form to watch
     * @param subscribe the URL to call back
     * @return GroopItWebhookModel
     */
    subscribeToReports(groupId: string, formId: string, subscribe: GroopItWebhookSubscribe): Promise<GroopItWebhookDTO> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/forms/{formId}/reports/subscribe";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscribe);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubscribeToReports(_response);
        });
    }

    protected processSubscribeToReports(response: Response): Promise<GroopItWebhookDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopItWebhookDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItWebhookDTO>(null as any);
    }

    /**
     * Registers a webhook to be called whenever CREATE/UPDATE events happen for reports in the given group
     * @param groupId the group to watch
     * @param subscribe the URL to call back
     * @return GroopItWebhookModel
     */
    subscribeToReports2(groupId: string, subscribe: GroopItWebhookSubscribe): Promise<GroopItWebhookDTO> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/reports/subscribe";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscribe);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubscribeToReports2(_response);
        });
    }

    protected processSubscribeToReports2(response: Response): Promise<GroopItWebhookDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopItWebhookDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItWebhookDTO>(null as any);
    }

    unsubscribeFromReports(groupId: string, formId: string, webhookId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/forms/{formId}/reports/unsubscribe/{webhookId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (webhookId === undefined || webhookId === null)
            throw new Error("The parameter 'webhookId' must be defined.");
        url_ = url_.replace("{webhookId}", encodeURIComponent("" + webhookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnsubscribeFromReports(_response);
        });
    }

    protected processUnsubscribeFromReports(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unsubscribeFromReports2(groupId: string, webhookId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/reports/unsubscribe/{webhookId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (webhookId === undefined || webhookId === null)
            throw new Error("The parameter 'webhookId' must be defined.");
        url_ = url_.replace("{webhookId}", encodeURIComponent("" + webhookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnsubscribeFromReports2(_response);
        });
    }

    protected processUnsubscribeFromReports2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns the membership for all linked groups
     * @param groupId the group
     * @param page (optional) the page number to start on
     * @param perPage (optional) the maximum number of results to return
     * @return [LinkedGroupMembershipDataExportDTO]
     */
    getLinkedMembers(groupId: string, page: number | undefined, perPage: number | undefined): Promise<LinkedGroupMembershipDataExportDTO[]> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/linked-members?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinkedMembers(_response);
        });
    }

    protected processGetLinkedMembers(response: Response): Promise<LinkedGroupMembershipDataExportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedGroupMembershipDataExportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkedGroupMembershipDataExportDTO[]>(null as any);
    }

    /**
     * Registers a webhook to be called whenever a member is added to a linked group
     * @param groupId the group to watch
     * @param subscribe the URL to call back
     * @return GroopItWebhookModel
     */
    subscribeToLinkedMembers(groupId: string, subscribe: GroopItWebhookSubscribe): Promise<GroopItWebhookDTO> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/linked-members/subscribe";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscribe);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubscribeToLinkedMembers(_response);
        });
    }

    protected processSubscribeToLinkedMembers(response: Response): Promise<GroopItWebhookDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopItWebhookDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItWebhookDTO>(null as any);
    }

    unsubscribeFromLinkedMembers(groupId: string, webhookId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/linked-members/unsubscribe/{webhookId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (webhookId === undefined || webhookId === null)
            throw new Error("The parameter 'webhookId' must be defined.");
        url_ = url_.replace("{webhookId}", encodeURIComponent("" + webhookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnsubscribeFromLinkedMembers(_response);
        });
    }

    protected processUnsubscribeFromLinkedMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addListOption(groupId: string, formId: string, fieldId: number, option: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/forms/{formId}/fields/{fieldId}?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (fieldId === undefined || fieldId === null)
            throw new Error("The parameter 'fieldId' must be defined.");
        url_ = url_.replace("{fieldId}", encodeURIComponent("" + fieldId));
        if (option !== undefined && option !== null)
            url_ += "option=" + encodeURIComponent("" + option) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddListOption(_response);
        });
    }

    protected processAddListOption(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSchema(groupId: string, formId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/data/groups/{groupId}/forms/{formId}/schema/read";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSchema(_response);
        });
    }

    protected processGetSchema(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class GroopApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a list of the user's groops
     * @return A list of Groop objects
     */
    getAllGroops(): Promise<UserGroopsDTO> {
        let url_ = this.baseUrl + "/api/groops/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGroops(_response);
        });
    }

    protected processGetAllGroops(response: Response): Promise<UserGroopsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroopsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroopsDTO>(null as any);
    }

    getGroops(groupToken: string[] | null | undefined): Promise<GroopDTO[]> {
        let url_ = this.baseUrl + "/api/groops?";
        if (groupToken !== undefined && groupToken !== null)
            groupToken && groupToken.forEach(item => { url_ += "groupToken=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroops(_response);
        });
    }

    protected processGetGroops(response: Response): Promise<GroopDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDTO[]>(null as any);
    }

    /**
     * Create a new Groop with the current user as the owner. This is
    used by the create group wizard after collecting all the basic
    group and subscription information.
     * @param model The new Groop to be created
     * @return The newly created group
     */
    postGroop(model: GroopCreateDTO): Promise<GroopDTO> {
        let url_ = this.baseUrl + "/api/groops";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostGroop(_response);
        });
    }

    protected processPostGroop(response: Response): Promise<GroopDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GroopDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDTO>(null as any);
    }

    removeParticipant(groopId: string | undefined, userId: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/groops?";
        if (groopId === null)
            throw new Error("The parameter 'groopId' cannot be null.");
        else if (groopId !== undefined)
            url_ += "groopId=" + encodeURIComponent("" + groopId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveParticipant(_response);
        });
    }

    protected processRemoveParticipant(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Retrieve the basic information of a specific groop by ID. Intended
    for use in the Groop context and supplies the bare minimum needed
    to display the Groop in the context of the current user.
     * @param id Id of the Groop
     * @return GroopContextDTO
     */
    basicInfo(id: string): Promise<GroopContextDTO> {
        let url_ = this.baseUrl + "/api/groops/{id}/BasicInfo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBasicInfo(_response);
        });
    }

    protected processBasicInfo(response: Response): Promise<GroopContextDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopContextDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopContextDTO>(null as any);
    }

    /**
     * Retrieve the details of a specific groop by ID
     * @param id Id of the Groop
     */
    getGroop(id: string): Promise<GroopDTO> {
        let url_ = this.baseUrl + "/api/groops/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroop(_response);
        });
    }

    protected processGetGroop(response: Response): Promise<GroopDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDTO>(null as any);
    }

    /**
     * Update details of a specific groop
     * @param id Id of the Groop to be updated
     */
    putGroop(id: string, groopEditViewModel: GroopEditDTO): Promise<GroopDTO> {
        let url_ = this.baseUrl + "/api/groops/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groopEditViewModel);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutGroop(_response);
        });
    }

    protected processPutGroop(response: Response): Promise<GroopDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDTO>(null as any);
    }

    /**
     * Delete a Groop
     * @param id Id of the Groop
     */
    deleteGroop(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGroop(_response);
        });
    }

    protected processDeleteGroop(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve a groop's avatar
     */
    getAvatar(id: string): Promise<GroopAvatar> {
        let url_ = this.baseUrl + "/api/groops/{id}/Avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvatar(_response);
        });
    }

    protected processGetAvatar(response: Response): Promise<GroopAvatar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopAvatar.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopAvatar>(null as any);
    }

    /**
     * Set the specified groop's avatar
     */
    setAvatar(id: string): Promise<GroopAvatar> {
        let url_ = this.baseUrl + "/api/groops/{id}/Avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAvatar(_response);
        });
    }

    protected processSetAvatar(response: Response): Promise<GroopAvatar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopAvatar.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopAvatar>(null as any);
    }

    /**
     * Delete the specified groop's avatar and return to the default avatar
     */
    deleteAvatar(id: string): Promise<GroopAvatar> {
        let url_ = this.baseUrl + "/api/groops/{id}/Avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAvatar(_response);
        });
    }

    protected processDeleteAvatar(response: Response): Promise<GroopAvatar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopAvatar.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopAvatar>(null as any);
    }

    /**
     * Retrieve a minimal set of data (i.e. id, timestamp) of Groopits
    that match the filter. This is helpful for visualizations (i.e. River)
    that want to fetch the full list of data quickly but are fine with making
    subsequent calls to fetch the full details.
     * @param groopId Id of the Groop
     */
    getGroopitData(groopId: string, filter: GroopitFilterDTO): Promise<GroopitDataDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/GetGroopitData";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroopitData(_response);
        });
    }

    protected processGetGroopitData(response: Response): Promise<GroopitDataDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopitDataDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopitDataDTO[]>(null as any);
    }

    /**
     * Retrieve the list of GroopIts in the specified Groop that match the supplied filters
     * @param groopId Id of the Groop
     * @param token (optional) 
     * @param offset (optional) 
     * @param count (optional) 
     */
    groopits(groopId: string, token: string | null | undefined, offset: number | undefined, count: number | undefined, filter: GroopitFilterDTO): Promise<GroopitPagedResults> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Groopits?";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGroopits(_response);
        });
    }

    protected processGroopits(response: Response): Promise<GroopitPagedResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopitPagedResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopitPagedResults>(null as any);
    }

    /**
     * Retrieve the list of GroopIts in the specified Groop that match the supplied filters
     * @param groopId Id of the Groop
     * @param filters (optional) The Assignment Ids to filter by.
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param query (optional) 
     * @param tag (optional) 
     * @param tagOperation (optional) 
     * @param choices (optional) 
     * @param choicesOperation (optional) 
     * @param creator (optional) 
     * @param feedFilterDataTypes (optional) 
     * @param count (optional) 
     */
    startGroopitPaging(groopId: string, filters: string[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, query: string[] | null | undefined, tag: string | null | undefined, tagOperation: CollectionOperationType | null | undefined, choices: string[] | null | undefined, choicesOperation: CollectionOperationType | null | undefined, creator: string[] | null | undefined, feedFilterDataTypes: FeedFilterDataTypes[] | null | undefined, count: number | undefined): Promise<GroopitPagedResults> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/StartGroopitPaging?";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (filters !== undefined && filters !== null)
            filters && filters.forEach(item => { url_ += "filters=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (query !== undefined && query !== null)
            query && query.forEach(item => { url_ += "query=" + encodeURIComponent("" + item) + "&"; });
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        if (tagOperation !== undefined && tagOperation !== null)
            url_ += "tagOperation=" + encodeURIComponent("" + tagOperation) + "&";
        if (choices !== undefined && choices !== null)
            choices && choices.forEach(item => { url_ += "choices=" + encodeURIComponent("" + item) + "&"; });
        if (choicesOperation !== undefined && choicesOperation !== null)
            url_ += "choicesOperation=" + encodeURIComponent("" + choicesOperation) + "&";
        if (creator !== undefined && creator !== null)
            creator && creator.forEach(item => { url_ += "creator=" + encodeURIComponent("" + item) + "&"; });
        if (feedFilterDataTypes !== undefined && feedFilterDataTypes !== null)
            feedFilterDataTypes && feedFilterDataTypes.forEach(item => { url_ += "feedFilterDataTypes=" + encodeURIComponent("" + item) + "&"; });
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartGroopitPaging(_response);
        });
    }

    protected processStartGroopitPaging(response: Response): Promise<GroopitPagedResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopitPagedResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopitPagedResults>(null as any);
    }

    /**
     * Retrieve the list of all GroopIts in all Assignments in the specified Groop
     * @param groopId Id of the Groop
     * @param token (optional) 
     * @param filters (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param query (optional) 
     * @param tag (optional) 
     * @param tagOperation (optional) 
     * @param choices (optional) 
     * @param choicesOperation (optional) 
     * @param creator (optional) 
     * @param feedFilterDataTypes (optional) 
     * @param offset (optional) 
     * @param count (optional) 
     */
    getGroopitPage(groopId: string, token: string | null | undefined, filters: string[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, query: string[] | null | undefined, tag: string | null | undefined, tagOperation: CollectionOperationType | null | undefined, choices: string[] | null | undefined, choicesOperation: CollectionOperationType | null | undefined, creator: string[] | null | undefined, feedFilterDataTypes: FeedFilterDataTypes[] | null | undefined, offset: number | undefined, count: number | undefined): Promise<GroopItModel_V1[]> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/GetGroopitPage?";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach(item => { url_ += "filters=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (query !== undefined && query !== null)
            query && query.forEach(item => { url_ += "query=" + encodeURIComponent("" + item) + "&"; });
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        if (tagOperation !== undefined && tagOperation !== null)
            url_ += "tagOperation=" + encodeURIComponent("" + tagOperation) + "&";
        if (choices !== undefined && choices !== null)
            choices && choices.forEach(item => { url_ += "choices=" + encodeURIComponent("" + item) + "&"; });
        if (choicesOperation !== undefined && choicesOperation !== null)
            url_ += "choicesOperation=" + encodeURIComponent("" + choicesOperation) + "&";
        if (creator !== undefined && creator !== null)
            creator && creator.forEach(item => { url_ += "creator=" + encodeURIComponent("" + item) + "&"; });
        if (feedFilterDataTypes !== undefined && feedFilterDataTypes !== null)
            feedFilterDataTypes && feedFilterDataTypes.forEach(item => { url_ += "feedFilterDataTypes=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroopitPage(_response);
        });
    }

    protected processGetGroopitPage(response: Response): Promise<GroopItModel_V1[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopItModel_V1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItModel_V1[]>(null as any);
    }

    /**
     * Retrieve the per-day count of Groopits in in the specified Groop
    that match the supplied filters.
     * @param groopId Id of the Groop
     * @param timeZone (optional) 
     */
    getGroopitCounts(groopId: string, timeZone: string | null | undefined, filter: GroopitFilterDTO): Promise<GroopitCountDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/GetGroopitCounts?";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroopitCounts(_response);
        });
    }

    protected processGetGroopitCounts(response: Response): Promise<GroopitCountDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopitCountDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopitCountDTO[]>(null as any);
    }

    /**
     * Retrieve the list of Users (both Owners and Members) of the specified Groop
     * @param groopId Id of the Groop
     */
    getUsers(groopId: string): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Users";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    /**
     * Retrieve the list of Ownerss of the specified Groop
     * @param groopId Id of the Groop
     */
    getOwners(groopId: string): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Owners";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOwners(_response);
        });
    }

    protected processGetOwners(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    /**
     * Retrieve the list of Members of the specified Groop
     * @param groopId Id of the Groop
     */
    getMembers(groopId: string): Promise<UserWithEmailDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Members";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMembers(_response);
        });
    }

    protected processGetMembers(response: Response): Promise<UserWithEmailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithEmailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithEmailDTO[]>(null as any);
    }

    /**
     * Invite another user to be a Member of the specified Groop
     * @param groopId Id of the Groop
     * @param email (optional) 
     */
    addMember(groopId: string, email: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Members?";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMember(_response);
        });
    }

    protected processAddMember(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getParticipants(groopId: string): Promise<GroupUsersDTO> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Participants";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetParticipants(_response);
        });
    }

    protected processGetParticipants(response: Response): Promise<GroupUsersDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupUsersDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupUsersDTO>(null as any);
    }

    /**
     * Get all membership-related data: Owners, Members, Requests, and Invitations
     * @param groopId Id of the Groop
     * @return List of Owners, Members (including Owners), Requests (admin only), and Invitations (admin only)
     */
    getPeople(groopId: string): Promise<MembershipInfo> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/People";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPeople(_response);
        });
    }

    protected processGetPeople(response: Response): Promise<MembershipInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembershipInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MembershipInfo>(null as any);
    }

    /**
     * Deletes an invitation from the specified Groop
     * @param groopId Groop ID
     * @param inviteId Invite ID
     */
    deleteInvite(groopId: string, inviteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Invites/{inviteId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (inviteId === undefined || inviteId === null)
            throw new Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{inviteId}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInvite(_response);
        });
    }

    protected processDeleteInvite(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes an invite request from the specified Groop
     * @param groopId Groop ID
     * @param requestId Request ID
     */
    deleteInviteRequest(groopId: string, requestId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/InviteRequests/{requestId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInviteRequest(_response);
        });
    }

    protected processDeleteInviteRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Accepts a request to join a Groop
     */
    acceptRequest(groopId: string, requestId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Requests/Accept/{requestId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptRequest(_response);
        });
    }

    protected processAcceptRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Ignores a request to join a Groop
     */
    ignoreRequest(groopId: string, requestId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Requests/Ignore/{requestId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIgnoreRequest(_response);
        });
    }

    protected processIgnoreRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Resends an invitation that hasn't been accepted yet
     */
    resendInvite(groopId: string, inviteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Invites/Resend/{inviteId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (inviteId === undefined || inviteId === null)
            throw new Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{inviteId}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendInvite(_response);
        });
    }

    protected processResendInvite(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Invite another user to be a Member of the specified Groop
     * @param groopId Id of the Groop
     */
    addMember2(groopId: string, model: InviteModel): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Members2";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMember2(_response);
        });
    }

    protected processAddMember2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove a member from the specified Groop
     * @param groopId Id of the Groop
     */
    deleteMember(groopId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Members/{userId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMember(_response);
        });
    }

    protected processDeleteMember(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Make a member of the groop into an owner
     * @param groopId Id of the Groop
     * @param userId The email address the invitation will be sent to.
     */
    addOwner(groopId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Owners/{userId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddOwner(_response);
        });
    }

    protected processAddOwner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove an owner from the specified Groop
     * @param groopId Id of the Groop
     * @param userId Id of the Owner
     */
    deleteOwner(groopId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Owners/{userId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteOwner(_response);
        });
    }

    protected processDeleteOwner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getViews(groopId: string): Promise<VizDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groopId}/Views";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetViews(_response);
        });
    }

    protected processGetViews(response: Response): Promise<VizDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VizDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VizDTO[]>(null as any);
    }

    /**
     * Set the specified groop's cover photo
     */
    setCoverPhoto(id: string): Promise<GroopCoverPhoto> {
        let url_ = this.baseUrl + "/api/groops/{id}/CoverPhoto";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCoverPhoto(_response);
        });
    }

    protected processSetCoverPhoto(response: Response): Promise<GroopCoverPhoto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopCoverPhoto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopCoverPhoto>(null as any);
    }

    getAccessTokens(id: string): Promise<GroupAccessTokenDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{id}/AccessToken";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessTokens(_response);
        });
    }

    protected processGetAccessTokens(response: Response): Promise<GroupAccessTokenDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupAccessTokenDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupAccessTokenDTO[]>(null as any);
    }

    createAccessToken(id: string, label: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/groops/{id}/AccessToken?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (label !== undefined && label !== null)
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAccessToken(_response);
        });
    }

    protected processCreateAccessToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateAccessTokenIntegration(groupAccessTokenId: number, integration: string | null): Promise<boolean> {
        let url_ = this.baseUrl + "/AccessToken/{groupAccessTokenId}/Integration/{integration}";
        if (groupAccessTokenId === undefined || groupAccessTokenId === null)
            throw new Error("The parameter 'groupAccessTokenId' must be defined.");
        url_ = url_.replace("{groupAccessTokenId}", encodeURIComponent("" + groupAccessTokenId));
        if (integration === undefined || integration === null)
            throw new Error("The parameter 'integration' must be defined.");
        url_ = url_.replace("{integration}", encodeURIComponent("" + integration));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAccessTokenIntegration(_response);
        });
    }

    protected processUpdateAccessTokenIntegration(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    disableToken(groupAccessTokenId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/AccessToken/{groupAccessTokenId}/Disable";
        if (groupAccessTokenId === undefined || groupAccessTokenId === null)
            throw new Error("The parameter 'groupAccessTokenId' must be defined.");
        url_ = url_.replace("{groupAccessTokenId}", encodeURIComponent("" + groupAccessTokenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisableToken(_response);
        });
    }

    protected processDisableToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    enableToken(groupAccessTokenId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/AccessToken/{groupAccessTokenId}/Enable";
        if (groupAccessTokenId === undefined || groupAccessTokenId === null)
            throw new Error("The parameter 'groupAccessTokenId' must be defined.");
        url_ = url_.replace("{groupAccessTokenId}", encodeURIComponent("" + groupAccessTokenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEnableToken(_response);
        });
    }

    protected processEnableToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteToken(groupAccessTokenId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/AccessToken/{groupAccessTokenId}";
        if (groupAccessTokenId === undefined || groupAccessTokenId === null)
            throw new Error("The parameter 'groupAccessTokenId' must be defined.");
        url_ = url_.replace("{groupAccessTokenId}", encodeURIComponent("" + groupAccessTokenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteToken(_response);
        });
    }

    protected processDeleteToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getKeywordPrompts(groupId: string): Promise<KeywordPromptsDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/keyword-prompts";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKeywordPrompts(_response);
        });
    }

    protected processGetKeywordPrompts(response: Response): Promise<KeywordPromptsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeywordPromptsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeywordPromptsDTO[]>(null as any);
    }

    createKeywordPrompts(groupId: string, model: CreateKeywordPromptsDTO): Promise<KeywordPromptsDTO> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/keyword-prompts";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateKeywordPrompts(_response);
        });
    }

    protected processCreateKeywordPrompts(response: Response): Promise<KeywordPromptsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeywordPromptsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeywordPromptsDTO>(null as any);
    }

    updateKeywordPrompts(groupId: string, id: number, model: CreateKeywordPromptsDTO): Promise<KeywordPromptsDTO> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/keyword-prompts/{id}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateKeywordPrompts(_response);
        });
    }

    protected processUpdateKeywordPrompts(response: Response): Promise<KeywordPromptsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeywordPromptsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeywordPromptsDTO>(null as any);
    }

    deleteKeywordPrompts(groupId: string, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/keyword-prompts/{id}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteKeywordPrompts(_response);
        });
    }

    protected processDeleteKeywordPrompts(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    connectToSalesforce(groupId: string, model: SFConnectionDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/salesforce-connection";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConnectToSalesforce(_response);
        });
    }

    protected processConnectToSalesforce(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    disconnectFromSalesforce(groupId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/salesforce-connection";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisconnectFromSalesforce(_response);
        });
    }

    protected processDisconnectFromSalesforce(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Query available inherited data fields
     * @param objectName (optional) 
     * @return List[String]
     */
    getSalesforceFields(groupId: string, objectName: string | null | undefined): Promise<SalesforceFieldDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/salesforce-fields?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (objectName !== undefined && objectName !== null)
            url_ += "objectName=" + encodeURIComponent("" + objectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalesforceFields(_response);
        });
    }

    protected processGetSalesforceFields(response: Response): Promise<SalesforceFieldDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesforceFieldDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesforceFieldDTO[]>(null as any);
    }

    getGroopitFilters(groupId: string): Promise<NamedGroopitFilterDisplayDTO[]> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/groopit-filters";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroopitFilters(_response);
        });
    }

    protected processGetGroopitFilters(response: Response): Promise<NamedGroopitFilterDisplayDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedGroopitFilterDisplayDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NamedGroopitFilterDisplayDTO[]>(null as any);
    }

    createGroopitFilter(groupId: string, filter: NamedGroopitFilterUpdateDTO): Promise<NamedGroopitFilterDisplayDTO> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/groopit-filters";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroopitFilter(_response);
        });
    }

    protected processCreateGroopitFilter(response: Response): Promise<NamedGroopitFilterDisplayDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = NamedGroopitFilterDisplayDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NamedGroopitFilterDisplayDTO>(null as any);
    }

    getGroopitFilter(groupId: string, id: number): Promise<NamedGroopitFilterDisplayDTO> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/groopit-filters/{id}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroopitFilter(_response);
        });
    }

    protected processGetGroopitFilter(response: Response): Promise<NamedGroopitFilterDisplayDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NamedGroopitFilterDisplayDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NamedGroopitFilterDisplayDTO>(null as any);
    }

    updateGroopitFilter(groupId: string, id: number, filter: NamedGroopitFilterUpdateDTO): Promise<NamedGroopitFilterDisplayDTO> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/groopit-filters/{id}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGroopitFilter(_response);
        });
    }

    protected processUpdateGroopitFilter(response: Response): Promise<NamedGroopitFilterDisplayDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NamedGroopitFilterDisplayDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NamedGroopitFilterDisplayDTO>(null as any);
    }

    deleteGroopitFilter(groupId: string, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/groopit-filters/{id}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGroopitFilter(_response);
        });
    }

    protected processDeleteGroopitFilter(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    checkPermission(groupId: string, permission: AccessRight | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/checkpermission?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckPermission(_response);
        });
    }

    protected processCheckPermission(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Query all available MultipleChoiceExtendedOptions for a given group
     * @param groupId ID of the group
     * @param query (optional) 
     * @param limit (optional) 
     * @return List[String]
     */
    getComponentOptions(groupId: string, query: string | null | undefined, limit: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/ComponentOptions?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComponentOptions(_response);
        });
    }

    protected processGetComponentOptions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Query all available MultipleChoiceExtendedOptions for a given group
     * @param groupId ID of the group
     * @return List[String]
     */
    areComponentOptionsValid(groupId: string, options: string[]): Promise<boolean[]> {
        let url_ = this.baseUrl + "/api/groops/{groupId}/ComponentOptions/checkvalidity";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAreComponentOptionsValid(_response);
        });
    }

    protected processAreComponentOptionsValid(response: Response): Promise<boolean[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean[]>(null as any);
    }
}

export class GroopItApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a GroopIt via it's id
     * @param groopItId Id of the GroopIt
     */
    getGroopIt(groopItId: string): Promise<GroopItModel_V1> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroopIt(_response);
        });
    }

    protected processGetGroopIt(response: Response): Promise<GroopItModel_V1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopItModel_V1.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItModel_V1>(null as any);
    }

    /**
     * Update an existing groopit with new component data
     */
    updateGroopItLegacy(groopItId: string, components: ComponentDataDTO[]): Promise<GroopItModel_V1> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(components);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGroopItLegacy(_response);
        });
    }

    protected processUpdateGroopItLegacy(response: Response): Promise<GroopItModel_V1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GroopItModel_V1.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItModel_V1>(null as any);
    }

    /**
     * Delete a GroopIt from the given assignment
     * @param groopItId Id of the GroopIt
     */
    deleteGroopIt(groopItId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGroopIt(_response);
        });
    }

    protected processDeleteGroopIt(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createGroopIt(groopId: string | undefined, assignmentId: string | undefined, groupToken: string | null | undefined, newGroopIt: CreateGroopitDTO): Promise<GroopItModel_V1> {
        let url_ = this.baseUrl + "/api/groopits/create?";
        if (groopId === null)
            throw new Error("The parameter 'groopId' cannot be null.");
        else if (groopId !== undefined)
            url_ += "groopId=" + encodeURIComponent("" + groopId) + "&";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        if (groupToken !== undefined && groupToken !== null)
            url_ += "groupToken=" + encodeURIComponent("" + groupToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newGroopIt);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroopIt(_response);
        });
    }

    protected processCreateGroopIt(response: Response): Promise<GroopItModel_V1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GroopItModel_V1.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItModel_V1>(null as any);
    }

    createGroopItAsDataExport(groopId: string | undefined, assignmentId: string | undefined, groupToken: string | null | undefined, newGroopIt: CreateGroopitDTO): Promise<GroopItDataExportDTO> {
        let url_ = this.baseUrl + "/api/groopits/createasdataexport?";
        if (groopId === null)
            throw new Error("The parameter 'groopId' cannot be null.");
        else if (groopId !== undefined)
            url_ += "groopId=" + encodeURIComponent("" + groopId) + "&";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        if (groupToken !== undefined && groupToken !== null)
            url_ += "groupToken=" + encodeURIComponent("" + groupToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newGroopIt);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroopItAsDataExport(_response);
        });
    }

    protected processCreateGroopItAsDataExport(response: Response): Promise<GroopItDataExportDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GroopItDataExportDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItDataExportDTO>(null as any);
    }

    createPendingUpload(isFile: boolean | undefined): Promise<PendingUploadDTO> {
        let url_ = this.baseUrl + "/api/groopits/uploads?";
        if (isFile === null)
            throw new Error("The parameter 'isFile' cannot be null.");
        else if (isFile !== undefined)
            url_ += "IsFile=" + encodeURIComponent("" + isFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePendingUpload(_response);
        });
    }

    protected processCreatePendingUpload(response: Response): Promise<PendingUploadDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PendingUploadDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PendingUploadDTO>(null as any);
    }

    createAiPendingUpload(contentDisposition: string | null | undefined): Promise<PendingUploadDTO> {
        let url_ = this.baseUrl + "/api/groopits/uploads/CreateAiPendingUpload?";
        if (contentDisposition !== undefined && contentDisposition !== null)
            url_ += "contentDisposition=" + encodeURIComponent("" + contentDisposition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAiPendingUpload(_response);
        });
    }

    protected processCreateAiPendingUpload(response: Response): Promise<PendingUploadDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PendingUploadDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PendingUploadDTO>(null as any);
    }

    /**
     * Update an existing groopit with new component data
     */
    updateGroopIt(groopItId: string, groopit: CreateGroopitDTO): Promise<GroopItModel_V1> {
        let url_ = this.baseUrl + "/api/groopits/v2/{groopItId}";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groopit);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGroopIt(_response);
        });
    }

    protected processUpdateGroopIt(response: Response): Promise<GroopItModel_V1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GroopItModel_V1.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItModel_V1>(null as any);
    }

    flagGroopIt(groopItId: string, flag: GroopItFlag): Promise<void> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/Flag";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(flag);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFlagGroopIt(_response);
        });
    }

    protected processFlagGroopIt(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    likeGroopIt(groopItId: string, like: GroopItLike): Promise<void> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/Like";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(like);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLikeGroopIt(_response);
        });
    }

    protected processLikeGroopIt(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the list of Users who like a particular GroopIt
     * @param groopItId Id of the GroopIt
     * @return Like of Users
     */
    getLikes(groopItId: string): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/Likes";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLikes(_response);
        });
    }

    protected processGetLikes(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    /**
     * Pins the given GroopIt
     */
    pin(groopItId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/Pin";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPin(_response);
        });
    }

    protected processPin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Unpins the given GroopIt
     */
    unPin(groopItId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/UnPin";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnPin(_response);
        });
    }

    protected processUnPin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves the comments for a given GroopIt
     * @param token (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     */
    getComments(groopItId: string, token: string | null | undefined, offset: number | undefined, limit: number | undefined): Promise<CommentMeta> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/Comments?";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComments(_response);
        });
    }

    protected processGetComments(response: Response): Promise<CommentMeta> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentMeta.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommentMeta>(null as any);
    }

    commentCreate(groopItId: string, comment: CommentDTO): Promise<CommentDTO> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/Comments";
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCommentCreate(_response);
        });
    }

    protected processCommentCreate(response: Response): Promise<CommentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommentDTO>(null as any);
    }

    commentEdit(commentId: string, groopItId: string, comment: CommentDTO): Promise<CommentDTO> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/Comments/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCommentEdit(_response);
        });
    }

    protected processCommentEdit(response: Response): Promise<CommentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommentDTO>(null as any);
    }

    commentDelete(commentId: string, groopItId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groopits/{groopItId}/Comments/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (groopItId === undefined || groopItId === null)
            throw new Error("The parameter 'groopItId' must be defined.");
        url_ = url_.replace("{groopItId}", encodeURIComponent("" + groopItId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCommentDelete(_response);
        });
    }

    protected processCommentDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getExternalServiceRelatedObject(serviceId: string | null | undefined, fieldName: string | null | undefined): Promise<SFTargetDTO> {
        let url_ = this.baseUrl + "/api/groopits/ExternalServiceRelatedObject?";
        if (serviceId !== undefined && serviceId !== null)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "fieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalServiceRelatedObject(_response);
        });
    }

    protected processGetExternalServiceRelatedObject(response: Response): Promise<SFTargetDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SFTargetDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SFTargetDTO>(null as any);
    }

    getExternalServiceRelatedObjects(serviceId: string | null | undefined): Promise<SFTargetDTO[]> {
        let url_ = this.baseUrl + "/api/groopits/ExternalServiceRelatedObjects?";
        if (serviceId !== undefined && serviceId !== null)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalServiceRelatedObjects(_response);
        });
    }

    protected processGetExternalServiceRelatedObjects(response: Response): Promise<SFTargetDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SFTargetDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SFTargetDTO[]>(null as any);
    }

    getExternalServiceRelatedRecords(organizationId: string | null | undefined, objectName: string | null | undefined, term: string | null | undefined, limit: number | undefined): Promise<SelectListDTO[]> {
        let url_ = this.baseUrl + "/api/groopits/ExternalServiceRelatedRecords?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (objectName !== undefined && objectName !== null)
            url_ += "objectName=" + encodeURIComponent("" + objectName) + "&";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalServiceRelatedRecords(_response);
        });
    }

    protected processGetExternalServiceRelatedRecords(response: Response): Promise<SelectListDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectListDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectListDTO[]>(null as any);
    }

    getExternalServiceRelatedRecordsV2(assignmentId: string | undefined, componentId: number | undefined, term: string | null | undefined, limit: number | undefined): Promise<SelectListDTO[]> {
        let url_ = this.baseUrl + "/api/groopits/ExternalServiceRelatedRecords/v2?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "componentId=" + encodeURIComponent("" + componentId) + "&";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalServiceRelatedRecordsV2(_response);
        });
    }

    protected processGetExternalServiceRelatedRecordsV2(response: Response): Promise<SelectListDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectListDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectListDTO[]>(null as any);
    }

    setFlagField(groopitId: string, fieldId: number, value: string[]): Promise<GroopItModel_V1> {
        let url_ = this.baseUrl + "/api/groopits/{groopitId}/FlagField/{fieldId}";
        if (groopitId === undefined || groopitId === null)
            throw new Error("The parameter 'groopitId' must be defined.");
        url_ = url_.replace("{groopitId}", encodeURIComponent("" + groopitId));
        if (fieldId === undefined || fieldId === null)
            throw new Error("The parameter 'fieldId' must be defined.");
        url_ = url_.replace("{fieldId}", encodeURIComponent("" + fieldId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetFlagField(_response);
        });
    }

    protected processSetFlagField(response: Response): Promise<GroopItModel_V1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopItModel_V1.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopItModel_V1>(null as any);
    }
}

export class InsightsApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getInsights(groopId: string): Promise<InsightsReportDTO[]> {
        let url_ = this.baseUrl + "/api/insights/groop/{groopId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsights(_response);
        });
    }

    protected processGetInsights(response: Response): Promise<InsightsReportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InsightsReportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsightsReportDTO[]>(null as any);
    }

    createInsightsReport(groopId: string, report: CreateInsightReportDTO): Promise<InsightsReportDTO> {
        let url_ = this.baseUrl + "/api/insights/groop/{groopId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(report);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateInsightsReport(_response);
        });
    }

    protected processCreateInsightsReport(response: Response): Promise<InsightsReportDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsightsReportDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsightsReportDTO>(null as any);
    }

    summarize(groopId: string, filters: GroopitFilterDTO): Promise<SummarizeResultDTO> {
        let url_ = this.baseUrl + "/api/insights/groop/{groopId}/summarize";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSummarize(_response);
        });
    }

    protected processSummarize(response: Response): Promise<SummarizeResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummarizeResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummarizeResultDTO>(null as any);
    }

    getSummarizeResult(jobId: string, groopId: string): Promise<SummarizeResultDTO> {
        let url_ = this.baseUrl + "/api/insights/groop/{groopId}/summarize/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSummarizeResult(_response);
        });
    }

    protected processGetSummarizeResult(response: Response): Promise<SummarizeResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummarizeResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummarizeResultDTO>(null as any);
    }

    identifyPatterns(groopId: string, filters: GroopitFilterDTO): Promise<PatternsResultDTO> {
        let url_ = this.baseUrl + "/api/insights/groop/{groopId}/patterns";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentifyPatterns(_response);
        });
    }

    protected processIdentifyPatterns(response: Response): Promise<PatternsResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatternsResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatternsResultDTO>(null as any);
    }

    getPatternsResult(jobId: string, groopId: string): Promise<PatternsResultDTO> {
        let url_ = this.baseUrl + "/api/insights/groop/{groopId}/patterns/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPatternsResult(_response);
        });
    }

    protected processGetPatternsResult(response: Response): Promise<PatternsResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatternsResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatternsResultDTO>(null as any);
    }

    getInsightsReport(reportId: string): Promise<InsightsReportDTO> {
        let url_ = this.baseUrl + "/api/insights/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsightsReport(_response);
        });
    }

    protected processGetInsightsReport(response: Response): Promise<InsightsReportDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsightsReportDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsightsReportDTO>(null as any);
    }

    updateInsightsReport(reportId: string, report: InsightsReportUpdateDTO): Promise<InsightsReportDTO> {
        let url_ = this.baseUrl + "/api/insights/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(report);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateInsightsReport(_response);
        });
    }

    protected processUpdateInsightsReport(response: Response): Promise<InsightsReportDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsightsReportDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsightsReportDTO>(null as any);
    }

    deleteInsightsReport(reportId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/insights/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInsightsReport(_response);
        });
    }

    protected processDeleteInsightsReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDataInsights(groopId: string): Promise<DataInsightDTO[]> {
        let url_ = this.baseUrl + "/api/insights/data/groop/{groopId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataInsights(_response);
        });
    }

    protected processGetDataInsights(response: Response): Promise<DataInsightDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataInsightDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataInsightDTO[]>(null as any);
    }

    createDataInsight(groopId: string, insightType: InsightType | undefined, insightPrompt: string | null | undefined, filters: GroopitFilterDTO): Promise<DataInsightsReportResultDTO> {
        let url_ = this.baseUrl + "/api/insights/data/groop/{groopId}?";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        if (insightType === null)
            throw new Error("The parameter 'insightType' cannot be null.");
        else if (insightType !== undefined)
            url_ += "insightType=" + encodeURIComponent("" + insightType) + "&";
        if (insightPrompt !== undefined && insightPrompt !== null)
            url_ += "insightPrompt=" + encodeURIComponent("" + insightPrompt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDataInsight(_response);
        });
    }

    protected processCreateDataInsight(response: Response): Promise<DataInsightsReportResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataInsightsReportResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataInsightsReportResultDTO>(null as any);
    }

    getDataInsightsReport(reportId: number): Promise<DataInsightDTO> {
        let url_ = this.baseUrl + "/api/insights/data/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataInsightsReport(_response);
        });
    }

    protected processGetDataInsightsReport(response: Response): Promise<DataInsightDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataInsightDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataInsightDTO>(null as any);
    }
}

export class OutlookApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getGroups(): Promise<GroopDisplayDTO[]> {
        let url_ = this.baseUrl + "/api/outlook/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: Response): Promise<GroopDisplayDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopDisplayDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDisplayDTO[]>(null as any);
    }

    configuration(): Promise<OutlookAddinConfiguration> {
        let url_ = this.baseUrl + "/api/outlook/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfiguration(_response);
        });
    }

    protected processConfiguration(response: Response): Promise<OutlookAddinConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutlookAddinConfiguration.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OutlookAddinConfiguration>(null as any);
    }

    link(exchangeIdentity: string): Promise<LegacyLinkResultDto> {
        let url_ = this.baseUrl + "/api/outlook/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exchangeIdentity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLink(_response);
        });
    }

    protected processLink(response: Response): Promise<LegacyLinkResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LegacyLinkResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegacyLinkResultDto>(null as any);
    }

    associate(): Promise<UserAssociationMismatchResult> {
        let url_ = this.baseUrl + "/api/outlook/Associate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssociate(_response);
        });
    }

    protected processAssociate(response: Response): Promise<UserAssociationMismatchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAssociationMismatchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAssociationMismatchResult>(null as any);
    }

    getKeywordPrompts(): Promise<KeywordPromptsDTO2[]> {
        let url_ = this.baseUrl + "/api/outlook/keyword-prompts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKeywordPrompts(_response);
        });
    }

    protected processGetKeywordPrompts(response: Response): Promise<KeywordPromptsDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeywordPromptsDTO2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeywordPromptsDTO2[]>(null as any);
    }

    userCanAccessKeywordPrompts(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/outlook/user-can-access-keyword-prompts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserCanAccessKeywordPrompts(_response);
        });
    }

    protected processUserCanAccessKeywordPrompts(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getKeywordPromptsFromAuthedUser(): Promise<KeywordPromptsDTO2[]> {
        let url_ = this.baseUrl + "/api/outlook/authed-keyword-prompts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKeywordPromptsFromAuthedUser(_response);
        });
    }

    protected processGetKeywordPromptsFromAuthedUser(response: Response): Promise<KeywordPromptsDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeywordPromptsDTO2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeywordPromptsDTO2[]>(null as any);
    }

    /**
     * Processes keywords matched in a users email by using the legacy Id Token.
     * @param matchingOutlookEmailPrompts The matching prompts to process.
     */
    processEmailKeywordMatches(matchingOutlookEmailPrompts: MatchingOutlookEmailPrompts): Promise<void> {
        let url_ = this.baseUrl + "/api/outlook/ProcessEmailKeywordMatches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchingOutlookEmailPrompts);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEmailKeywordMatches(_response);
        });
    }

    protected processProcessEmailKeywordMatches(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Processes keywords matched in a users email by using the non-legacy Id Token.
     * @param matchingOutlookEmailPrompts The matching prompts to process.
     */
    processNonLegacyEmailKeywordMatches(matchingOutlookEmailPrompts: MatchingOutlookEmailPrompts): Promise<void> {
        let url_ = this.baseUrl + "/api/outlook/ProcessNonLegacyEmailKeywordMatches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchingOutlookEmailPrompts);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessNonLegacyEmailKeywordMatches(_response);
        });
    }

    protected processProcessNonLegacyEmailKeywordMatches(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RegisterClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    post(handle: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/register?";
        if (handle !== undefined && handle !== null)
            url_ += "handle=" + encodeURIComponent("" + handle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    put(id: string, deviceUpdate: DeviceRegistration): Promise<void> {
        let url_ = this.baseUrl + "/api/register/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/register/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SlackApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUserVersion(id: string): Promise<SlackAppVersion> {
        let url_ = this.baseUrl + "/api/slack/connections/{id}/user-version";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserVersion(_response);
        });
    }

    protected processGetUserVersion(response: Response): Promise<SlackAppVersion> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackAppVersion>(null as any);
    }

    getGroupConnections(groupId: string): Promise<SlackConnectionDTO[]> {
        let url_ = this.baseUrl + "/api/slack/group/{groupId}/connections";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupConnections(_response);
        });
    }

    protected processGetGroupConnections(response: Response): Promise<SlackConnectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlackConnectionDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackConnectionDTO[]>(null as any);
    }

    getAssignmentConnections(assignmentId: string): Promise<SlackConnectionDTO[]> {
        let url_ = this.baseUrl + "/api/slack/assignment/{assignmentId}/connections";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentConnections(_response);
        });
    }

    protected processGetAssignmentConnections(response: Response): Promise<SlackConnectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlackConnectionDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackConnectionDTO[]>(null as any);
    }

    getUserChannels(id: string, cursor: string | null | undefined, term: string | null | undefined): Promise<SlackChannelResultsDTO> {
        let url_ = this.baseUrl + "/api/slack/user-channels/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserChannels(_response);
        });
    }

    protected processGetUserChannels(response: Response): Promise<SlackChannelResultsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlackChannelResultsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackChannelResultsDTO>(null as any);
    }

    getBotChannels(id: string): Promise<SlackChannelDTO[]> {
        let url_ = this.baseUrl + "/api/slack/bot-channels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBotChannels(_response);
        });
    }

    protected processGetBotChannels(response: Response): Promise<SlackChannelDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlackChannelDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackChannelDTO[]>(null as any);
    }

    getNotificationLinks(assignmentId: string): Promise<SlackNotificationLinkDTO[]> {
        let url_ = this.baseUrl + "/api/slack/notification-links/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotificationLinks(_response);
        });
    }

    protected processGetNotificationLinks(response: Response): Promise<SlackNotificationLinkDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlackNotificationLinkDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackNotificationLinkDTO[]>(null as any);
    }

    createNotificationLink(channelLink: CreateSlackNotificationLinkDTO): Promise<SlackNotificationLinkDTO> {
        let url_ = this.baseUrl + "/api/slack/notification-links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(channelLink);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNotificationLink(_response);
        });
    }

    protected processCreateNotificationLink(response: Response): Promise<SlackNotificationLinkDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlackNotificationLinkDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackNotificationLinkDTO>(null as any);
    }

    removeNotificationLink(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/slack/notification-links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveNotificationLink(_response);
        });
    }

    protected processRemoveNotificationLink(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBotMembership(id: string, connectionId: string | null | undefined): Promise<SlackChannelBotMembershipDTO> {
        let url_ = this.baseUrl + "/api/slack/channel-bot-membership/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (connectionId !== undefined && connectionId !== null)
            url_ += "connectionId=" + encodeURIComponent("" + connectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBotMembership(_response);
        });
    }

    protected processGetBotMembership(response: Response): Promise<SlackChannelBotMembershipDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlackChannelBotMembershipDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackChannelBotMembershipDTO>(null as any);
    }

    addBotToAllPublicChannels(teamId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/slack/channel-bot-membership/add-all-public/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddBotToAllPublicChannels(_response);
        });
    }

    protected processAddBotToAllPublicChannels(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getChannelLinks(groupId: string): Promise<SlackChannelLinkDTO[]> {
        let url_ = this.baseUrl + "/api/slack/channel-links/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChannelLinks(_response);
        });
    }

    protected processGetChannelLinks(response: Response): Promise<SlackChannelLinkDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlackChannelLinkDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackChannelLinkDTO[]>(null as any);
    }

    createChannelLink(channelLink: CreateSlackChannelLinkDTO): Promise<SlackChannelLinkDTO> {
        let url_ = this.baseUrl + "/api/slack/channel-links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(channelLink);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateChannelLink(_response);
        });
    }

    protected processCreateChannelLink(response: Response): Promise<SlackChannelLinkDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlackChannelLinkDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackChannelLinkDTO>(null as any);
    }

    removeChannelLink(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/slack/channel-links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveChannelLink(_response);
        });
    }

    protected processRemoveChannelLink(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TeamsApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUserVersion(id: string): Promise<TeamsUserVersion> {
        let url_ = this.baseUrl + "/api/teams/connections/{id}/user-version";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserVersion(_response);
        });
    }

    protected processGetUserVersion(response: Response): Promise<TeamsUserVersion> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsUserVersion>(null as any);
    }

    getLinkedGroups(tenantId: string | null | undefined, teamId: string | null | undefined, channelId: string | null | undefined): Promise<GroopDTO[]> {
        let url_ = this.baseUrl + "/api/teams?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (channelId !== undefined && channelId !== null)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinkedGroups(_response);
        });
    }

    protected processGetLinkedGroups(response: Response): Promise<GroopDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroopDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDTO[]>(null as any);
    }

    getGroupCategories(tenantId: string | null | undefined, teamId: string | null | undefined, channelId: string | null | undefined): Promise<GroupCategories> {
        let url_ = this.baseUrl + "/api/teams/getgroupcategories?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (channelId !== undefined && channelId !== null)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupCategories(_response);
        });
    }

    protected processGetGroupCategories(response: Response): Promise<GroupCategories> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupCategories.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupCategories>(null as any);
    }

    getGroupConnections(groupId: string): Promise<TeamsConnectionDTO[]> {
        let url_ = this.baseUrl + "/api/teams/group/{groupId}/connections";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupConnections(_response);
        });
    }

    protected processGetGroupConnections(response: Response): Promise<TeamsConnectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamsConnectionDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsConnectionDTO[]>(null as any);
    }

    getAssignmentConnections(assignmentId: string): Promise<TeamsConnectionDTO[]> {
        let url_ = this.baseUrl + "/api/teams/assignment/{assignmentId}/connections";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentConnections(_response);
        });
    }

    protected processGetAssignmentConnections(response: Response): Promise<TeamsConnectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamsConnectionDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsConnectionDTO[]>(null as any);
    }

    getUserChannels(id: string): Promise<TeamsChannelDTO[]> {
        let url_ = this.baseUrl + "/api/teams/user-channels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserChannels(_response);
        });
    }

    protected processGetUserChannels(response: Response): Promise<TeamsChannelDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamsChannelDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsChannelDTO[]>(null as any);
    }

    getBotChannels(id: string): Promise<TeamsChannelDTO[]> {
        let url_ = this.baseUrl + "/api/teams/bot-channels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBotChannels(_response);
        });
    }

    protected processGetBotChannels(response: Response): Promise<TeamsChannelDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamsChannelDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsChannelDTO[]>(null as any);
    }

    getNotificationLinks(assignmentId: string): Promise<TeamsNotificationLinkDTO[]> {
        let url_ = this.baseUrl + "/api/teams/notification-links/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotificationLinks(_response);
        });
    }

    protected processGetNotificationLinks(response: Response): Promise<TeamsNotificationLinkDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamsNotificationLinkDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsNotificationLinkDTO[]>(null as any);
    }

    createNotificationLink(channelLink: CreateTeamsNotificationLinkDTO): Promise<TeamsNotificationLinkDTO> {
        let url_ = this.baseUrl + "/api/teams/notification-links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(channelLink);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNotificationLink(_response);
        });
    }

    protected processCreateNotificationLink(response: Response): Promise<TeamsNotificationLinkDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamsNotificationLinkDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsNotificationLinkDTO>(null as any);
    }

    removeNotificationLink(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/teams/notification-links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveNotificationLink(_response);
        });
    }

    protected processRemoveNotificationLink(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getChannelLinks(groupId: string): Promise<TeamsChannelLinkDTO[]> {
        let url_ = this.baseUrl + "/api/teams/channel-links/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChannelLinks(_response);
        });
    }

    protected processGetChannelLinks(response: Response): Promise<TeamsChannelLinkDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamsChannelLinkDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsChannelLinkDTO[]>(null as any);
    }

    createChannelLink(channelLink: CreateTeamsChannelLinkDTO): Promise<TeamsChannelLinkDTO> {
        let url_ = this.baseUrl + "/api/teams/channel-links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(channelLink);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateChannelLink(_response);
        });
    }

    protected processCreateChannelLink(response: Response): Promise<TeamsChannelLinkDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamsChannelLinkDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsChannelLinkDTO>(null as any);
    }

    removeChannelLink(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/teams/channel-links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveChannelLink(_response);
        });
    }

    protected processRemoveChannelLink(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TenantApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getScimInfo(): Promise<ScimDTO> {
        let url_ = this.baseUrl + "/api/tenants/GetScimInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetScimInfo(_response);
        });
    }

    protected processGetScimInfo(response: Response): Promise<ScimDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScimDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScimDTO>(null as any);
    }

    getNewScimSecret(): Promise<ScimDTO> {
        let url_ = this.baseUrl + "/api/tenants/GetNewScimSecret";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNewScimSecret(_response);
        });
    }

    protected processGetNewScimSecret(response: Response): Promise<ScimDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScimDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScimDTO>(null as any);
    }

    scimEnable(enable: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/tenants?";
        if (enable === null)
            throw new Error("The parameter 'enable' cannot be null.");
        else if (enable !== undefined)
            url_ += "enable=" + encodeURIComponent("" + enable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processScimEnable(_response);
        });
    }

    protected processScimEnable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new user
     * @return On failure, returns a ModelState object containing a "reason" member.
                Currently the following reasons are defined: "EmailExists" "UserNameExists"
                "BadPassword" and "NoInvitation"
     */
    createUser(model: CreateUserDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    forgotPassword(model: ForgotPasswordViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/users/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    confirmEmail(userId: string | null | undefined, code: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/users/ConfirmEmail?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getConfirmUrl(userID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/users/GetConfirmUrl/{userID}";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfirmUrl(_response);
        });
    }

    protected processGetConfirmUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Retrieve details about the current user
     */
    getSelf(): Promise<UserSelfDTO> {
        let url_ = this.baseUrl + "/api/users/Self";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelf(_response);
        });
    }

    protected processGetSelf(response: Response): Promise<UserSelfDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSelfDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSelfDTO>(null as any);
    }

    /**
     * Update details about the current user
     */
    putSelf(model: EditUserDTO): Promise<UserSelfDTO> {
        let url_ = this.baseUrl + "/api/users/Self";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutSelf(_response);
        });
    }

    protected processPutSelf(response: Response): Promise<UserSelfDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSelfDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSelfDTO>(null as any);
    }

    deleteSelf(): Promise<void> {
        let url_ = this.baseUrl + "/api/users/Self";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSelf(_response);
        });
    }

    protected processDeleteSelf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update details about the current user
     */
    putPassword(model: ChangePasswordModel): Promise<void> {
        let url_ = this.baseUrl + "/api/users/Self/Password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutPassword(_response);
        });
    }

    protected processPutPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve a user's avatar
     */
    getAvatar(): Promise<UserAvatar> {
        let url_ = this.baseUrl + "/api/users/Self/Avatar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvatar(_response);
        });
    }

    protected processGetAvatar(response: Response): Promise<UserAvatar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatar.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatar>(null as any);
    }

    /**
     * Set the current user's avatar
     */
    setAvatar(): Promise<UserAvatar> {
        let url_ = this.baseUrl + "/api/users/Self/Avatar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAvatar(_response);
        });
    }

    protected processSetAvatar(response: Response): Promise<UserAvatar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatar.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatar>(null as any);
    }

    /**
     * Delete the current user's avatar and return to the default avatar
     */
    deleteAvatar(): Promise<UserAvatar> {
        let url_ = this.baseUrl + "/api/users/Self/Avatar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAvatar(_response);
        });
    }

    protected processDeleteAvatar(response: Response): Promise<UserAvatar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatar.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatar>(null as any);
    }

    /**
     * Retrieve a user's avatar
     */
    getAvatar2(id: string): Promise<UserAvatar> {
        let url_ = this.baseUrl + "/api/users/{id}/Avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvatar2(_response);
        });
    }

    protected processGetAvatar2(response: Response): Promise<UserAvatar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatar.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatar>(null as any);
    }

    /**
     * Join an existing groop
     */
    joinGroop(groopId: string): Promise<GroopDTO> {
        let url_ = this.baseUrl + "/api/users/Self/Groop/{groopId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processJoinGroop(_response);
        });
    }

    protected processJoinGroop(response: Response): Promise<GroopDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDTO>(null as any);
    }

    /**
     * Leave a groop the user is a member of and delete any outstanding
    invitations.
     */
    leaveGroop(groopId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/users/Self/Groop/{groopId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLeaveGroop(_response);
        });
    }

    protected processLeaveGroop(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Join an existing groop
     */
    joinGroopV4(groopId: string): Promise<GroopDTO> {
        let url_ = this.baseUrl + "/api/v4/users/Self/Groop/{groopId}";
        if (groopId === undefined || groopId === null)
            throw new Error("The parameter 'groopId' must be defined.");
        url_ = url_.replace("{groopId}", encodeURIComponent("" + groopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processJoinGroopV4(_response);
        });
    }

    protected processJoinGroopV4(response: Response): Promise<GroopDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroopDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopDTO>(null as any);
    }

    /**
     * retrieve the current user's email settings
     * @return EmailSettingsModel
     */
    getEmailSettings(): Promise<EmailSettingsModel> {
        let url_ = this.baseUrl + "/api/users/Self/EmailSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmailSettings(_response);
        });
    }

    protected processGetEmailSettings(response: Response): Promise<EmailSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailSettingsModel>(null as any);
    }

    setEmailSettings(model: EmailSettingsModel): Promise<void> {
        let url_ = this.baseUrl + "/api/users/Self/EmailSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetEmailSettings(_response);
        });
    }

    protected processSetEmailSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VizApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    publishView(model: VizDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/viz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPublishView(_response);
        });
    }

    protected processPublishView(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDataGET(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/viz/Data/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataGET(_response);
        });
    }

    protected processGetDataGET(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    getDataPOST(model: VizDTO): Promise<any> {
        let url_ = this.baseUrl + "/api/viz/Data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataPOST(_response);
        });
    }

    protected processGetDataPOST(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    getView(id: number | undefined): Promise<VizDTO> {
        let url_ = this.baseUrl + "/api/viz/id:int?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetView(_response);
        });
    }

    protected processGetView(response: Response): Promise<VizDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VizDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VizDTO>(null as any);
    }

    updateView(id: number | undefined, model: VizDTO): Promise<VizDTO> {
        let url_ = this.baseUrl + "/api/viz/id:int?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateView(_response);
        });
    }

    protected processUpdateView(response: Response): Promise<VizDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VizDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VizDTO>(null as any);
    }
}

export class SalesforceApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    linkGroup(linkGroup: LinkGroupDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/link-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(linkGroup);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkGroup(_response);
        });
    }

    protected processLinkGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    unlinkGroup(unlinkGroup: UnlinkGroupDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/unlink-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unlinkGroup);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnlinkGroup(_response);
        });
    }

    protected processUnlinkGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    mapField(mapField: MapFieldDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/map-field";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapField);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMapField(_response);
        });
    }

    protected processMapField(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getGroups(getGroups: GetGroupsDTO): Promise<GroupDTO[]> {
        let url_ = this.baseUrl + "/api/salesforce/get-linked-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getGroups);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: Response): Promise<GroupDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupDTO[]>(null as any);
    }

    getOwnedGroups(getGroups: GetGroupsDTO): Promise<GroupDTO[]> {
        let url_ = this.baseUrl + "/api/salesforce/get-owned-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getGroups);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOwnedGroups(_response);
        });
    }

    protected processGetOwnedGroups(response: Response): Promise<GroupDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupDTO[]>(null as any);
    }

    createGroopIt(newGroopit: CreateGroopitDTO2): Promise<GroopitDTO> {
        let url_ = this.baseUrl + "/api/salesforce/create-groopit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newGroopit);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroopIt(_response);
        });
    }

    protected processCreateGroopIt(response: Response): Promise<GroopitDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GroopitDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroopitDTO>(null as any);
    }

    getComponentOptions(getComponentOptions: GetComponentOptionsDTO): Promise<string[]> {
        let url_ = this.baseUrl + "/api/salesforce/get-component-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getComponentOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComponentOptions(_response);
        });
    }

    protected processGetComponentOptions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createPendingUpload(isFile: boolean | undefined): Promise<PendingUploadDTO> {
        let url_ = this.baseUrl + "/api/salesforce/uploads?";
        if (isFile === null)
            throw new Error("The parameter 'isFile' cannot be null.");
        else if (isFile !== undefined)
            url_ += "isFile=" + encodeURIComponent("" + isFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePendingUpload(_response);
        });
    }

    protected processCreatePendingUpload(response: Response): Promise<PendingUploadDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PendingUploadDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PendingUploadDTO>(null as any);
    }

    setLinkedObjects(setLinkedObjects: SetLinkedObjectsDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/set-linked-objects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setLinkedObjects);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetLinkedObjects(_response);
        });
    }

    protected processSetLinkedObjects(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setGroopitExternalId(setGroopitExternalId: SetGroopitExternalIdDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/set-groopit-external-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setGroopitExternalId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetGroopitExternalId(_response);
        });
    }

    protected processSetGroopitExternalId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MetadataClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Generates the OData $metadata document.
     * @return The IEdmModel representing $metadata.
     */
    getMetadata(): Promise<IEdmModel> {
        let url_ = this.baseUrl + "/odata/$metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMetadata(_response);
        });
    }

    protected processGetMetadata(response: Response): Promise<IEdmModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IEdmModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IEdmModel>(null as any);
    }

    /**
     * Generates the OData service document.
     * @return The service document for the service.
     */
    getServiceDocument(): Promise<ODataServiceDocument> {
        let url_ = this.baseUrl + "/odata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceDocument(_response);
        });
    }

    protected processGetServiceDocument(response: Response): Promise<ODataServiceDocument> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataServiceDocument.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ODataServiceDocument>(null as any);
    }
}

export class FollowUpEditorResponseDTO implements IFollowUpEditorResponseDTO {
    success!: boolean;
    groopit?: GroopItModel_V1 | undefined;
    errors?: ModelStateErrorDTO | undefined;

    constructor(data?: IFollowUpEditorResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.groopit = _data["groopit"] ? GroopItModel_V1.fromJS(_data["groopit"]) : <any>undefined;
            this.errors = _data["errors"] ? ModelStateErrorDTO.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FollowUpEditorResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FollowUpEditorResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["groopit"] = this.groopit ? this.groopit.toJSON() : <any>undefined;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFollowUpEditorResponseDTO {
    success: boolean;
    groopit?: GroopItModel_V1 | undefined;
    errors?: ModelStateErrorDTO | undefined;
}

export class GroopItModel_V1 implements IGroopItModel_V1 {
    id!: string;
    creator!: UserDTO;
    timestamp!: Date;
    /** Set to the last edit time (if any) or null if it hasn't bee edited. */
    editTime?: Date | undefined;
    /** Set to the user to last edited the groopit or null if it hasn't been edited. */
    editor?: UserDTO | undefined;
    flag?: string | undefined;
    pinned?: boolean;
    assignmentId!: string;
    components!: ComponentDataDTO[];
    likeCount!: number;
    likedByUser!: boolean;
    canComment!: boolean;
    commentCount!: number;
    /** set of users tagged in this groopit */
    tagged?: { [key: string]: UserDTO; } | undefined;
    parentGroop!: DisplayGroopDTO;
    salesforceLinks!: SFTargetDTO[];
    source?: string | undefined;
    extractionSource?: ExtractionSource | undefined;

    constructor(data?: IGroopItModel_V1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.creator = new UserDTO();
            this.components = [];
            this.parentGroop = new DisplayGroopDTO();
            this.salesforceLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.creator = _data["Creator"] ? UserDTO.fromJS(_data["Creator"]) : new UserDTO();
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.editTime = _data["EditTime"] ? new Date(_data["EditTime"].toString()) : <any>undefined;
            this.editor = _data["Editor"] ? UserDTO.fromJS(_data["Editor"]) : <any>undefined;
            this.flag = _data["Flag"];
            this.pinned = _data["Pinned"];
            this.assignmentId = _data["AssignmentId"];
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(ComponentDataDTO.fromJS(item));
            }
            this.likeCount = _data["LikeCount"];
            this.likedByUser = _data["LikedByUser"];
            this.canComment = _data["CanComment"];
            this.commentCount = _data["CommentCount"];
            if (_data["Tagged"]) {
                this.tagged = {} as any;
                for (let key in _data["Tagged"]) {
                    if (_data["Tagged"].hasOwnProperty(key))
                        (<any>this.tagged)![key] = _data["Tagged"][key] ? UserDTO.fromJS(_data["Tagged"][key]) : new UserDTO();
                }
            }
            this.parentGroop = _data["ParentGroop"] ? DisplayGroopDTO.fromJS(_data["ParentGroop"]) : new DisplayGroopDTO();
            if (Array.isArray(_data["SalesforceLinks"])) {
                this.salesforceLinks = [] as any;
                for (let item of _data["SalesforceLinks"])
                    this.salesforceLinks!.push(SFTargetDTO.fromJS(item));
            }
            this.source = _data["Source"];
            this.extractionSource = _data["ExtractionSource"] ? ExtractionSource.fromJS(_data["ExtractionSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GroopItModel_V1 {
        data = typeof data === 'object' ? data : {};
        let result = new GroopItModel_V1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["EditTime"] = this.editTime ? this.editTime.toISOString() : <any>undefined;
        data["Editor"] = this.editor ? this.editor.toJSON() : <any>undefined;
        data["Flag"] = this.flag;
        data["Pinned"] = this.pinned;
        data["AssignmentId"] = this.assignmentId;
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        data["LikeCount"] = this.likeCount;
        data["LikedByUser"] = this.likedByUser;
        data["CanComment"] = this.canComment;
        data["CommentCount"] = this.commentCount;
        if (this.tagged) {
            data["Tagged"] = {};
            for (let key in this.tagged) {
                if (this.tagged.hasOwnProperty(key))
                    (<any>data["Tagged"])[key] = this.tagged[key] ? this.tagged[key].toJSON() : <any>undefined;
            }
        }
        data["ParentGroop"] = this.parentGroop ? this.parentGroop.toJSON() : <any>undefined;
        if (Array.isArray(this.salesforceLinks)) {
            data["SalesforceLinks"] = [];
            for (let item of this.salesforceLinks)
                data["SalesforceLinks"].push(item.toJSON());
        }
        data["Source"] = this.source;
        data["ExtractionSource"] = this.extractionSource ? this.extractionSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGroopItModel_V1 {
    id: string;
    creator: UserDTO;
    timestamp: Date;
    /** Set to the last edit time (if any) or null if it hasn't bee edited. */
    editTime?: Date | undefined;
    /** Set to the user to last edited the groopit or null if it hasn't been edited. */
    editor?: UserDTO | undefined;
    flag?: string | undefined;
    pinned?: boolean;
    assignmentId: string;
    components: ComponentDataDTO[];
    likeCount: number;
    likedByUser: boolean;
    canComment: boolean;
    commentCount: number;
    /** set of users tagged in this groopit */
    tagged?: { [key: string]: UserDTO; } | undefined;
    parentGroop: DisplayGroopDTO;
    salesforceLinks: SFTargetDTO[];
    source?: string | undefined;
    extractionSource?: ExtractionSource | undefined;
}

export class UserDTO implements IUserDTO {
    id!: string;
    friendlyName!: string;
    avatarUrl!: string;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.friendlyName = _data["FriendlyName"];
            this.avatarUrl = _data["AvatarUrl"];
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FriendlyName"] = this.friendlyName;
        data["AvatarUrl"] = this.avatarUrl;
        return data;
    }
}

export interface IUserDTO {
    id: string;
    friendlyName: string;
    avatarUrl: string;
}

export class ComponentDataDTO implements IComponentDataDTO {
    componentData_Id!: number;
    model!: ComponentModelDTO;
    type!: ComponentType;
    image?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    pictures?: PictureModelDTO[] | undefined;
    files?: FileModelDTO[] | undefined;
    location?: Point | undefined;
    notes?: string | undefined;
    number?: number | undefined;
    formattedNumber?: string | undefined;
    timestamp?: Date | undefined;
    externalId?: string | undefined;
    displayName?: string | undefined;
    displayValue?: string | undefined;
    value?: string | undefined;
    options?: string | undefined;
    choice?: string | undefined;

    constructor(data?: IComponentDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = new ComponentModelDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentData_Id = _data["ComponentData_Id"];
            this.model = _data["Model"] ? ComponentModelDTO.fromJS(_data["Model"]) : new ComponentModelDTO();
            this.type = _data["Type"];
            this.image = _data["Image"];
            this.width = _data["Width"];
            this.height = _data["Height"];
            if (Array.isArray(_data["Pictures"])) {
                this.pictures = [] as any;
                for (let item of _data["Pictures"])
                    this.pictures!.push(PictureModelDTO.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileModelDTO.fromJS(item));
            }
            this.location = _data["Location"] ? Point.fromJS(_data["Location"]) : <any>undefined;
            this.notes = _data["Notes"];
            this.number = _data["Number"];
            this.formattedNumber = _data["FormattedNumber"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.externalId = _data["ExternalId"];
            this.displayName = _data["DisplayName"];
            this.displayValue = _data["DisplayValue"];
            this.value = _data["Value"];
            this.options = _data["Options"];
            this.choice = _data["Choice"];
        }
    }

    static fromJS(data: any): ComponentDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ComponentData_Id"] = this.componentData_Id;
        data["Model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["Type"] = this.type;
        data["Image"] = this.image;
        data["Width"] = this.width;
        data["Height"] = this.height;
        if (Array.isArray(this.pictures)) {
            data["Pictures"] = [];
            for (let item of this.pictures)
                data["Pictures"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["Notes"] = this.notes;
        data["Number"] = this.number;
        data["FormattedNumber"] = this.formattedNumber;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["ExternalId"] = this.externalId;
        data["DisplayName"] = this.displayName;
        data["DisplayValue"] = this.displayValue;
        data["Value"] = this.value;
        data["Options"] = this.options;
        data["Choice"] = this.choice;
        return data;
    }
}

export interface IComponentDataDTO {
    componentData_Id: number;
    model: ComponentModelDTO;
    type: ComponentType;
    image?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    pictures?: PictureModelDTO[] | undefined;
    files?: FileModelDTO[] | undefined;
    location?: Point | undefined;
    notes?: string | undefined;
    number?: number | undefined;
    formattedNumber?: string | undefined;
    timestamp?: Date | undefined;
    externalId?: string | undefined;
    displayName?: string | undefined;
    displayValue?: string | undefined;
    value?: string | undefined;
    options?: string | undefined;
    choice?: string | undefined;
}

export class ComponentModelDTO implements IComponentModelDTO {
    componentModel_Id!: number;
    type!: ComponentType;
    sequence!: number;
    description!: string;
    aIPrompt?: string | undefined;
    required!: boolean;
    formId!: string;
    /** For ComponentType:

MultipleChoice

A list of options, delimited by pipe (|). See  if
accessing this property for a .

Decimal
C# Format options (e.g. "F0").

FileSet
A list of mimetypes suitable for the accept attribute of the HTML input element. */
    options?: string | undefined;
    /** Valid only for ComponentType.MultipleChoice
Whether multiple options are allowed or just one. */
    multiple?: boolean;
    hiddenFromMembers?: boolean;
    isFlagField?: boolean;
    isFollowUpField?: boolean;
    /** Valid only for ComponentType.DateTime
Whether to display Date-only or both Date and Time */
    dateOnly?: boolean;
    /** Valid only for ComponentType.MultipleChoice
true - members are allowed to add options
false - only owners can add options */
    userEditable?: boolean;
    /** Valid only for ComponentType.Note and ComponentType.FixedDecimal
Indicates that this model is actually a row in a table field. ParentModel
will be the parent ComponentType.Table. null if not a table row. */
    parentModelComponentModel_Id?: number | undefined;
    /** Valid only for ComponentType.SaveToSalesforce and ComponentType.InheritedData */
    externalDataType?: string | undefined;
    externalFieldName?: string | undefined;
    externalFieldLabel?: string | undefined;

    constructor(data?: IComponentModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentModel_Id = _data["ComponentModel_Id"];
            this.type = _data["Type"];
            this.sequence = _data["Sequence"];
            this.description = _data["Description"];
            this.aIPrompt = _data["AIPrompt"];
            this.required = _data["Required"];
            this.formId = _data["FormId"];
            this.options = _data["Options"];
            this.multiple = _data["Multiple"];
            this.hiddenFromMembers = _data["HiddenFromMembers"];
            this.isFlagField = _data["IsFlagField"];
            this.isFollowUpField = _data["IsFollowUpField"];
            this.dateOnly = _data["DateOnly"];
            this.userEditable = _data["UserEditable"];
            this.parentModelComponentModel_Id = _data["ParentModelComponentModel_Id"];
            this.externalDataType = _data["ExternalDataType"];
            this.externalFieldName = _data["ExternalFieldName"];
            this.externalFieldLabel = _data["ExternalFieldLabel"];
        }
    }

    static fromJS(data: any): ComponentModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ComponentModel_Id"] = this.componentModel_Id;
        data["Type"] = this.type;
        data["Sequence"] = this.sequence;
        data["Description"] = this.description;
        data["AIPrompt"] = this.aIPrompt;
        data["Required"] = this.required;
        data["FormId"] = this.formId;
        data["Options"] = this.options;
        data["Multiple"] = this.multiple;
        data["HiddenFromMembers"] = this.hiddenFromMembers;
        data["IsFlagField"] = this.isFlagField;
        data["IsFollowUpField"] = this.isFollowUpField;
        data["DateOnly"] = this.dateOnly;
        data["UserEditable"] = this.userEditable;
        data["ParentModelComponentModel_Id"] = this.parentModelComponentModel_Id;
        data["ExternalDataType"] = this.externalDataType;
        data["ExternalFieldName"] = this.externalFieldName;
        data["ExternalFieldLabel"] = this.externalFieldLabel;
        return data;
    }
}

export interface IComponentModelDTO {
    componentModel_Id: number;
    type: ComponentType;
    sequence: number;
    description: string;
    aIPrompt?: string | undefined;
    required: boolean;
    formId: string;
    /** For ComponentType:

MultipleChoice

A list of options, delimited by pipe (|). See  if
accessing this property for a .

Decimal
C# Format options (e.g. "F0").

FileSet
A list of mimetypes suitable for the accept attribute of the HTML input element. */
    options?: string | undefined;
    /** Valid only for ComponentType.MultipleChoice
Whether multiple options are allowed or just one. */
    multiple?: boolean;
    hiddenFromMembers?: boolean;
    isFlagField?: boolean;
    isFollowUpField?: boolean;
    /** Valid only for ComponentType.DateTime
Whether to display Date-only or both Date and Time */
    dateOnly?: boolean;
    /** Valid only for ComponentType.MultipleChoice
true - members are allowed to add options
false - only owners can add options */
    userEditable?: boolean;
    /** Valid only for ComponentType.Note and ComponentType.FixedDecimal
Indicates that this model is actually a row in a table field. ParentModel
will be the parent ComponentType.Table. null if not a table row. */
    parentModelComponentModel_Id?: number | undefined;
    /** Valid only for ComponentType.SaveToSalesforce and ComponentType.InheritedData */
    externalDataType?: string | undefined;
    externalFieldName?: string | undefined;
    externalFieldLabel?: string | undefined;
}

export enum ComponentType {
    Picture = 0,
    Location = 1,
    Note = 2,
    MultipleChoice = 3,
    Obsolete = 4,
    DateTime = 5,
    MultipleChoiceExtended = 6,
    Obsolete2 = 7,
    FixedDecimal = 8,
    PictureSet = 9,
    Table = 10,
    FileSet = 11,
    SaveToSalesforce = 12,
    InheritedData = 13,
    FollowUpRequest = 14,
    Unknown = -1,
}

export class PictureModelDTO implements IPictureModelDTO {
    id?: number;
    image!: string;
    width?: number;
    height?: number;
    sequence!: number;
    componentId?: number | undefined;

    constructor(data?: IPictureModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.image = _data["Image"];
            this.width = _data["Width"];
            this.height = _data["Height"];
            this.sequence = _data["Sequence"];
            this.componentId = _data["ComponentId"];
        }
    }

    static fromJS(data: any): PictureModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PictureModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Image"] = this.image;
        data["Width"] = this.width;
        data["Height"] = this.height;
        data["Sequence"] = this.sequence;
        data["ComponentId"] = this.componentId;
        return data;
    }
}

export interface IPictureModelDTO {
    id?: number;
    image: string;
    width?: number;
    height?: number;
    sequence: number;
    componentId?: number | undefined;
}

export class FileModelDTO implements IFileModelDTO {
    id?: number;
    fileId!: string;
    size?: number;
    filename?: string | undefined;
    sequence!: number;
    componentId?: number | undefined;

    constructor(data?: IFileModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fileId = _data["FileId"];
            this.size = _data["Size"];
            this.filename = _data["Filename"];
            this.sequence = _data["Sequence"];
            this.componentId = _data["ComponentId"];
        }
    }

    static fromJS(data: any): FileModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FileId"] = this.fileId;
        data["Size"] = this.size;
        data["Filename"] = this.filename;
        data["Sequence"] = this.sequence;
        data["ComponentId"] = this.componentId;
        return data;
    }
}

export interface IFileModelDTO {
    id?: number;
    fileId: string;
    size?: number;
    filename?: string | undefined;
    sequence: number;
    componentId?: number | undefined;
}

export class Geography implements IGeography {
    coordinateSystemId?: number;
    wellKnownText?: string;

    [key: string]: any;

    constructor(data?: IGeography) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.coordinateSystemId = _data["CoordinateSystemId"];
            this.wellKnownText = _data["WellKnownText"];
        }
    }

    static fromJS(data: any): Geography {
        data = typeof data === 'object' ? data : {};
        let result = new Geography();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["CoordinateSystemId"] = this.coordinateSystemId;
        data["WellKnownText"] = this.wellKnownText;
        return data;
    }
}

export interface IGeography {
    coordinateSystemId?: number;
    wellKnownText?: string;

    [key: string]: any;
}

export class Point implements IPoint {
    geography?: Geography;

    [key: string]: any;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.geography = _data["Geography"] ? Geography.fromJS(_data["Geography"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Geography"] = this.geography ? this.geography.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPoint {
    geography?: Geography;

    [key: string]: any;
}

export class DisplayGroopDTO implements IDisplayGroopDTO {
    id!: string;
    name?: string | undefined;
    avatarUrl?: string | undefined;
    email?: string | undefined;

    constructor(data?: IDisplayGroopDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.avatarUrl = _data["AvatarUrl"];
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): DisplayGroopDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayGroopDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["AvatarUrl"] = this.avatarUrl;
        data["Email"] = this.email;
        return data;
    }
}

export interface IDisplayGroopDTO {
    id: string;
    name?: string | undefined;
    avatarUrl?: string | undefined;
    email?: string | undefined;
}

/** Represents a Salesforce object that a Groopit can be linked to. */
export class SFTargetDTO implements ISFTargetDTO {
    isEditable?: boolean;
    salesforceType?: string | undefined;
    fieldName?: string | undefined;
    label!: string;
    name?: string | undefined;
    selectedObjectId?: string | undefined;

    constructor(data?: ISFTargetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEditable = _data["IsEditable"];
            this.salesforceType = _data["SalesforceType"];
            this.fieldName = _data["FieldName"];
            this.label = _data["Label"];
            this.name = _data["Name"];
            this.selectedObjectId = _data["SelectedObjectId"];
        }
    }

    static fromJS(data: any): SFTargetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SFTargetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsEditable"] = this.isEditable;
        data["SalesforceType"] = this.salesforceType;
        data["FieldName"] = this.fieldName;
        data["Label"] = this.label;
        data["Name"] = this.name;
        data["SelectedObjectId"] = this.selectedObjectId;
        return data;
    }
}

/** Represents a Salesforce object that a Groopit can be linked to. */
export interface ISFTargetDTO {
    isEditable?: boolean;
    salesforceType?: string | undefined;
    fieldName?: string | undefined;
    label: string;
    name?: string | undefined;
    selectedObjectId?: string | undefined;
}

export class ExtractionSource implements IExtractionSource {
    id?: string;
    value?: string | undefined;
    includeSource?: boolean;

    constructor(data?: IExtractionSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.value = _data["Value"];
            this.includeSource = _data["IncludeSource"];
        }
    }

    static fromJS(data: any): ExtractionSource {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractionSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Value"] = this.value;
        data["IncludeSource"] = this.includeSource;
        return data;
    }
}

export interface IExtractionSource {
    id?: string;
    value?: string | undefined;
    includeSource?: boolean;
}

export class ModelStateErrorDTO implements IModelStateErrorDTO {
    modelState!: { [key: string]: string[]; };

    constructor(data?: IModelStateErrorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.modelState = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["ModelState"]) {
                this.modelState = {} as any;
                for (let key in _data["ModelState"]) {
                    if (_data["ModelState"].hasOwnProperty(key))
                        (<any>this.modelState)![key] = _data["ModelState"][key] !== undefined ? _data["ModelState"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ModelStateErrorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ModelStateErrorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.modelState) {
            data["ModelState"] = {};
            for (let key in this.modelState) {
                if (this.modelState.hasOwnProperty(key))
                    (<any>data["ModelState"])[key] = (<any>this.modelState)[key];
            }
        }
        return data;
    }
}

export interface IModelStateErrorDTO {
    modelState: { [key: string]: string[]; };
}

export abstract class ComponentDataEditorViewModel implements IComponentDataEditorViewModel {
    componentModel_Id!: number;
    required!: boolean;
    description!: string;
    aIPrompt?: string | undefined;
    hiddenFromMembers!: boolean;
    parentComponent?: ComponentType | undefined;

    constructor(data?: IComponentDataEditorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentModel_Id = _data["ComponentModel_Id"];
            this.required = _data["Required"];
            this.description = _data["Description"];
            this.aIPrompt = _data["AIPrompt"];
            this.hiddenFromMembers = _data["HiddenFromMembers"];
            this.parentComponent = _data["ParentComponent"];
        }
    }

    static fromJS(data: any): ComponentDataEditorViewModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ComponentDataEditorViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ComponentModel_Id"] = this.componentModel_Id;
        data["Required"] = this.required;
        data["Description"] = this.description;
        data["AIPrompt"] = this.aIPrompt;
        data["HiddenFromMembers"] = this.hiddenFromMembers;
        data["ParentComponent"] = this.parentComponent;
        return data;
    }
}

export interface IComponentDataEditorViewModel {
    componentModel_Id: number;
    required: boolean;
    description: string;
    aIPrompt?: string | undefined;
    hiddenFromMembers: boolean;
    parentComponent?: ComponentType | undefined;
}

export class Assignment implements IAssignment {
    id?: string;
    title?: string | undefined;
    posts?: Post[] | undefined;

    constructor(data?: IAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            if (Array.isArray(_data["Posts"])) {
                this.posts = [] as any;
                for (let item of _data["Posts"])
                    this.posts!.push(Post.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Assignment {
        data = typeof data === 'object' ? data : {};
        let result = new Assignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        if (Array.isArray(this.posts)) {
            data["Posts"] = [];
            for (let item of this.posts)
                data["Posts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignment {
    id?: string;
    title?: string | undefined;
    posts?: Post[] | undefined;
}

export class Post implements IPost {
    id?: string;
    creatorId?: string | undefined;
    creatorEmail?: string | undefined;
    timestamp?: Date;
    fields?: { [key: string]: any; } | undefined;

    constructor(data?: IPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.creatorId = _data["CreatorId"];
            this.creatorEmail = _data["CreatorEmail"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            if (_data["Fields"]) {
                this.fields = {} as any;
                for (let key in _data["Fields"]) {
                    if (_data["Fields"].hasOwnProperty(key))
                        (<any>this.fields)![key] = _data["Fields"][key];
                }
            }
        }
    }

    static fromJS(data: any): Post {
        data = typeof data === 'object' ? data : {};
        let result = new Post();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatorId"] = this.creatorId;
        data["CreatorEmail"] = this.creatorEmail;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        if (this.fields) {
            data["Fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["Fields"])[key] = (<any>this.fields)[key];
            }
        }
        return data;
    }
}

export interface IPost {
    id?: string;
    creatorId?: string | undefined;
    creatorEmail?: string | undefined;
    timestamp?: Date;
    fields?: { [key: string]: any; } | undefined;
}

export class SuggestDataModelsResultDTO implements ISuggestDataModelsResultDTO {
    assignments?: AssignmentDTO[] | undefined;
    error?: ErrorDTO | undefined;

    constructor(data?: ISuggestDataModelsResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(AssignmentDTO.fromJS(item));
            }
            this.error = _data["error"] ? ErrorDTO.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SuggestDataModelsResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestDataModelsResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISuggestDataModelsResultDTO {
    assignments?: AssignmentDTO[] | undefined;
    error?: ErrorDTO | undefined;
}

export class AssignmentDTO implements IAssignmentDTO {
    id!: string;
    groop!: string;
    name!: string;
    description?: string | undefined;
    hidden!: boolean;
    sequence!: number;
    components!: ComponentModelDTO[];
    isActive!: boolean;
    allowsContributors!: boolean;
    allowsPublishers!: boolean;
    title?: string | undefined;
    assignmentPhotoUrl!: string;

    constructor(data?: IAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.components = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.groop = _data["Groop"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.hidden = _data["Hidden"];
            this.sequence = _data["Sequence"];
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(ComponentModelDTO.fromJS(item));
            }
            this.isActive = _data["IsActive"];
            this.allowsContributors = _data["AllowsContributors"];
            this.allowsPublishers = _data["AllowsPublishers"];
            this.title = _data["Title"];
            this.assignmentPhotoUrl = _data["AssignmentPhotoUrl"];
        }
    }

    static fromJS(data: any): AssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Groop"] = this.groop;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Hidden"] = this.hidden;
        data["Sequence"] = this.sequence;
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        data["IsActive"] = this.isActive;
        data["AllowsContributors"] = this.allowsContributors;
        data["AllowsPublishers"] = this.allowsPublishers;
        data["Title"] = this.title;
        data["AssignmentPhotoUrl"] = this.assignmentPhotoUrl;
        return data;
    }
}

export interface IAssignmentDTO {
    id: string;
    groop: string;
    name: string;
    description?: string | undefined;
    hidden: boolean;
    sequence: number;
    components: ComponentModelDTO[];
    isActive: boolean;
    allowsContributors: boolean;
    allowsPublishers: boolean;
    title?: string | undefined;
    assignmentPhotoUrl: string;
}

export class ErrorDTO implements IErrorDTO {
    error!: ErrorType;
    error_description?: string | undefined;

    constructor(data?: IErrorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.error_description = _data["error_description"];
        }
    }

    static fromJS(data: any): ErrorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["error_description"] = this.error_description;
        return data;
    }
}

export interface IErrorDTO {
    error: ErrorType;
    error_description?: string | undefined;
}

export enum ErrorType {
    Error = "Error",
    DeprecatedAPI = "DeprecatedAPI",
    SalesforceNeedsAuthorization = "SalesforceNeedsAuthorization",
    SalesforceNotAuthorized = "SalesforceNotAuthorized",
    ExternalServiceFailure = "ExternalServiceFailure",
    UpgradeClient = "UpgradeClient",
    ExternalServiceMissingField = "ExternalServiceMissingField",
    UniquenessConflict = "UniquenessConflict",
    HiddenResourceConflict = "HiddenResourceConflict",
}

export class AiPopulateDataModelResultDTO implements IAiPopulateDataModelResultDTO {
    jobId!: string;
    status!: AsyncStatus;
    result?: AiStructuredDataModelResultDTO[] | undefined;

    constructor(data?: IAiPopulateDataModelResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["JobId"];
            this.status = _data["Status"];
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(AiStructuredDataModelResultDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AiPopulateDataModelResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AiPopulateDataModelResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["JobId"] = this.jobId;
        data["Status"] = this.status;
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAiPopulateDataModelResultDTO {
    jobId: string;
    status: AsyncStatus;
    result?: AiStructuredDataModelResultDTO[] | undefined;
}

export enum AsyncStatus {
    Completed = 0,
    Failed = 1,
    Cancelled = 2,
    InProgress = 3,
}

export class AiStructuredDataModelResultDTO implements IAiStructuredDataModelResultDTO {
    components?: ExtractedComponentDataDTO[] | undefined;
    error?: ErrorDTO | undefined;

    constructor(data?: IAiStructuredDataModelResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(ExtractedComponentDataDTO.fromJS(item));
            }
            this.error = _data["Error"] ? ErrorDTO.fromJS(_data["Error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AiStructuredDataModelResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AiStructuredDataModelResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        data["Error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAiStructuredDataModelResultDTO {
    components?: ExtractedComponentDataDTO[] | undefined;
    error?: ErrorDTO | undefined;
}

export class ExtractedComponentDataDTO implements IExtractedComponentDataDTO {
    componentData_Id!: number;
    modelComponentModelId!: number;
    type!: ComponentType;
    image?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    pictures?: PictureModelDTO[] | undefined;
    files?: FileModelDTO[] | undefined;
    location?: Point | undefined;
    notes?: string | undefined;
    number?: number | undefined;
    formattedNumber?: string | undefined;
    timestamp?: Date | undefined;
    externalId?: string | undefined;
    displayName?: string | undefined;
    displayValue?: string | undefined;
    value?: string | undefined;
    options?: string | undefined;
    choice?: string | undefined;

    constructor(data?: IExtractedComponentDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentData_Id = _data["ComponentData_Id"];
            this.modelComponentModelId = _data["ModelComponentModelId"];
            this.type = _data["Type"];
            this.image = _data["Image"];
            this.width = _data["Width"];
            this.height = _data["Height"];
            if (Array.isArray(_data["Pictures"])) {
                this.pictures = [] as any;
                for (let item of _data["Pictures"])
                    this.pictures!.push(PictureModelDTO.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileModelDTO.fromJS(item));
            }
            this.location = _data["Location"] ? Point.fromJS(_data["Location"]) : <any>undefined;
            this.notes = _data["Notes"];
            this.number = _data["Number"];
            this.formattedNumber = _data["FormattedNumber"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.externalId = _data["ExternalId"];
            this.displayName = _data["DisplayName"];
            this.displayValue = _data["DisplayValue"];
            this.value = _data["Value"];
            this.options = _data["Options"];
            this.choice = _data["Choice"];
        }
    }

    static fromJS(data: any): ExtractedComponentDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractedComponentDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ComponentData_Id"] = this.componentData_Id;
        data["ModelComponentModelId"] = this.modelComponentModelId;
        data["Type"] = this.type;
        data["Image"] = this.image;
        data["Width"] = this.width;
        data["Height"] = this.height;
        if (Array.isArray(this.pictures)) {
            data["Pictures"] = [];
            for (let item of this.pictures)
                data["Pictures"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["Notes"] = this.notes;
        data["Number"] = this.number;
        data["FormattedNumber"] = this.formattedNumber;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["ExternalId"] = this.externalId;
        data["DisplayName"] = this.displayName;
        data["DisplayValue"] = this.displayValue;
        data["Value"] = this.value;
        data["Options"] = this.options;
        data["Choice"] = this.choice;
        return data;
    }
}

export interface IExtractedComponentDataDTO {
    componentData_Id: number;
    modelComponentModelId: number;
    type: ComponentType;
    image?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    pictures?: PictureModelDTO[] | undefined;
    files?: FileModelDTO[] | undefined;
    location?: Point | undefined;
    notes?: string | undefined;
    number?: number | undefined;
    formattedNumber?: string | undefined;
    timestamp?: Date | undefined;
    externalId?: string | undefined;
    displayName?: string | undefined;
    displayValue?: string | undefined;
    value?: string | undefined;
    options?: string | undefined;
    choice?: string | undefined;
}

export class AiPopulateDataModelDTO implements IAiPopulateDataModelDTO {
    extractionType!: ExtractionTypes;
    content!: AiExtractionContentDTO;

    constructor(data?: IAiPopulateDataModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = new AiExtractionContentDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extractionType = _data["ExtractionType"];
            this.content = _data["Content"] ? AiExtractionContentDTO.fromJS(_data["Content"]) : new AiExtractionContentDTO();
        }
    }

    static fromJS(data: any): AiPopulateDataModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AiPopulateDataModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExtractionType"] = this.extractionType;
        data["Content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAiPopulateDataModelDTO {
    extractionType: ExtractionTypes;
    content: AiExtractionContentDTO;
}

export enum ExtractionTypes {
    SingleItem = 0,
    MultipleItems = 1,
    MultipleItemsFromGroupedData = 2,
}

export class AiExtractionContentDTO implements IAiExtractionContentDTO {
    text?: string | undefined;
    url?: string | undefined;
    file?: FileDTO | undefined;

    constructor(data?: IAiExtractionContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["Text"];
            this.url = _data["Url"];
            this.file = _data["File"] ? FileDTO.fromJS(_data["File"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AiExtractionContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AiExtractionContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["Url"] = this.url;
        data["File"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAiExtractionContentDTO {
    text?: string | undefined;
    url?: string | undefined;
    file?: FileDTO | undefined;
}

export class FileDTO implements IFileDTO {
    fileId?: string;
    filename?: string | undefined;

    constructor(data?: IFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["FileId"];
            this.filename = _data["Filename"];
        }
    }

    static fromJS(data: any): FileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileId"] = this.fileId;
        data["Filename"] = this.filename;
        return data;
    }
}

export interface IFileDTO {
    fileId?: string;
    filename?: string | undefined;
}

export class AiPopulateAndShareDataModelResultDTO implements IAiPopulateAndShareDataModelResultDTO {
    jobId?: string | undefined;
    status!: AsyncStatus;
    groopitId?: string;
    error?: string | undefined;

    constructor(data?: IAiPopulateAndShareDataModelResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["JobId"];
            this.status = _data["Status"];
            this.groopitId = _data["GroopitId"];
            this.error = _data["Error"];
        }
    }

    static fromJS(data: any): AiPopulateAndShareDataModelResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AiPopulateAndShareDataModelResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["JobId"] = this.jobId;
        data["Status"] = this.status;
        data["GroopitId"] = this.groopitId;
        data["Error"] = this.error;
        return data;
    }
}

export interface IAiPopulateAndShareDataModelResultDTO {
    jobId?: string | undefined;
    status: AsyncStatus;
    groopitId?: string;
    error?: string | undefined;
}

export class AiPopulateAndShareDataModelInputDTO implements IAiPopulateAndShareDataModelInputDTO {
    unstructuredData?: string | undefined;
    overrideDate?: Date | undefined;

    constructor(data?: IAiPopulateAndShareDataModelInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unstructuredData = _data["UnstructuredData"];
            this.overrideDate = _data["OverrideDate"] ? new Date(_data["OverrideDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AiPopulateAndShareDataModelInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AiPopulateAndShareDataModelInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnstructuredData"] = this.unstructuredData;
        data["OverrideDate"] = this.overrideDate ? this.overrideDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAiPopulateAndShareDataModelInputDTO {
    unstructuredData?: string | undefined;
    overrideDate?: Date | undefined;
}

export class ChatWithYourDataResponse implements IChatWithYourDataResponse {
    conversationId!: string;
    response!: string;
    timestamp!: string;

    constructor(data?: IChatWithYourDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["ConversationId"];
            this.response = _data["Response"];
            this.timestamp = _data["Timestamp"];
        }
    }

    static fromJS(data: any): ChatWithYourDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatWithYourDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConversationId"] = this.conversationId;
        data["Response"] = this.response;
        data["Timestamp"] = this.timestamp;
        return data;
    }
}

export interface IChatWithYourDataResponse {
    conversationId: string;
    response: string;
    timestamp: string;
}

export class ChatWithYourDataErrorResponse extends ChatWithYourDataResponse implements IChatWithYourDataErrorResponse {
    exceededMaximumTokens!: boolean;

    constructor(data?: IChatWithYourDataErrorResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exceededMaximumTokens = _data["ExceededMaximumTokens"];
        }
    }

    static fromJS(data: any): ChatWithYourDataErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatWithYourDataErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExceededMaximumTokens"] = this.exceededMaximumTokens;
        super.toJSON(data);
        return data;
    }
}

export interface IChatWithYourDataErrorResponse extends IChatWithYourDataResponse {
    exceededMaximumTokens: boolean;
}

export class StartChatWithYourDataRequest implements IStartChatWithYourDataRequest {
    filter!: GroopitFilterDTO;
    chatWithYourDataEntry!: ChatWithYourDataEntry;
    conversationTitle!: string;

    constructor(data?: IStartChatWithYourDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filter = new GroopitFilterDTO();
            this.chatWithYourDataEntry = new ChatWithYourDataEntry();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? GroopitFilterDTO.fromJS(_data["Filter"]) : new GroopitFilterDTO();
            this.chatWithYourDataEntry = _data["ChatWithYourDataEntry"] ? ChatWithYourDataEntry.fromJS(_data["ChatWithYourDataEntry"]) : new ChatWithYourDataEntry();
            this.conversationTitle = _data["ConversationTitle"];
        }
    }

    static fromJS(data: any): StartChatWithYourDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartChatWithYourDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["ChatWithYourDataEntry"] = this.chatWithYourDataEntry ? this.chatWithYourDataEntry.toJSON() : <any>undefined;
        data["ConversationTitle"] = this.conversationTitle;
        return data;
    }
}

export interface IStartChatWithYourDataRequest {
    filter: GroopitFilterDTO;
    chatWithYourDataEntry: ChatWithYourDataEntry;
    conversationTitle: string;
}

export class GroopitFilterDTO implements IGroopitFilterDTO {
    assignments?: GroopitFilterAssignmentDTO[] | undefined;
    choices?: string[] | undefined;
    choicesOperation?: CollectionOperationType;
    creators?: string[] | undefined;
    endDate?: Date | undefined;
    feedFilterDataTypes?: FeedFilterDataTypes[] | undefined;
    query?: string[] | undefined;
    startDate?: Date | undefined;
    tags?: string[] | undefined;
    tagsOperation?: CollectionOperationType;

    constructor(data?: IGroopitFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(GroopitFilterAssignmentDTO.fromJS(item));
            }
            if (Array.isArray(_data["Choices"])) {
                this.choices = [] as any;
                for (let item of _data["Choices"])
                    this.choices!.push(item);
            }
            this.choicesOperation = _data["ChoicesOperation"];
            if (Array.isArray(_data["Creators"])) {
                this.creators = [] as any;
                for (let item of _data["Creators"])
                    this.creators!.push(item);
            }
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["FeedFilterDataTypes"])) {
                this.feedFilterDataTypes = [] as any;
                for (let item of _data["FeedFilterDataTypes"])
                    this.feedFilterDataTypes!.push(item);
            }
            if (Array.isArray(_data["Query"])) {
                this.query = [] as any;
                for (let item of _data["Query"])
                    this.query!.push(item);
            }
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["Tags"])) {
                this.tags = [] as any;
                for (let item of _data["Tags"])
                    this.tags!.push(item);
            }
            this.tagsOperation = _data["TagsOperation"];
        }
    }

    static fromJS(data: any): GroopitFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        if (Array.isArray(this.choices)) {
            data["Choices"] = [];
            for (let item of this.choices)
                data["Choices"].push(item);
        }
        data["ChoicesOperation"] = this.choicesOperation;
        if (Array.isArray(this.creators)) {
            data["Creators"] = [];
            for (let item of this.creators)
                data["Creators"].push(item);
        }
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.feedFilterDataTypes)) {
            data["FeedFilterDataTypes"] = [];
            for (let item of this.feedFilterDataTypes)
                data["FeedFilterDataTypes"].push(item);
        }
        if (Array.isArray(this.query)) {
            data["Query"] = [];
            for (let item of this.query)
                data["Query"].push(item);
        }
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["Tags"] = [];
            for (let item of this.tags)
                data["Tags"].push(item);
        }
        data["TagsOperation"] = this.tagsOperation;
        return data;
    }
}

export interface IGroopitFilterDTO {
    assignments?: GroopitFilterAssignmentDTO[] | undefined;
    choices?: string[] | undefined;
    choicesOperation?: CollectionOperationType;
    creators?: string[] | undefined;
    endDate?: Date | undefined;
    feedFilterDataTypes?: FeedFilterDataTypes[] | undefined;
    query?: string[] | undefined;
    startDate?: Date | undefined;
    tags?: string[] | undefined;
    tagsOperation?: CollectionOperationType;
}

export class GroopitFilterAssignmentDTO implements IGroopitFilterAssignmentDTO {
    id?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    creators?: string[] | undefined;
    componentModelIds?: number[] | undefined;
    components?: GroopitFilterComponentDTO[] | undefined;

    constructor(data?: IGroopitFilterAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["Creators"])) {
                this.creators = [] as any;
                for (let item of _data["Creators"])
                    this.creators!.push(item);
            }
            if (Array.isArray(_data["ComponentModelIds"])) {
                this.componentModelIds = [] as any;
                for (let item of _data["ComponentModelIds"])
                    this.componentModelIds!.push(item);
            }
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(GroopitFilterComponentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroopitFilterAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitFilterAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.creators)) {
            data["Creators"] = [];
            for (let item of this.creators)
                data["Creators"].push(item);
        }
        if (Array.isArray(this.componentModelIds)) {
            data["ComponentModelIds"] = [];
            for (let item of this.componentModelIds)
                data["ComponentModelIds"].push(item);
        }
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroopitFilterAssignmentDTO {
    id?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    creators?: string[] | undefined;
    componentModelIds?: number[] | undefined;
    components?: GroopitFilterComponentDTO[] | undefined;
}

export class GroopitFilterComponentDTO implements IGroopitFilterComponentDTO {
    componentModelId?: number;
    operation?: ComponentOperationType;
    value?: any | undefined;

    constructor(data?: IGroopitFilterComponentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentModelId = _data["ComponentModelId"];
            this.operation = _data["Operation"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): GroopitFilterComponentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitFilterComponentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ComponentModelId"] = this.componentModelId;
        data["Operation"] = this.operation;
        data["Value"] = this.value;
        return data;
    }
}

export interface IGroopitFilterComponentDTO {
    componentModelId?: number;
    operation?: ComponentOperationType;
    value?: any | undefined;
}

export enum ComponentOperationType {
    Any = 0,
    None = 1,
    Equal = 2,
    LessThan = 3,
    GreaterThan = 4,
    LessThanOrEqual = 5,
    GreaterThanOrEqual = 6,
    Contains = 7,
    AnyOf = 8,
    AllOf = 9,
    FollowUpComplete = 10,
    FollowUpIncomplete = 11,
}

export enum CollectionOperationType {
    AllOf = 0,
    AnyOf = 1,
}

export enum FeedFilterDataTypes {
    Picture = 0,
    Location = 1,
    Text = 2,
    Tags = 3,
    DateTime = 5,
    Lists = 6,
    Numbers = 8,
    Pictures = 9,
    Files = 11,
    SaveToSalesforce = 12,
    FollowUpMarkedComplete = -5,
    FollowUpNotMarkedComplete = -4,
    Flags = -3,
    Comments = -2,
}

export class ChatWithYourDataLineEntry implements IChatWithYourDataLineEntry {
    chatLine!: string;
    role!: AuthorRole;
    timestamp!: Date;

    constructor(data?: IChatWithYourDataLineEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new AuthorRole();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatLine = _data["ChatLine"];
            this.role = _data["Role"] ? AuthorRole.fromJS(_data["Role"]) : new AuthorRole();
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatWithYourDataLineEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ChatWithYourDataLineEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ChatLine"] = this.chatLine;
        data["Role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatWithYourDataLineEntry {
    chatLine: string;
    role: AuthorRole;
    timestamp: Date;
}

export class ChatWithYourDataEntry extends ChatWithYourDataLineEntry implements IChatWithYourDataEntry {
    conversationId?: string | undefined;
    groopId!: string;
    userId!: string;

    constructor(data?: IChatWithYourDataEntry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conversationId = _data["ConversationId"];
            this.groopId = _data["GroopId"];
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): ChatWithYourDataEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ChatWithYourDataEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConversationId"] = this.conversationId;
        data["GroopId"] = this.groopId;
        data["UserId"] = this.userId;
        super.toJSON(data);
        return data;
    }
}

export interface IChatWithYourDataEntry extends IChatWithYourDataLineEntry {
    conversationId?: string | undefined;
    groopId: string;
    userId: string;
}

/** A description of the intended purpose of a message within a chat completions interaction. */
export class AuthorRole implements IAuthorRole {
    /** Gets the label associated with this AuthorRole. */
    label?: string;

    constructor(data?: IAuthorRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): AuthorRole {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Label"] = this.label;
        return data;
    }
}

/** A description of the intended purpose of a message within a chat completions interaction. */
export interface IAuthorRole {
    /** Gets the label associated with this AuthorRole. */
    label?: string;
}

export class ChatWithYourDataConversation implements IChatWithYourDataConversation {
    conversationId!: string;
    conversationTitle!: string;
    feedFilter!: GroopitFilterDisplayDTO;
    groopId!: string;
    initialInput!: string;
    timestamp!: Date;
    userId!: string;

    constructor(data?: IChatWithYourDataConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.feedFilter = new GroopitFilterDisplayDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["ConversationId"];
            this.conversationTitle = _data["ConversationTitle"];
            this.feedFilter = _data["FeedFilter"] ? GroopitFilterDisplayDTO.fromJS(_data["FeedFilter"]) : new GroopitFilterDisplayDTO();
            this.groopId = _data["GroopId"];
            this.initialInput = _data["InitialInput"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): ChatWithYourDataConversation {
        data = typeof data === 'object' ? data : {};
        let result = new ChatWithYourDataConversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConversationId"] = this.conversationId;
        data["ConversationTitle"] = this.conversationTitle;
        data["FeedFilter"] = this.feedFilter ? this.feedFilter.toJSON() : <any>undefined;
        data["GroopId"] = this.groopId;
        data["InitialInput"] = this.initialInput;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["UserId"] = this.userId;
        return data;
    }
}

export interface IChatWithYourDataConversation {
    conversationId: string;
    conversationTitle: string;
    feedFilter: GroopitFilterDisplayDTO;
    groopId: string;
    initialInput: string;
    timestamp: Date;
    userId: string;
}

export class GroopitFilterDisplayDTO implements IGroopitFilterDisplayDTO {
    assignments!: GroopitFilterAssignmentDisplayDTO[];
    choices!: string[];
    choicesOperation!: CollectionOperationType;
    creators!: UserDTO[];
    dateRange?: DatePickerRangeDTO | undefined;
    feedFilterDataTypes!: FeedFilterDataTypes[];
    query!: string[];
    tags!: string[];
    tagsOperation!: CollectionOperationType;

    constructor(data?: IGroopitFilterDisplayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignments = [];
            this.choices = [];
            this.choicesOperation = CollectionOperationType.AllOf;
            this.creators = [];
            this.feedFilterDataTypes = [];
            this.query = [];
            this.tags = [];
            this.tagsOperation = CollectionOperationType.AllOf;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(GroopitFilterAssignmentDisplayDTO.fromJS(item));
            }
            if (Array.isArray(_data["Choices"])) {
                this.choices = [] as any;
                for (let item of _data["Choices"])
                    this.choices!.push(item);
            }
            this.choicesOperation = _data["ChoicesOperation"] !== undefined ? _data["ChoicesOperation"] : CollectionOperationType.AllOf;
            if (Array.isArray(_data["Creators"])) {
                this.creators = [] as any;
                for (let item of _data["Creators"])
                    this.creators!.push(UserDTO.fromJS(item));
            }
            this.dateRange = _data["DateRange"] ? DatePickerRangeDTO.fromJS(_data["DateRange"]) : <any>undefined;
            if (Array.isArray(_data["FeedFilterDataTypes"])) {
                this.feedFilterDataTypes = [] as any;
                for (let item of _data["FeedFilterDataTypes"])
                    this.feedFilterDataTypes!.push(item);
            }
            if (Array.isArray(_data["Query"])) {
                this.query = [] as any;
                for (let item of _data["Query"])
                    this.query!.push(item);
            }
            if (Array.isArray(_data["Tags"])) {
                this.tags = [] as any;
                for (let item of _data["Tags"])
                    this.tags!.push(item);
            }
            this.tagsOperation = _data["TagsOperation"] !== undefined ? _data["TagsOperation"] : CollectionOperationType.AllOf;
        }
    }

    static fromJS(data: any): GroopitFilterDisplayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitFilterDisplayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        if (Array.isArray(this.choices)) {
            data["Choices"] = [];
            for (let item of this.choices)
                data["Choices"].push(item);
        }
        data["ChoicesOperation"] = this.choicesOperation;
        if (Array.isArray(this.creators)) {
            data["Creators"] = [];
            for (let item of this.creators)
                data["Creators"].push(item.toJSON());
        }
        data["DateRange"] = this.dateRange ? this.dateRange.toJSON() : <any>undefined;
        if (Array.isArray(this.feedFilterDataTypes)) {
            data["FeedFilterDataTypes"] = [];
            for (let item of this.feedFilterDataTypes)
                data["FeedFilterDataTypes"].push(item);
        }
        if (Array.isArray(this.query)) {
            data["Query"] = [];
            for (let item of this.query)
                data["Query"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["Tags"] = [];
            for (let item of this.tags)
                data["Tags"].push(item);
        }
        data["TagsOperation"] = this.tagsOperation;
        return data;
    }
}

export interface IGroopitFilterDisplayDTO {
    assignments: GroopitFilterAssignmentDisplayDTO[];
    choices: string[];
    choicesOperation: CollectionOperationType;
    creators: UserDTO[];
    dateRange?: DatePickerRangeDTO | undefined;
    feedFilterDataTypes: FeedFilterDataTypes[];
    query: string[];
    tags: string[];
    tagsOperation: CollectionOperationType;
}

export class GroopitFilterAssignmentDisplayDTO implements IGroopitFilterAssignmentDisplayDTO {
    id!: string;
    title!: string;
    assignmentPhotoUrl!: string;
    dateRange?: DatePickerRangeDTO | undefined;
    creators?: UserDTO[] | undefined;
    componentModelIds?: number[] | undefined;
    components?: GroopitFilterComponentDisplayDTO[] | undefined;

    constructor(data?: IGroopitFilterAssignmentDisplayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            this.assignmentPhotoUrl = _data["AssignmentPhotoUrl"];
            this.dateRange = _data["DateRange"] ? DatePickerRangeDTO.fromJS(_data["DateRange"]) : <any>undefined;
            if (Array.isArray(_data["Creators"])) {
                this.creators = [] as any;
                for (let item of _data["Creators"])
                    this.creators!.push(UserDTO.fromJS(item));
            }
            if (Array.isArray(_data["ComponentModelIds"])) {
                this.componentModelIds = [] as any;
                for (let item of _data["ComponentModelIds"])
                    this.componentModelIds!.push(item);
            }
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(GroopitFilterComponentDisplayDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroopitFilterAssignmentDisplayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitFilterAssignmentDisplayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["AssignmentPhotoUrl"] = this.assignmentPhotoUrl;
        data["DateRange"] = this.dateRange ? this.dateRange.toJSON() : <any>undefined;
        if (Array.isArray(this.creators)) {
            data["Creators"] = [];
            for (let item of this.creators)
                data["Creators"].push(item.toJSON());
        }
        if (Array.isArray(this.componentModelIds)) {
            data["ComponentModelIds"] = [];
            for (let item of this.componentModelIds)
                data["ComponentModelIds"].push(item);
        }
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroopitFilterAssignmentDisplayDTO {
    id: string;
    title: string;
    assignmentPhotoUrl: string;
    dateRange?: DatePickerRangeDTO | undefined;
    creators?: UserDTO[] | undefined;
    componentModelIds?: number[] | undefined;
    components?: GroopitFilterComponentDisplayDTO[] | undefined;
}

export class DatePickerRangeDTO implements IDatePickerRangeDTO {
    id!: DatePickerRangeId;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IDatePickerRangeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DatePickerRangeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DatePickerRangeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDatePickerRangeDTO {
    id: DatePickerRangeId;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export enum DatePickerRangeId {
    LastDay = "LastDay",
    CurrentWeek = "CurrentWeek",
    PreviousWeek = "PreviousWeek",
    CurrentMonth = "CurrentMonth",
    PreviousMonth = "PreviousMonth",
    CurrentQuarter = "CurrentQuarter",
    PreviousQuarter = "PreviousQuarter",
    CurrentYear = "CurrentYear",
    PreviousYear = "PreviousYear",
    Custom = "Custom",
}

export class GroopitFilterComponentDisplayDTO implements IGroopitFilterComponentDisplayDTO {
    componentModelId!: number;
    componentModelType!: ComponentType;
    componentModelDescription!: string;
    operation!: ComponentOperationType;
    value?: any | undefined;

    constructor(data?: IGroopitFilterComponentDisplayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentModelId = _data["ComponentModelId"];
            this.componentModelType = _data["ComponentModelType"];
            this.componentModelDescription = _data["ComponentModelDescription"];
            this.operation = _data["Operation"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): GroopitFilterComponentDisplayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitFilterComponentDisplayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ComponentModelId"] = this.componentModelId;
        data["ComponentModelType"] = this.componentModelType;
        data["ComponentModelDescription"] = this.componentModelDescription;
        data["Operation"] = this.operation;
        data["Value"] = this.value;
        return data;
    }
}

export interface IGroopitFilterComponentDisplayDTO {
    componentModelId: number;
    componentModelType: ComponentType;
    componentModelDescription: string;
    operation: ComponentOperationType;
    value?: any | undefined;
}

export class ModifyAssignmentDTO implements IModifyAssignmentDTO {
    groop!: string;
    name!: string;
    description?: string | undefined;
    components!: ComponentModelDTO[];
    deletedComponents?: number[] | undefined;
    isActive!: boolean;
    allowsContributors!: boolean;
    title!: string;
    assignmentPhoto?: string | undefined;

    constructor(data?: IModifyAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.components = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groop = _data["Groop"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(ComponentModelDTO.fromJS(item));
            }
            if (Array.isArray(_data["DeletedComponents"])) {
                this.deletedComponents = [] as any;
                for (let item of _data["DeletedComponents"])
                    this.deletedComponents!.push(item);
            }
            this.isActive = _data["IsActive"];
            this.allowsContributors = _data["AllowsContributors"];
            this.title = _data["Title"];
            this.assignmentPhoto = _data["AssignmentPhoto"];
        }
    }

    static fromJS(data: any): ModifyAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Groop"] = this.groop;
        data["Name"] = this.name;
        data["Description"] = this.description;
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedComponents)) {
            data["DeletedComponents"] = [];
            for (let item of this.deletedComponents)
                data["DeletedComponents"].push(item);
        }
        data["IsActive"] = this.isActive;
        data["AllowsContributors"] = this.allowsContributors;
        data["Title"] = this.title;
        data["AssignmentPhoto"] = this.assignmentPhoto;
        return data;
    }
}

export interface IModifyAssignmentDTO {
    groop: string;
    name: string;
    description?: string | undefined;
    components: ComponentModelDTO[];
    deletedComponents?: number[] | undefined;
    isActive: boolean;
    allowsContributors: boolean;
    title: string;
    assignmentPhoto?: string | undefined;
}

export class ColumnMappings implements IColumnMappings {
    mappings!: ColumnMapping[];
    csvHeaders!: string[];
    separator!: string;

    constructor(data?: IColumnMappings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mappings = [];
            this.csvHeaders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Mappings"])) {
                this.mappings = [] as any;
                for (let item of _data["Mappings"])
                    this.mappings!.push(ColumnMapping.fromJS(item));
            }
            if (Array.isArray(_data["CsvHeaders"])) {
                this.csvHeaders = [] as any;
                for (let item of _data["CsvHeaders"])
                    this.csvHeaders!.push(item);
            }
            this.separator = _data["Separator"];
        }
    }

    static fromJS(data: any): ColumnMappings {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnMappings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mappings)) {
            data["Mappings"] = [];
            for (let item of this.mappings)
                data["Mappings"].push(item.toJSON());
        }
        if (Array.isArray(this.csvHeaders)) {
            data["CsvHeaders"] = [];
            for (let item of this.csvHeaders)
                data["CsvHeaders"].push(item);
        }
        data["Separator"] = this.separator;
        return data;
    }
}

export interface IColumnMappings {
    mappings: ColumnMapping[];
    csvHeaders: string[];
    separator: string;
}

export class ColumnMapping implements IColumnMapping {
    modelId?: number;
    columnIndex?: number;
    addNewItems!: boolean;
    separator?: string | undefined;
    defaultTimeZone?: string | undefined;

    constructor(data?: IColumnMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["ModelId"];
            this.columnIndex = _data["ColumnIndex"];
            this.addNewItems = _data["AddNewItems"];
            this.separator = _data["Separator"];
            this.defaultTimeZone = _data["DefaultTimeZone"];
        }
    }

    static fromJS(data: any): ColumnMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ModelId"] = this.modelId;
        data["ColumnIndex"] = this.columnIndex;
        data["AddNewItems"] = this.addNewItems;
        data["Separator"] = this.separator;
        data["DefaultTimeZone"] = this.defaultTimeZone;
        return data;
    }
}

export interface IColumnMapping {
    modelId?: number;
    columnIndex?: number;
    addNewItems: boolean;
    separator?: string | undefined;
    defaultTimeZone?: string | undefined;
}

export class BulkImportResult implements IBulkImportResult {
    /** Total number of rows in the CSV processed */
    rows?: number;
    /** Total number of groopits successfully created */
    groopitsCreated?: number;
    /** Total number of rows skipped due to no data */
    rowsSkipped?: number;
    /** Total number of rows that had errors and could not be imported */
    rowErrors?: number;
    /** Unique identifier for the CSV blob where all errors are logged
null if no errors occurred */
    errorBlobName?: string | undefined;
    /** Total time taken to process the import */
    duration?: string;

    constructor(data?: IBulkImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rows = _data["Rows"];
            this.groopitsCreated = _data["GroopitsCreated"];
            this.rowsSkipped = _data["RowsSkipped"];
            this.rowErrors = _data["RowErrors"];
            this.errorBlobName = _data["ErrorBlobName"];
            this.duration = _data["Duration"];
        }
    }

    static fromJS(data: any): BulkImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rows"] = this.rows;
        data["GroopitsCreated"] = this.groopitsCreated;
        data["RowsSkipped"] = this.rowsSkipped;
        data["RowErrors"] = this.rowErrors;
        data["ErrorBlobName"] = this.errorBlobName;
        data["Duration"] = this.duration;
        return data;
    }
}

export interface IBulkImportResult {
    /** Total number of rows in the CSV processed */
    rows?: number;
    /** Total number of groopits successfully created */
    groopitsCreated?: number;
    /** Total number of rows skipped due to no data */
    rowsSkipped?: number;
    /** Total number of rows that had errors and could not be imported */
    rowErrors?: number;
    /** Unique identifier for the CSV blob where all errors are logged
null if no errors occurred */
    errorBlobName?: string | undefined;
    /** Total time taken to process the import */
    duration?: string;
}

export class Group implements IGroup {
    /** The unique ID of the group. */
    id!: string;
    /** The name of the group. */
    name!: string;
    /** The purpose of the group. */
    purpose!: string;
    /** The URL of the group's thumbnail image. */
    avatarUrl!: string;
    /** The URL of the group. */
    groupUrl!: string;
    /** The number of users in the group. */
    usersCount!: number;
    /** The number of insights shared in the group. */
    insightsCount!: number;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.purpose = _data["Purpose"];
            this.avatarUrl = _data["AvatarUrl"];
            this.groupUrl = _data["GroupUrl"];
            this.usersCount = _data["UsersCount"];
            this.insightsCount = _data["InsightsCount"];
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Purpose"] = this.purpose;
        data["AvatarUrl"] = this.avatarUrl;
        data["GroupUrl"] = this.groupUrl;
        data["UsersCount"] = this.usersCount;
        data["InsightsCount"] = this.insightsCount;
        return data;
    }
}

export interface IGroup {
    /** The unique ID of the group. */
    id: string;
    /** The name of the group. */
    name: string;
    /** The purpose of the group. */
    purpose: string;
    /** The URL of the group's thumbnail image. */
    avatarUrl: string;
    /** The URL of the group. */
    groupUrl: string;
    /** The number of users in the group. */
    usersCount: number;
    /** The number of insights shared in the group. */
    insightsCount: number;
}

export class DataModel implements IDataModel {
    /** The unique ID of the data model. */
    id!: string;
    /** The title of the data model. */
    title!: string;
    /** The description of the data model. */
    direction!: string;
    /** The URL of the data model's thumbnail image. */
    avatarUrl!: string;
    /** The URL of the data model. */
    dataModelUrl!: string;
    /** The number of insights shared in the data model. */
    insightsCount!: number;
    /** The number of insights shared in the data model today. */
    insightsCountToday!: number;

    constructor(data?: IDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            this.direction = _data["Direction"];
            this.avatarUrl = _data["AvatarUrl"];
            this.dataModelUrl = _data["DataModelUrl"];
            this.insightsCount = _data["InsightsCount"];
            this.insightsCountToday = _data["InsightsCountToday"];
        }
    }

    static fromJS(data: any): DataModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["Direction"] = this.direction;
        data["AvatarUrl"] = this.avatarUrl;
        data["DataModelUrl"] = this.dataModelUrl;
        data["InsightsCount"] = this.insightsCount;
        data["InsightsCountToday"] = this.insightsCountToday;
        return data;
    }
}

export interface IDataModel {
    /** The unique ID of the data model. */
    id: string;
    /** The title of the data model. */
    title: string;
    /** The description of the data model. */
    direction: string;
    /** The URL of the data model's thumbnail image. */
    avatarUrl: string;
    /** The URL of the data model. */
    dataModelUrl: string;
    /** The number of insights shared in the data model. */
    insightsCount: number;
    /** The number of insights shared in the data model today. */
    insightsCountToday: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["Type"];
            this.title = _data["Title"];
            this.status = _data["Status"];
            this.detail = _data["Detail"];
            this.instance = _data["Instance"];
            if (_data["Extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["Extensions"]) {
                    if (_data["Extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["Extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Type"] = this.type;
        data["Title"] = this.title;
        data["Status"] = this.status;
        data["Detail"] = this.detail;
        data["Instance"] = this.instance;
        if (this.extensions) {
            data["Extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["Extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

/** A version of the Groop object that contains only the necessary data for exporting GroopIt data via the API */
export class GroopDataExportDTO implements IGroopDataExportDTO {
    id?: string;
    name?: string | undefined;
    purpose?: string | undefined;

    constructor(data?: IGroopDataExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.purpose = _data["purpose"];
        }
    }

    static fromJS(data: any): GroopDataExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopDataExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["purpose"] = this.purpose;
        return data;
    }
}

/** A version of the Groop object that contains only the necessary data for exporting GroopIt data via the API */
export interface IGroopDataExportDTO {
    id?: string;
    name?: string | undefined;
    purpose?: string | undefined;
}

/** A version of the Assignment object that contains only the necessary data for exporting GroopIt data via the API */
export class AssignmentDataExportDTO implements IAssignmentDataExportDTO {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    fields?: ComponentModelDataExportDTO[] | undefined;

    constructor(data?: IAssignmentDataExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(ComponentModelDataExportDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignmentDataExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentDataExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

/** A version of the Assignment object that contains only the necessary data for exporting GroopIt data via the API */
export interface IAssignmentDataExportDTO {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    fields?: ComponentModelDataExportDTO[] | undefined;
}

/** A version of the ComponentModel object that contains only the necessary data for exporting GroopIt data via the API */
export class ComponentModelDataExportDTO implements IComponentModelDataExportDTO {
    id?: number;
    type?: ComponentType2;
    hiddenFromMembers?: boolean;
    description?: string | undefined;

    constructor(data?: IComponentModelDataExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.hiddenFromMembers = _data["hiddenFromMembers"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ComponentModelDataExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentModelDataExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["hiddenFromMembers"] = this.hiddenFromMembers;
        data["description"] = this.description;
        return data;
    }
}

/** A version of the ComponentModel object that contains only the necessary data for exporting GroopIt data via the API */
export interface IComponentModelDataExportDTO {
    id?: number;
    type?: ComponentType2;
    hiddenFromMembers?: boolean;
    description?: string | undefined;
}

export enum ComponentType2 {
    Picture = "Picture",
    Location = "Location",
    Note = "Note",
    MultipleChoice = "MultipleChoice",
    Obsolete = "Obsolete",
    DateTime = "DateTime",
    MultipleChoiceExtended = "MultipleChoiceExtended",
    Obsolete2 = "Obsolete2",
    FixedDecimal = "FixedDecimal",
    PictureSet = "PictureSet",
    Table = "Table",
    FileSet = "FileSet",
    SaveToSalesforce = "SaveToSalesforce",
    InheritedData = "InheritedData",
    FollowUpRequest = "FollowUpRequest",
    Unknown = "Unknown",
}

/** An insight shared to a data model */
export class GroopItDataExportDTO implements IGroopItDataExportDTO {
    /** Unique identifier for the insight */
    id?: string;
    /** Unique identifier for the data model */
    formId?: string;
    /** Title of the data model */
    formName?: string | undefined;
    /** Unique identifier for the group */
    groupId?: string;
    /** Link to the insight */
    reportUrl?: string | undefined;
    /** Link to the data model */
    formUrl?: string | undefined;
    /** Link to the group */
    groupUrl?: string | undefined;
    /** Person who shared the insight */
    creator?: UserDataExportDTO | undefined;
    /** Time the insight was shared */
    createTime?: Date;
    /** Time the insight was last edited */
    lastEditTime?: Date | undefined;
    /** Person who last edited the insight */
    lastEditor?: UserDataExportDTO | undefined;
    /** Flag for the insight */
    flag?: string | undefined;
    /** Data fields */
    data?: ComponentDataDataExportDTO[] | undefined;
    /** Text representation of the insight */
    dataBlob?: string | undefined;
    /** Text representation of the insight without hidden fields */
    filteredDataBlob?: string | undefined;

    constructor(data?: IGroopItDataExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.groupId = _data["groupId"];
            this.reportUrl = _data["reportUrl"];
            this.formUrl = _data["formUrl"];
            this.groupUrl = _data["groupUrl"];
            this.creator = _data["creator"] ? UserDataExportDTO.fromJS(_data["creator"]) : <any>undefined;
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.lastEditTime = _data["lastEditTime"] ? new Date(_data["lastEditTime"].toString()) : <any>undefined;
            this.lastEditor = _data["lastEditor"] ? UserDataExportDTO.fromJS(_data["lastEditor"]) : <any>undefined;
            this.flag = _data["flag"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ComponentDataDataExportDTO.fromJS(item));
            }
            this.dataBlob = _data["dataBlob"];
            this.filteredDataBlob = _data["filteredDataBlob"];
        }
    }

    static fromJS(data: any): GroopItDataExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopItDataExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["groupId"] = this.groupId;
        data["reportUrl"] = this.reportUrl;
        data["formUrl"] = this.formUrl;
        data["groupUrl"] = this.groupUrl;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["lastEditTime"] = this.lastEditTime ? this.lastEditTime.toISOString() : <any>undefined;
        data["lastEditor"] = this.lastEditor ? this.lastEditor.toJSON() : <any>undefined;
        data["flag"] = this.flag;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["dataBlob"] = this.dataBlob;
        data["filteredDataBlob"] = this.filteredDataBlob;
        return data;
    }
}

/** An insight shared to a data model */
export interface IGroopItDataExportDTO {
    /** Unique identifier for the insight */
    id?: string;
    /** Unique identifier for the data model */
    formId?: string;
    /** Title of the data model */
    formName?: string | undefined;
    /** Unique identifier for the group */
    groupId?: string;
    /** Link to the insight */
    reportUrl?: string | undefined;
    /** Link to the data model */
    formUrl?: string | undefined;
    /** Link to the group */
    groupUrl?: string | undefined;
    /** Person who shared the insight */
    creator?: UserDataExportDTO | undefined;
    /** Time the insight was shared */
    createTime?: Date;
    /** Time the insight was last edited */
    lastEditTime?: Date | undefined;
    /** Person who last edited the insight */
    lastEditor?: UserDataExportDTO | undefined;
    /** Flag for the insight */
    flag?: string | undefined;
    /** Data fields */
    data?: ComponentDataDataExportDTO[] | undefined;
    /** Text representation of the insight */
    dataBlob?: string | undefined;
    /** Text representation of the insight without hidden fields */
    filteredDataBlob?: string | undefined;
}

/** A version of the ApplicationUser object that contains only the necessary data for exporting GroopIt data via the API */
export class UserDataExportDTO implements IUserDataExportDTO {
    /** Unique user identifier */
    id?: string | undefined;
    /** User name */
    name?: string | undefined;
    /** User email */
    email?: string | undefined;

    constructor(data?: IUserDataExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserDataExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

/** A version of the ApplicationUser object that contains only the necessary data for exporting GroopIt data via the API */
export interface IUserDataExportDTO {
    /** Unique user identifier */
    id?: string | undefined;
    /** User name */
    name?: string | undefined;
    /** User email */
    email?: string | undefined;
}

/** A version of the ComponentData object that contains only the necessary data for exporting GroopIt data via the API */
export class ComponentDataDataExportDTO implements IComponentDataDataExportDTO {
    field?: ComponentModelDataExportDTO | undefined;
    displayValue?: string | undefined;
    stringValue?: string | undefined;

    constructor(data?: IComponentDataDataExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"] ? ComponentModelDataExportDTO.fromJS(_data["field"]) : <any>undefined;
            this.displayValue = _data["displayValue"];
            this.stringValue = _data["stringValue"];
        }
    }

    static fromJS(data: any): ComponentDataDataExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentDataDataExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        data["displayValue"] = this.displayValue;
        data["stringValue"] = this.stringValue;
        return data;
    }
}

/** A version of the ComponentData object that contains only the necessary data for exporting GroopIt data via the API */
export interface IComponentDataDataExportDTO {
    field?: ComponentModelDataExportDTO | undefined;
    displayValue?: string | undefined;
    stringValue?: string | undefined;
}

export class GroopItWebhookDTO implements IGroopItWebhookDTO {
    id?: number;
    creatorId?: string | undefined;
    groupId?: string;
    formId?: string | undefined;
    callback?: string | undefined;
    eventType?: EventType;

    constructor(data?: IGroopItWebhookDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.creatorId = _data["CreatorId"];
            this.groupId = _data["GroupId"];
            this.formId = _data["FormId"];
            this.callback = _data["Callback"];
            this.eventType = _data["EventType"];
        }
    }

    static fromJS(data: any): GroopItWebhookDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopItWebhookDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatorId"] = this.creatorId;
        data["GroupId"] = this.groupId;
        data["FormId"] = this.formId;
        data["Callback"] = this.callback;
        data["EventType"] = this.eventType;
        return data;
    }
}

export interface IGroopItWebhookDTO {
    id?: number;
    creatorId?: string | undefined;
    groupId?: string;
    formId?: string | undefined;
    callback?: string | undefined;
    eventType?: EventType;
}

export enum EventType {
    CREATE_REPORT = 0,
    UPDATE_REPORT = 1,
    NEW_MEMBER = 2,
}

export class GroopItWebhookSubscribe implements IGroopItWebhookSubscribe {
    callback?: string | undefined;
    eventType?: EventType;

    constructor(data?: IGroopItWebhookSubscribe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callback = _data["Callback"];
            this.eventType = _data["EventType"];
        }
    }

    static fromJS(data: any): GroopItWebhookSubscribe {
        data = typeof data === 'object' ? data : {};
        let result = new GroopItWebhookSubscribe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Callback"] = this.callback;
        data["EventType"] = this.eventType;
        return data;
    }
}

export interface IGroopItWebhookSubscribe {
    callback?: string | undefined;
    eventType?: EventType;
}

/** Contains information about when members join linked groups */
export class LinkedGroupMembershipDataExportDTO implements ILinkedGroupMembershipDataExportDTO {
    id?: string | undefined;
    member?: UserDataExportDTO | undefined;
    group?: GroopDataExportDTO | undefined;
    role?: UserRole;

    constructor(data?: ILinkedGroupMembershipDataExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.member = _data["member"] ? UserDataExportDTO.fromJS(_data["member"]) : <any>undefined;
            this.group = _data["group"] ? GroopDataExportDTO.fromJS(_data["group"]) : <any>undefined;
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): LinkedGroupMembershipDataExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedGroupMembershipDataExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

/** Contains information about when members join linked groups */
export interface ILinkedGroupMembershipDataExportDTO {
    id?: string | undefined;
    member?: UserDataExportDTO | undefined;
    group?: GroopDataExportDTO | undefined;
    role?: UserRole;
}

export enum UserRole {
    None = "None",
    Member = "Member",
    Moderator = "Moderator",
    Organizer = "Organizer",
    Administrator = "Administrator",
    Invited = "Invited",
    JoinRequested = "JoinRequested",
    Publisher = "Publisher",
}

export class UserGroopsDTO implements IUserGroopsDTO {
    owned?: GroopDTO[] | undefined;
    member?: GroopDTO[] | undefined;
    invited?: GroopDTO[] | undefined;
    requested?: GroopDTO[] | undefined;

    constructor(data?: IUserGroopsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Owned"])) {
                this.owned = [] as any;
                for (let item of _data["Owned"])
                    this.owned!.push(GroopDTO.fromJS(item));
            }
            if (Array.isArray(_data["Member"])) {
                this.member = [] as any;
                for (let item of _data["Member"])
                    this.member!.push(GroopDTO.fromJS(item));
            }
            if (Array.isArray(_data["Invited"])) {
                this.invited = [] as any;
                for (let item of _data["Invited"])
                    this.invited!.push(GroopDTO.fromJS(item));
            }
            if (Array.isArray(_data["Requested"])) {
                this.requested = [] as any;
                for (let item of _data["Requested"])
                    this.requested!.push(GroopDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserGroopsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroopsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.owned)) {
            data["Owned"] = [];
            for (let item of this.owned)
                data["Owned"].push(item.toJSON());
        }
        if (Array.isArray(this.member)) {
            data["Member"] = [];
            for (let item of this.member)
                data["Member"].push(item.toJSON());
        }
        if (Array.isArray(this.invited)) {
            data["Invited"] = [];
            for (let item of this.invited)
                data["Invited"].push(item.toJSON());
        }
        if (Array.isArray(this.requested)) {
            data["Requested"] = [];
            for (let item of this.requested)
                data["Requested"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserGroopsDTO {
    owned?: GroopDTO[] | undefined;
    member?: GroopDTO[] | undefined;
    invited?: GroopDTO[] | undefined;
    requested?: GroopDTO[] | undefined;
}

export class GroopDTO implements IGroopDTO {
    id!: string;
    name?: string | undefined;
    by?: string | undefined;
    email?: string | undefined;
    avatarUrl?: string | undefined;
    creationTime?: Date;
    memberCount?: number;
    groopitCount?: number;
    newGroopitCount?: number;
    newsCount?: number;
    vizCount?: number;
    description?: string | undefined;
    assignments?: AssignmentDTO[] | undefined;
    isPublic?: boolean;
    link?: string | undefined;
    linkText?: string | undefined;
    groopItFlagChoices?: string | undefined;
    isShareable?: boolean;
    friendlyUrl?: string | undefined;
    joinUrl?: string | undefined;
    owners?: UserDTO[] | undefined;
    role?: UserRole2;
    coverPhotoUrl?: string | undefined;
    whyItMatters?: string | undefined;
    howToContribute?: string | undefined;
    subscriptionLevel?: SubscriptionLevel;
    subscriptionOwner?: UserDTO | undefined;
    subscriptionExpiration?: Date | undefined;
    parent?: GroopDTO | undefined;
    memberForm?: MemberFormDTO | undefined;
    salesforceConnection?: SFConnectionDTO | undefined;
    isSaveToSalesforceV2?: boolean;

    constructor(data?: IGroopDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.by = _data["By"];
            this.email = _data["Email"];
            this.avatarUrl = _data["AvatarUrl"];
            this.creationTime = _data["CreationTime"] ? new Date(_data["CreationTime"].toString()) : <any>undefined;
            this.memberCount = _data["MemberCount"];
            this.groopitCount = _data["GroopitCount"];
            this.newGroopitCount = _data["NewGroopitCount"];
            this.newsCount = _data["NewsCount"];
            this.vizCount = _data["VizCount"];
            this.description = _data["Description"];
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(AssignmentDTO.fromJS(item));
            }
            this.isPublic = _data["IsPublic"];
            this.link = _data["Link"];
            this.linkText = _data["LinkText"];
            this.groopItFlagChoices = _data["GroopItFlagChoices"];
            this.isShareable = _data["IsShareable"];
            this.friendlyUrl = _data["FriendlyUrl"];
            this.joinUrl = _data["JoinUrl"];
            if (Array.isArray(_data["Owners"])) {
                this.owners = [] as any;
                for (let item of _data["Owners"])
                    this.owners!.push(UserDTO.fromJS(item));
            }
            this.role = _data["Role"];
            this.coverPhotoUrl = _data["CoverPhotoUrl"];
            this.whyItMatters = _data["WhyItMatters"];
            this.howToContribute = _data["HowToContribute"];
            this.subscriptionLevel = _data["SubscriptionLevel"];
            this.subscriptionOwner = _data["SubscriptionOwner"] ? UserDTO.fromJS(_data["SubscriptionOwner"]) : <any>undefined;
            this.subscriptionExpiration = _data["SubscriptionExpiration"] ? new Date(_data["SubscriptionExpiration"].toString()) : <any>undefined;
            this.parent = _data["Parent"] ? GroopDTO.fromJS(_data["Parent"]) : <any>undefined;
            this.memberForm = _data["MemberForm"] ? MemberFormDTO.fromJS(_data["MemberForm"]) : <any>undefined;
            this.salesforceConnection = _data["SalesforceConnection"] ? SFConnectionDTO.fromJS(_data["SalesforceConnection"]) : <any>undefined;
            this.isSaveToSalesforceV2 = _data["IsSaveToSalesforceV2"];
        }
    }

    static fromJS(data: any): GroopDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["By"] = this.by;
        data["Email"] = this.email;
        data["AvatarUrl"] = this.avatarUrl;
        data["CreationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["MemberCount"] = this.memberCount;
        data["GroopitCount"] = this.groopitCount;
        data["NewGroopitCount"] = this.newGroopitCount;
        data["NewsCount"] = this.newsCount;
        data["VizCount"] = this.vizCount;
        data["Description"] = this.description;
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        data["IsPublic"] = this.isPublic;
        data["Link"] = this.link;
        data["LinkText"] = this.linkText;
        data["GroopItFlagChoices"] = this.groopItFlagChoices;
        data["IsShareable"] = this.isShareable;
        data["FriendlyUrl"] = this.friendlyUrl;
        data["JoinUrl"] = this.joinUrl;
        if (Array.isArray(this.owners)) {
            data["Owners"] = [];
            for (let item of this.owners)
                data["Owners"].push(item.toJSON());
        }
        data["Role"] = this.role;
        data["CoverPhotoUrl"] = this.coverPhotoUrl;
        data["WhyItMatters"] = this.whyItMatters;
        data["HowToContribute"] = this.howToContribute;
        data["SubscriptionLevel"] = this.subscriptionLevel;
        data["SubscriptionOwner"] = this.subscriptionOwner ? this.subscriptionOwner.toJSON() : <any>undefined;
        data["SubscriptionExpiration"] = this.subscriptionExpiration ? this.subscriptionExpiration.toISOString() : <any>undefined;
        data["Parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["MemberForm"] = this.memberForm ? this.memberForm.toJSON() : <any>undefined;
        data["SalesforceConnection"] = this.salesforceConnection ? this.salesforceConnection.toJSON() : <any>undefined;
        data["IsSaveToSalesforceV2"] = this.isSaveToSalesforceV2;
        return data;
    }
}

export interface IGroopDTO {
    id: string;
    name?: string | undefined;
    by?: string | undefined;
    email?: string | undefined;
    avatarUrl?: string | undefined;
    creationTime?: Date;
    memberCount?: number;
    groopitCount?: number;
    newGroopitCount?: number;
    newsCount?: number;
    vizCount?: number;
    description?: string | undefined;
    assignments?: AssignmentDTO[] | undefined;
    isPublic?: boolean;
    link?: string | undefined;
    linkText?: string | undefined;
    groopItFlagChoices?: string | undefined;
    isShareable?: boolean;
    friendlyUrl?: string | undefined;
    joinUrl?: string | undefined;
    owners?: UserDTO[] | undefined;
    role?: UserRole2;
    coverPhotoUrl?: string | undefined;
    whyItMatters?: string | undefined;
    howToContribute?: string | undefined;
    subscriptionLevel?: SubscriptionLevel;
    subscriptionOwner?: UserDTO | undefined;
    subscriptionExpiration?: Date | undefined;
    parent?: GroopDTO | undefined;
    memberForm?: MemberFormDTO | undefined;
    salesforceConnection?: SFConnectionDTO | undefined;
    isSaveToSalesforceV2?: boolean;
}

export enum UserRole2 {
    None = 0,
    Member = 1,
    Moderator = 2,
    Organizer = 3,
    Administrator = 4,
    Invited = 5,
    JoinRequested = 6,
    Publisher = 7,
}

/** Indicates the user's current subscription level */
export enum SubscriptionLevel {
    Free = 0,
    Essential = 1,
    Professional = 2,
    Enterprise = 3,
}

export class MemberFormDTO implements IMemberFormDTO {
    id!: string;
    groop!: string;
    consent?: string | undefined;
    components?: ComponentModelDTO[] | undefined;

    constructor(data?: IMemberFormDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.groop = _data["Groop"];
            this.consent = _data["Consent"];
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(ComponentModelDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberFormDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MemberFormDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Groop"] = this.groop;
        data["Consent"] = this.consent;
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMemberFormDTO {
    id: string;
    groop: string;
    consent?: string | undefined;
    components?: ComponentModelDTO[] | undefined;
}

/** DTO to represent a connection to a salesforce organization */
export class SFConnectionDTO implements ISFConnectionDTO {
    id!: string;
    name!: string;
    baseEndpoint?: string | undefined;

    constructor(data?: ISFConnectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.baseEndpoint = _data["BaseEndpoint"];
        }
    }

    static fromJS(data: any): SFConnectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SFConnectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["BaseEndpoint"] = this.baseEndpoint;
        return data;
    }
}

/** DTO to represent a connection to a salesforce organization */
export interface ISFConnectionDTO {
    id: string;
    name: string;
    baseEndpoint?: string | undefined;
}

/** A lighter weight version of the GroopDTO that is used by the React front end to set the group context */
export class GroopContextDTO implements IGroopContextDTO {
    id!: string;
    name?: string | undefined;
    avatarUrl?: string | undefined;
    email?: string | undefined;
    groopItFlagChoices?: string | undefined;
    isOwner!: boolean;
    salesforceConnection?: SFConnectionDTO | undefined;
    assignments?: AssignmentDTO[] | undefined;

    constructor(data?: IGroopContextDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.avatarUrl = _data["AvatarUrl"];
            this.email = _data["Email"];
            this.groopItFlagChoices = _data["GroopItFlagChoices"];
            this.isOwner = _data["IsOwner"];
            this.salesforceConnection = _data["SalesforceConnection"] ? SFConnectionDTO.fromJS(_data["SalesforceConnection"]) : <any>undefined;
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(AssignmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroopContextDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopContextDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["AvatarUrl"] = this.avatarUrl;
        data["Email"] = this.email;
        data["GroopItFlagChoices"] = this.groopItFlagChoices;
        data["IsOwner"] = this.isOwner;
        data["SalesforceConnection"] = this.salesforceConnection ? this.salesforceConnection.toJSON() : <any>undefined;
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        return data;
    }
}

/** A lighter weight version of the GroopDTO that is used by the React front end to set the group context */
export interface IGroopContextDTO {
    id: string;
    name?: string | undefined;
    avatarUrl?: string | undefined;
    email?: string | undefined;
    groopItFlagChoices?: string | undefined;
    isOwner: boolean;
    salesforceConnection?: SFConnectionDTO | undefined;
    assignments?: AssignmentDTO[] | undefined;
}

export class GroopEditDTO implements IGroopEditDTO {
    id?: string;
    name?: string | undefined;
    by?: string | undefined;
    email?: string | undefined;
    description?: string | undefined;
    isPublic?: boolean;
    link?: string | undefined;
    linkText?: string | undefined;
    groopItFlagChoices?: string | undefined;
    isShareable?: boolean;
    friendlyUrl?: string | undefined;
    whyItMatters?: string | undefined;
    howToContribute?: string | undefined;

    constructor(data?: IGroopEditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.by = _data["By"];
            this.email = _data["Email"];
            this.description = _data["Description"];
            this.isPublic = _data["IsPublic"];
            this.link = _data["Link"];
            this.linkText = _data["LinkText"];
            this.groopItFlagChoices = _data["GroopItFlagChoices"];
            this.isShareable = _data["IsShareable"];
            this.friendlyUrl = _data["FriendlyUrl"];
            this.whyItMatters = _data["WhyItMatters"];
            this.howToContribute = _data["HowToContribute"];
        }
    }

    static fromJS(data: any): GroopEditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopEditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["By"] = this.by;
        data["Email"] = this.email;
        data["Description"] = this.description;
        data["IsPublic"] = this.isPublic;
        data["Link"] = this.link;
        data["LinkText"] = this.linkText;
        data["GroopItFlagChoices"] = this.groopItFlagChoices;
        data["IsShareable"] = this.isShareable;
        data["FriendlyUrl"] = this.friendlyUrl;
        data["WhyItMatters"] = this.whyItMatters;
        data["HowToContribute"] = this.howToContribute;
        return data;
    }
}

export interface IGroopEditDTO {
    id?: string;
    name?: string | undefined;
    by?: string | undefined;
    email?: string | undefined;
    description?: string | undefined;
    isPublic?: boolean;
    link?: string | undefined;
    linkText?: string | undefined;
    groopItFlagChoices?: string | undefined;
    isShareable?: boolean;
    friendlyUrl?: string | undefined;
    whyItMatters?: string | undefined;
    howToContribute?: string | undefined;
}

export class GroopCreateDTO implements IGroopCreateDTO {
    name!: string;
    description?: string | undefined;
    /** Base64 encoded image data. */
    avatarImage?: string | undefined;
    /** Base64 encoded image data. */
    coverImage?: string | undefined;

    constructor(data?: IGroopCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.avatarImage = _data["AvatarImage"];
            this.coverImage = _data["CoverImage"];
        }
    }

    static fromJS(data: any): GroopCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["AvatarImage"] = this.avatarImage;
        data["CoverImage"] = this.coverImage;
        return data;
    }
}

export interface IGroopCreateDTO {
    name: string;
    description?: string | undefined;
    /** Base64 encoded image data. */
    avatarImage?: string | undefined;
    /** Base64 encoded image data. */
    coverImage?: string | undefined;
}

export class GroopAvatar implements IGroopAvatar {
    avatarUrl?: string | undefined;

    constructor(data?: IGroopAvatar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatarUrl = _data["AvatarUrl"];
        }
    }

    static fromJS(data: any): GroopAvatar {
        data = typeof data === 'object' ? data : {};
        let result = new GroopAvatar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AvatarUrl"] = this.avatarUrl;
        return data;
    }
}

export interface IGroopAvatar {
    avatarUrl?: string | undefined;
}

export class GroopitDataDTO implements IGroopitDataDTO {
    id!: string;
    timestamp!: Date;
    assignmentId!: string;

    constructor(data?: IGroopitDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.assignmentId = _data["AssignmentId"];
        }
    }

    static fromJS(data: any): GroopitDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["AssignmentId"] = this.assignmentId;
        return data;
    }
}

export interface IGroopitDataDTO {
    id: string;
    timestamp: Date;
    assignmentId: string;
}

export class GroopitPagedResults implements IGroopitPagedResults {
    token?: string | undefined;
    totalCount!: number;
    starterImage?: string | undefined;
    starterLink?: string | undefined;
    /** Whether any GroopIts are not visible due to the current subscription level */
    isLimitedBySubscription!: boolean;
    /** Whether at least one pinned GroopIt is not visible due to the current subscription level */
    isPinnedLimitedBySubscription?: boolean;
    groopits!: GroopItModel_V1[];
    assignments!: { [key: string]: AssignmentDTO; };
    hasHiddenFields!: boolean;

    constructor(data?: IGroopitPagedResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groopits = [];
            this.assignments = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.totalCount = _data["TotalCount"];
            this.starterImage = _data["StarterImage"];
            this.starterLink = _data["StarterLink"];
            this.isLimitedBySubscription = _data["IsLimitedBySubscription"];
            this.isPinnedLimitedBySubscription = _data["IsPinnedLimitedBySubscription"];
            if (Array.isArray(_data["Groopits"])) {
                this.groopits = [] as any;
                for (let item of _data["Groopits"])
                    this.groopits!.push(GroopItModel_V1.fromJS(item));
            }
            if (_data["Assignments"]) {
                this.assignments = {} as any;
                for (let key in _data["Assignments"]) {
                    if (_data["Assignments"].hasOwnProperty(key))
                        (<any>this.assignments)![key] = _data["Assignments"][key] ? AssignmentDTO.fromJS(_data["Assignments"][key]) : new AssignmentDTO();
                }
            }
            this.hasHiddenFields = _data["HasHiddenFields"];
        }
    }

    static fromJS(data: any): GroopitPagedResults {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitPagedResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["TotalCount"] = this.totalCount;
        data["StarterImage"] = this.starterImage;
        data["StarterLink"] = this.starterLink;
        data["IsLimitedBySubscription"] = this.isLimitedBySubscription;
        data["IsPinnedLimitedBySubscription"] = this.isPinnedLimitedBySubscription;
        if (Array.isArray(this.groopits)) {
            data["Groopits"] = [];
            for (let item of this.groopits)
                data["Groopits"].push(item.toJSON());
        }
        if (this.assignments) {
            data["Assignments"] = {};
            for (let key in this.assignments) {
                if (this.assignments.hasOwnProperty(key))
                    (<any>data["Assignments"])[key] = this.assignments[key] ? this.assignments[key].toJSON() : <any>undefined;
            }
        }
        data["HasHiddenFields"] = this.hasHiddenFields;
        return data;
    }
}

export interface IGroopitPagedResults {
    token?: string | undefined;
    totalCount: number;
    starterImage?: string | undefined;
    starterLink?: string | undefined;
    /** Whether any GroopIts are not visible due to the current subscription level */
    isLimitedBySubscription: boolean;
    /** Whether at least one pinned GroopIt is not visible due to the current subscription level */
    isPinnedLimitedBySubscription?: boolean;
    groopits: GroopItModel_V1[];
    assignments: { [key: string]: AssignmentDTO; };
    hasHiddenFields: boolean;
}

export class GroopitCountDTO implements IGroopitCountDTO {
    id!: string;
    name!: string;
    active!: boolean;
    counts!: GroopitCount[];

    constructor(data?: IGroopitCountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.counts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
            if (Array.isArray(_data["Counts"])) {
                this.counts = [] as any;
                for (let item of _data["Counts"])
                    this.counts!.push(GroopitCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroopitCountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitCountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        if (Array.isArray(this.counts)) {
            data["Counts"] = [];
            for (let item of this.counts)
                data["Counts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroopitCountDTO {
    id: string;
    name: string;
    active: boolean;
    counts: GroopitCount[];
}

export class GroopitCount implements IGroopitCount {
    date!: Date;
    count!: number;

    constructor(data?: IGroopitCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): GroopitCount {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Count"] = this.count;
        return data;
    }
}

export interface IGroopitCount {
    date: Date;
    count: number;
}

export class UserWithEmailDTO extends UserDTO implements IUserWithEmailDTO {
    email?: string | undefined;

    constructor(data?: IUserWithEmailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): UserWithEmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithEmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        super.toJSON(data);
        return data;
    }
}

export interface IUserWithEmailDTO extends IUserDTO {
    email?: string | undefined;
}

export class GroupUsersDTO implements IGroupUsersDTO {
    organizers!: ParticipantDTO[];
    users!: ParticipantDTO[];

    constructor(data?: IGroupUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organizers = [];
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Organizers"])) {
                this.organizers = [] as any;
                for (let item of _data["Organizers"])
                    this.organizers!.push(ParticipantDTO.fromJS(item));
            }
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(ParticipantDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupUsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizers)) {
            data["Organizers"] = [];
            for (let item of this.organizers)
                data["Organizers"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupUsersDTO {
    organizers: ParticipantDTO[];
    users: ParticipantDTO[];
}

export class ParticipantDTO implements IParticipantDTO {
    id!: string;
    friendlyName!: string;
    avatarUrl!: string;
    lastActive?: Date;
    postCount?: number;

    constructor(data?: IParticipantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.friendlyName = _data["FriendlyName"];
            this.avatarUrl = _data["AvatarUrl"];
            this.lastActive = _data["LastActive"] ? new Date(_data["LastActive"].toString()) : <any>undefined;
            this.postCount = _data["PostCount"];
        }
    }

    static fromJS(data: any): ParticipantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FriendlyName"] = this.friendlyName;
        data["AvatarUrl"] = this.avatarUrl;
        data["LastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>undefined;
        data["PostCount"] = this.postCount;
        return data;
    }
}

export interface IParticipantDTO {
    id: string;
    friendlyName: string;
    avatarUrl: string;
    lastActive?: Date;
    postCount?: number;
}

export class MembershipInfo implements IMembershipInfo {
    administrators!: UserWithEmailDTO[];
    owners!: UserWithEmailDTO[];
    membersAndOwners!: UserWithEmailDTO[];
    requests?: ClientInviteRequest[] | undefined;
    invitations?: ClientInvite[] | undefined;
    lastViewed?: { [key: string]: Date; } | undefined;

    constructor(data?: IMembershipInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.administrators = [];
            this.owners = [];
            this.membersAndOwners = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Administrators"])) {
                this.administrators = [] as any;
                for (let item of _data["Administrators"])
                    this.administrators!.push(UserWithEmailDTO.fromJS(item));
            }
            if (Array.isArray(_data["Owners"])) {
                this.owners = [] as any;
                for (let item of _data["Owners"])
                    this.owners!.push(UserWithEmailDTO.fromJS(item));
            }
            if (Array.isArray(_data["MembersAndOwners"])) {
                this.membersAndOwners = [] as any;
                for (let item of _data["MembersAndOwners"])
                    this.membersAndOwners!.push(UserWithEmailDTO.fromJS(item));
            }
            if (Array.isArray(_data["Requests"])) {
                this.requests = [] as any;
                for (let item of _data["Requests"])
                    this.requests!.push(ClientInviteRequest.fromJS(item));
            }
            if (Array.isArray(_data["Invitations"])) {
                this.invitations = [] as any;
                for (let item of _data["Invitations"])
                    this.invitations!.push(ClientInvite.fromJS(item));
            }
            if (_data["LastViewed"]) {
                this.lastViewed = {} as any;
                for (let key in _data["LastViewed"]) {
                    if (_data["LastViewed"].hasOwnProperty(key))
                        (<any>this.lastViewed)![key] = _data["LastViewed"][key] ? new Date(_data["LastViewed"][key].toString()) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): MembershipInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.administrators)) {
            data["Administrators"] = [];
            for (let item of this.administrators)
                data["Administrators"].push(item.toJSON());
        }
        if (Array.isArray(this.owners)) {
            data["Owners"] = [];
            for (let item of this.owners)
                data["Owners"].push(item.toJSON());
        }
        if (Array.isArray(this.membersAndOwners)) {
            data["MembersAndOwners"] = [];
            for (let item of this.membersAndOwners)
                data["MembersAndOwners"].push(item.toJSON());
        }
        if (Array.isArray(this.requests)) {
            data["Requests"] = [];
            for (let item of this.requests)
                data["Requests"].push(item.toJSON());
        }
        if (Array.isArray(this.invitations)) {
            data["Invitations"] = [];
            for (let item of this.invitations)
                data["Invitations"].push(item.toJSON());
        }
        if (this.lastViewed) {
            data["LastViewed"] = {};
            for (let key in this.lastViewed) {
                if (this.lastViewed.hasOwnProperty(key))
                    (<any>data["LastViewed"])[key] = this.lastViewed[key] ? this.lastViewed[key].toISOString() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IMembershipInfo {
    administrators: UserWithEmailDTO[];
    owners: UserWithEmailDTO[];
    membersAndOwners: UserWithEmailDTO[];
    requests?: ClientInviteRequest[] | undefined;
    invitations?: ClientInvite[] | undefined;
    lastViewed?: { [key: string]: Date; } | undefined;
}

export class ClientInviteRequest implements IClientInviteRequest {
    id?: number;
    from?: UserDTO | undefined;
    sent?: Date;

    constructor(data?: IClientInviteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.from = _data["From"] ? UserDTO.fromJS(_data["From"]) : <any>undefined;
            this.sent = _data["Sent"] ? new Date(_data["Sent"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientInviteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInviteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["From"] = this.from ? this.from.toJSON() : <any>undefined;
        data["Sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientInviteRequest {
    id?: number;
    from?: UserDTO | undefined;
    sent?: Date;
}

export class ClientInvite implements IClientInvite {
    id?: number;
    from?: UserDTO | undefined;
    toEmail?: string | undefined;
    sent?: Date;
    seen?: Date | undefined;

    constructor(data?: IClientInvite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.from = _data["From"] ? UserDTO.fromJS(_data["From"]) : <any>undefined;
            this.toEmail = _data["ToEmail"];
            this.sent = _data["Sent"] ? new Date(_data["Sent"].toString()) : <any>undefined;
            this.seen = _data["Seen"] ? new Date(_data["Seen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientInvite {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInvite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["From"] = this.from ? this.from.toJSON() : <any>undefined;
        data["ToEmail"] = this.toEmail;
        data["Sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        data["Seen"] = this.seen ? this.seen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientInvite {
    id?: number;
    from?: UserDTO | undefined;
    toEmail?: string | undefined;
    sent?: Date;
    seen?: Date | undefined;
}

export class InviteModel implements IInviteModel {
    message?: string | undefined;
    emails?: string[] | undefined;

    constructor(data?: IInviteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"];
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): InviteModel {
        data = typeof data === 'object' ? data : {};
        let result = new InviteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message;
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item);
        }
        return data;
    }
}

export interface IInviteModel {
    message?: string | undefined;
    emails?: string[] | undefined;
}

export class VizDTO implements IVizDTO {
    id?: number;
    groopId!: string;
    assignmentId!: string;
    primaryId?: number | undefined;
    filterId?: number | undefined;
    vizType!: VizType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    operation!: OperationType;
    title!: string;
    description?: string | undefined;
    label?: string | undefined;
    startCount?: number;
    goalCount?: number;
    access?: Visibility;
    grouping!: GroupingType;

    constructor(data?: IVizDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.groopId = _data["GroopId"];
            this.assignmentId = _data["AssignmentId"];
            this.primaryId = _data["PrimaryId"];
            this.filterId = _data["FilterId"];
            this.vizType = _data["VizType"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            this.operation = _data["Operation"];
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.label = _data["Label"];
            this.startCount = _data["StartCount"];
            this.goalCount = _data["GoalCount"];
            this.access = _data["Access"];
            this.grouping = _data["Grouping"];
        }
    }

    static fromJS(data: any): VizDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VizDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["GroopId"] = this.groopId;
        data["AssignmentId"] = this.assignmentId;
        data["PrimaryId"] = this.primaryId;
        data["FilterId"] = this.filterId;
        data["VizType"] = this.vizType;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["Operation"] = this.operation;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["Label"] = this.label;
        data["StartCount"] = this.startCount;
        data["GoalCount"] = this.goalCount;
        data["Access"] = this.access;
        data["Grouping"] = this.grouping;
        return data;
    }
}

export interface IVizDTO {
    id?: number;
    groopId: string;
    assignmentId: string;
    primaryId?: number | undefined;
    filterId?: number | undefined;
    vizType: VizType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    operation: OperationType;
    title: string;
    description?: string | undefined;
    label?: string | undefined;
    startCount?: number;
    goalCount?: number;
    access?: Visibility;
    grouping: GroupingType;
}

export enum VizType {
    Map = 0,
    Counter = 1,
    Goal = 2,
    Timeline = 3,
    TagCount = 4,
    Leaderboard = 5,
    ChoiceCount = 6,
    CounterWithTotal = 7,
}

export enum OperationType {
    Count = 0,
    Sum = 1,
    Mean = 2,
    Median = 3,
    Map = 4,
    CountTags = 5,
}

export enum Visibility {
    Members = 0,
    Public = 1,
}

export enum GroupingType {
    None = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
    Quarterly = 4,
    Annually = 5,
}

export class GroopCoverPhoto implements IGroopCoverPhoto {
    coverPhotoUrl?: string | undefined;

    constructor(data?: IGroopCoverPhoto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coverPhotoUrl = _data["CoverPhotoUrl"];
        }
    }

    static fromJS(data: any): GroopCoverPhoto {
        data = typeof data === 'object' ? data : {};
        let result = new GroopCoverPhoto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CoverPhotoUrl"] = this.coverPhotoUrl;
        return data;
    }
}

export interface IGroopCoverPhoto {
    coverPhotoUrl?: string | undefined;
}

export class GroupAccessTokenDTO implements IGroupAccessTokenDTO {
    id!: number;
    token!: string;
    label!: string;
    createdOn!: Date;
    lastUsedOn?: Date | undefined;
    createdBy!: string;
    integration?: string | undefined;
    disabled!: boolean;

    constructor(data?: IGroupAccessTokenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.token = _data["Token"];
            this.label = _data["Label"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.lastUsedOn = _data["LastUsedOn"] ? new Date(_data["LastUsedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.integration = _data["Integration"];
            this.disabled = _data["Disabled"];
        }
    }

    static fromJS(data: any): GroupAccessTokenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupAccessTokenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Token"] = this.token;
        data["Label"] = this.label;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["LastUsedOn"] = this.lastUsedOn ? this.lastUsedOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["Integration"] = this.integration;
        data["Disabled"] = this.disabled;
        return data;
    }
}

export interface IGroupAccessTokenDTO {
    id: number;
    token: string;
    label: string;
    createdOn: Date;
    lastUsedOn?: Date | undefined;
    createdBy: string;
    integration?: string | undefined;
    disabled: boolean;
}

export class KeywordPromptsDTO implements IKeywordPromptsDTO {
    id!: number;
    groopId!: string;
    isDisabled!: boolean;
    keywords!: string;
    prompt!: string;
    isOutlookLinked!: boolean;
    excludedChannels!: { [key: string]: string[]; };
    teamsChannelLinks!: TeamsChannelLinkDTO[];
    slackChannelLinks!: SlackChannelLinkDTO[];

    constructor(data?: IKeywordPromptsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.excludedChannels = {};
            this.teamsChannelLinks = [];
            this.slackChannelLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.groopId = _data["GroopId"];
            this.isDisabled = _data["IsDisabled"];
            this.keywords = _data["Keywords"];
            this.prompt = _data["Prompt"];
            this.isOutlookLinked = _data["IsOutlookLinked"];
            if (_data["ExcludedChannels"]) {
                this.excludedChannels = {} as any;
                for (let key in _data["ExcludedChannels"]) {
                    if (_data["ExcludedChannels"].hasOwnProperty(key))
                        (<any>this.excludedChannels)![key] = _data["ExcludedChannels"][key] !== undefined ? _data["ExcludedChannels"][key] : [];
                }
            }
            if (Array.isArray(_data["TeamsChannelLinks"])) {
                this.teamsChannelLinks = [] as any;
                for (let item of _data["TeamsChannelLinks"])
                    this.teamsChannelLinks!.push(TeamsChannelLinkDTO.fromJS(item));
            }
            if (Array.isArray(_data["SlackChannelLinks"])) {
                this.slackChannelLinks = [] as any;
                for (let item of _data["SlackChannelLinks"])
                    this.slackChannelLinks!.push(SlackChannelLinkDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KeywordPromptsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KeywordPromptsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["GroopId"] = this.groopId;
        data["IsDisabled"] = this.isDisabled;
        data["Keywords"] = this.keywords;
        data["Prompt"] = this.prompt;
        data["IsOutlookLinked"] = this.isOutlookLinked;
        if (this.excludedChannels) {
            data["ExcludedChannels"] = {};
            for (let key in this.excludedChannels) {
                if (this.excludedChannels.hasOwnProperty(key))
                    (<any>data["ExcludedChannels"])[key] = (<any>this.excludedChannels)[key];
            }
        }
        if (Array.isArray(this.teamsChannelLinks)) {
            data["TeamsChannelLinks"] = [];
            for (let item of this.teamsChannelLinks)
                data["TeamsChannelLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.slackChannelLinks)) {
            data["SlackChannelLinks"] = [];
            for (let item of this.slackChannelLinks)
                data["SlackChannelLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKeywordPromptsDTO {
    id: number;
    groopId: string;
    isDisabled: boolean;
    keywords: string;
    prompt: string;
    isOutlookLinked: boolean;
    excludedChannels: { [key: string]: string[]; };
    teamsChannelLinks: TeamsChannelLinkDTO[];
    slackChannelLinks: SlackChannelLinkDTO[];
}

export class TeamsChannelLinkDTO implements ITeamsChannelLinkDTO {
    id!: number;
    connection!: TeamsConnectionDTO;
    teamId?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;
    groopId!: string;
    existingMembersOnly!: boolean;

    constructor(data?: ITeamsChannelLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.connection = new TeamsConnectionDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.connection = _data["Connection"] ? TeamsConnectionDTO.fromJS(_data["Connection"]) : new TeamsConnectionDTO();
            this.teamId = _data["TeamId"];
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
            this.groopId = _data["GroopId"];
            this.existingMembersOnly = _data["ExistingMembersOnly"];
        }
    }

    static fromJS(data: any): TeamsChannelLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TeamsChannelLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
        data["TeamId"] = this.teamId;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        data["GroopId"] = this.groopId;
        data["ExistingMembersOnly"] = this.existingMembersOnly;
        return data;
    }
}

export interface ITeamsChannelLinkDTO {
    id: number;
    connection: TeamsConnectionDTO;
    teamId?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;
    groopId: string;
    existingMembersOnly: boolean;
}

export class TeamsConnectionDTO implements ITeamsConnectionDTO {
    id!: string;
    name?: string | undefined;
    botChannels!: TeamsChannelDTO[];

    constructor(data?: ITeamsConnectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.botChannels = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["BotChannels"])) {
                this.botChannels = [] as any;
                for (let item of _data["BotChannels"])
                    this.botChannels!.push(TeamsChannelDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamsConnectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TeamsConnectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.botChannels)) {
            data["BotChannels"] = [];
            for (let item of this.botChannels)
                data["BotChannels"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamsConnectionDTO {
    id: string;
    name?: string | undefined;
    botChannels: TeamsChannelDTO[];
}

export class TeamsChannelDTO implements ITeamsChannelDTO {
    connectionId!: string;
    teamId?: string | undefined;
    teamName?: string | undefined;
    channelId!: string;
    channelName!: string;

    constructor(data?: ITeamsChannelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionId = _data["ConnectionId"];
            this.teamId = _data["TeamId"];
            this.teamName = _data["TeamName"];
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
        }
    }

    static fromJS(data: any): TeamsChannelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TeamsChannelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectionId"] = this.connectionId;
        data["TeamId"] = this.teamId;
        data["TeamName"] = this.teamName;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        return data;
    }
}

export interface ITeamsChannelDTO {
    connectionId: string;
    teamId?: string | undefined;
    teamName?: string | undefined;
    channelId: string;
    channelName: string;
}

export class SlackChannelLinkDTO implements ISlackChannelLinkDTO {
    id!: number;
    connection!: SlackConnectionDTO;
    channelId?: string | undefined;
    channelName?: string | undefined;
    groopId!: string;
    existingMembersOnly!: boolean;

    constructor(data?: ISlackChannelLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.connection = new SlackConnectionDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.connection = _data["Connection"] ? SlackConnectionDTO.fromJS(_data["Connection"]) : new SlackConnectionDTO();
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
            this.groopId = _data["GroopId"];
            this.existingMembersOnly = _data["ExistingMembersOnly"];
        }
    }

    static fromJS(data: any): SlackChannelLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SlackChannelLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        data["GroopId"] = this.groopId;
        data["ExistingMembersOnly"] = this.existingMembersOnly;
        return data;
    }
}

export interface ISlackChannelLinkDTO {
    id: number;
    connection: SlackConnectionDTO;
    channelId?: string | undefined;
    channelName?: string | undefined;
    groopId: string;
    existingMembersOnly: boolean;
}

export class SlackConnectionDTO implements ISlackConnectionDTO {
    id!: string;
    name?: string | undefined;
    version!: SlackAppVersion;
    botChannels!: SlackChannelDTO[];

    constructor(data?: ISlackConnectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.botChannels = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.version = _data["Version"];
            if (Array.isArray(_data["BotChannels"])) {
                this.botChannels = [] as any;
                for (let item of _data["BotChannels"])
                    this.botChannels!.push(SlackChannelDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlackConnectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SlackConnectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Version"] = this.version;
        if (Array.isArray(this.botChannels)) {
            data["BotChannels"] = [];
            for (let item of this.botChannels)
                data["BotChannels"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlackConnectionDTO {
    id: string;
    name?: string | undefined;
    version: SlackAppVersion;
    botChannels: SlackChannelDTO[];
}

export enum SlackAppVersion {
    Any = 0,
    CreateReports = 0,
    KeywordPrompts = 1,
    ChannelNotifications = 2,
    KeywordPromptsV2 = 3,
    None = -1,
}

export class SlackChannelDTO implements ISlackChannelDTO {
    connectionId!: string;
    id!: string;
    name!: string;
    isPrivate?: boolean;

    constructor(data?: ISlackChannelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionId = _data["ConnectionId"];
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.isPrivate = _data["IsPrivate"];
        }
    }

    static fromJS(data: any): SlackChannelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SlackChannelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectionId"] = this.connectionId;
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["IsPrivate"] = this.isPrivate;
        return data;
    }
}

export interface ISlackChannelDTO {
    connectionId: string;
    id: string;
    name: string;
    isPrivate?: boolean;
}

export class CreateKeywordPromptsDTO implements ICreateKeywordPromptsDTO {
    isDisabled!: boolean;
    keywords!: string;
    prompt!: string;
    isOutlookLinked?: boolean;
    excludedChannels!: { [key: string]: string[]; };
    teamsChannelLinks!: number[];
    slackChannelLinks!: number[];

    constructor(data?: ICreateKeywordPromptsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.excludedChannels = {};
            this.teamsChannelLinks = [];
            this.slackChannelLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDisabled = _data["IsDisabled"];
            this.keywords = _data["Keywords"];
            this.prompt = _data["Prompt"];
            this.isOutlookLinked = _data["IsOutlookLinked"];
            if (_data["ExcludedChannels"]) {
                this.excludedChannels = {} as any;
                for (let key in _data["ExcludedChannels"]) {
                    if (_data["ExcludedChannels"].hasOwnProperty(key))
                        (<any>this.excludedChannels)![key] = _data["ExcludedChannels"][key] !== undefined ? _data["ExcludedChannels"][key] : [];
                }
            }
            if (Array.isArray(_data["TeamsChannelLinks"])) {
                this.teamsChannelLinks = [] as any;
                for (let item of _data["TeamsChannelLinks"])
                    this.teamsChannelLinks!.push(item);
            }
            if (Array.isArray(_data["SlackChannelLinks"])) {
                this.slackChannelLinks = [] as any;
                for (let item of _data["SlackChannelLinks"])
                    this.slackChannelLinks!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateKeywordPromptsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKeywordPromptsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsDisabled"] = this.isDisabled;
        data["Keywords"] = this.keywords;
        data["Prompt"] = this.prompt;
        data["IsOutlookLinked"] = this.isOutlookLinked;
        if (this.excludedChannels) {
            data["ExcludedChannels"] = {};
            for (let key in this.excludedChannels) {
                if (this.excludedChannels.hasOwnProperty(key))
                    (<any>data["ExcludedChannels"])[key] = (<any>this.excludedChannels)[key];
            }
        }
        if (Array.isArray(this.teamsChannelLinks)) {
            data["TeamsChannelLinks"] = [];
            for (let item of this.teamsChannelLinks)
                data["TeamsChannelLinks"].push(item);
        }
        if (Array.isArray(this.slackChannelLinks)) {
            data["SlackChannelLinks"] = [];
            for (let item of this.slackChannelLinks)
                data["SlackChannelLinks"].push(item);
        }
        return data;
    }
}

export interface ICreateKeywordPromptsDTO {
    isDisabled: boolean;
    keywords: string;
    prompt: string;
    isOutlookLinked?: boolean;
    excludedChannels: { [key: string]: string[]; };
    teamsChannelLinks: number[];
    slackChannelLinks: number[];
}

export class SalesforceFieldDTO implements ISalesforceFieldDTO {
    length?: number;
    name?: string | undefined;
    type?: string | undefined;
    defaultValue?: any | undefined;
    inlineHelpText?: any | undefined;
    writeRequiresMasterRead?: boolean;
    precision?: number;
    unique?: boolean;
    controllerName?: any | undefined;
    deprecatedAndHidden?: boolean;
    createable?: boolean;
    updateable?: boolean;
    externalId?: boolean;
    idLookup?: boolean;
    nameField?: boolean;
    sortable?: boolean;
    filterable?: boolean;
    restrictedPicklist?: boolean;
    caseSensitive?: boolean;
    relationshipName?: string | undefined;
    byteLength?: number;
    label?: string | undefined;
    calculated?: boolean;
    scale?: number;
    picklistValues?: any[] | undefined;
    autoNumber?: boolean;
    nillable?: boolean;
    displayLocationInDecimal?: boolean;
    cascadeDelete?: boolean;
    restrictedDelete?: boolean;
    calculatedFormula?: any | undefined;
    defaultValueFormula?: any | undefined;
    defaultedOnCreate?: boolean;
    digits?: number;
    groupable?: boolean;
    permissionable?: boolean;
    referenceTo?: string[] | undefined;
    relationshipOrder?: any | undefined;
    soapType?: string | undefined;
    dependentPicklist?: boolean;
    namePointing?: boolean;
    custom?: boolean;
    htmlFormatted?: boolean;

    constructor(data?: ISalesforceFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.length = _data["length"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.defaultValue = _data["defaultValue"];
            this.inlineHelpText = _data["inlineHelpText"];
            this.writeRequiresMasterRead = _data["writeRequiresMasterRead"];
            this.precision = _data["precision"];
            this.unique = _data["unique"];
            this.controllerName = _data["controllerName"];
            this.deprecatedAndHidden = _data["deprecatedAndHidden"];
            this.createable = _data["createable"];
            this.updateable = _data["updateable"];
            this.externalId = _data["externalId"];
            this.idLookup = _data["idLookup"];
            this.nameField = _data["nameField"];
            this.sortable = _data["sortable"];
            this.filterable = _data["filterable"];
            this.restrictedPicklist = _data["restrictedPicklist"];
            this.caseSensitive = _data["caseSensitive"];
            this.relationshipName = _data["relationshipName"];
            this.byteLength = _data["byteLength"];
            this.label = _data["label"];
            this.calculated = _data["calculated"];
            this.scale = _data["scale"];
            if (Array.isArray(_data["picklistValues"])) {
                this.picklistValues = [] as any;
                for (let item of _data["picklistValues"])
                    this.picklistValues!.push(item);
            }
            this.autoNumber = _data["autoNumber"];
            this.nillable = _data["nillable"];
            this.displayLocationInDecimal = _data["displayLocationInDecimal"];
            this.cascadeDelete = _data["cascadeDelete"];
            this.restrictedDelete = _data["restrictedDelete"];
            this.calculatedFormula = _data["calculatedFormula"];
            this.defaultValueFormula = _data["defaultValueFormula"];
            this.defaultedOnCreate = _data["defaultedOnCreate"];
            this.digits = _data["digits"];
            this.groupable = _data["groupable"];
            this.permissionable = _data["permissionable"];
            if (Array.isArray(_data["referenceTo"])) {
                this.referenceTo = [] as any;
                for (let item of _data["referenceTo"])
                    this.referenceTo!.push(item);
            }
            this.relationshipOrder = _data["relationshipOrder"];
            this.soapType = _data["soapType"];
            this.dependentPicklist = _data["dependentPicklist"];
            this.namePointing = _data["namePointing"];
            this.custom = _data["custom"];
            this.htmlFormatted = _data["htmlFormatted"];
        }
    }

    static fromJS(data: any): SalesforceFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesforceFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["name"] = this.name;
        data["type"] = this.type;
        data["defaultValue"] = this.defaultValue;
        data["inlineHelpText"] = this.inlineHelpText;
        data["writeRequiresMasterRead"] = this.writeRequiresMasterRead;
        data["precision"] = this.precision;
        data["unique"] = this.unique;
        data["controllerName"] = this.controllerName;
        data["deprecatedAndHidden"] = this.deprecatedAndHidden;
        data["createable"] = this.createable;
        data["updateable"] = this.updateable;
        data["externalId"] = this.externalId;
        data["idLookup"] = this.idLookup;
        data["nameField"] = this.nameField;
        data["sortable"] = this.sortable;
        data["filterable"] = this.filterable;
        data["restrictedPicklist"] = this.restrictedPicklist;
        data["caseSensitive"] = this.caseSensitive;
        data["relationshipName"] = this.relationshipName;
        data["byteLength"] = this.byteLength;
        data["label"] = this.label;
        data["calculated"] = this.calculated;
        data["scale"] = this.scale;
        if (Array.isArray(this.picklistValues)) {
            data["picklistValues"] = [];
            for (let item of this.picklistValues)
                data["picklistValues"].push(item);
        }
        data["autoNumber"] = this.autoNumber;
        data["nillable"] = this.nillable;
        data["displayLocationInDecimal"] = this.displayLocationInDecimal;
        data["cascadeDelete"] = this.cascadeDelete;
        data["restrictedDelete"] = this.restrictedDelete;
        data["calculatedFormula"] = this.calculatedFormula;
        data["defaultValueFormula"] = this.defaultValueFormula;
        data["defaultedOnCreate"] = this.defaultedOnCreate;
        data["digits"] = this.digits;
        data["groupable"] = this.groupable;
        data["permissionable"] = this.permissionable;
        if (Array.isArray(this.referenceTo)) {
            data["referenceTo"] = [];
            for (let item of this.referenceTo)
                data["referenceTo"].push(item);
        }
        data["relationshipOrder"] = this.relationshipOrder;
        data["soapType"] = this.soapType;
        data["dependentPicklist"] = this.dependentPicklist;
        data["namePointing"] = this.namePointing;
        data["custom"] = this.custom;
        data["htmlFormatted"] = this.htmlFormatted;
        return data;
    }
}

export interface ISalesforceFieldDTO {
    length?: number;
    name?: string | undefined;
    type?: string | undefined;
    defaultValue?: any | undefined;
    inlineHelpText?: any | undefined;
    writeRequiresMasterRead?: boolean;
    precision?: number;
    unique?: boolean;
    controllerName?: any | undefined;
    deprecatedAndHidden?: boolean;
    createable?: boolean;
    updateable?: boolean;
    externalId?: boolean;
    idLookup?: boolean;
    nameField?: boolean;
    sortable?: boolean;
    filterable?: boolean;
    restrictedPicklist?: boolean;
    caseSensitive?: boolean;
    relationshipName?: string | undefined;
    byteLength?: number;
    label?: string | undefined;
    calculated?: boolean;
    scale?: number;
    picklistValues?: any[] | undefined;
    autoNumber?: boolean;
    nillable?: boolean;
    displayLocationInDecimal?: boolean;
    cascadeDelete?: boolean;
    restrictedDelete?: boolean;
    calculatedFormula?: any | undefined;
    defaultValueFormula?: any | undefined;
    defaultedOnCreate?: boolean;
    digits?: number;
    groupable?: boolean;
    permissionable?: boolean;
    referenceTo?: string[] | undefined;
    relationshipOrder?: any | undefined;
    soapType?: string | undefined;
    dependentPicklist?: boolean;
    namePointing?: boolean;
    custom?: boolean;
    htmlFormatted?: boolean;
}

export class NamedGroopitFilterDisplayDTO implements INamedGroopitFilterDisplayDTO {
    id!: number;
    name!: string;
    isPublished!: boolean;
    creator!: UserDTO;
    filter!: GroopitFilterDisplayDTO;

    constructor(data?: INamedGroopitFilterDisplayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.creator = new UserDTO();
            this.filter = new GroopitFilterDisplayDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.isPublished = _data["IsPublished"];
            this.creator = _data["Creator"] ? UserDTO.fromJS(_data["Creator"]) : new UserDTO();
            this.filter = _data["Filter"] ? GroopitFilterDisplayDTO.fromJS(_data["Filter"]) : new GroopitFilterDisplayDTO();
        }
    }

    static fromJS(data: any): NamedGroopitFilterDisplayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NamedGroopitFilterDisplayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["IsPublished"] = this.isPublished;
        data["Creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface INamedGroopitFilterDisplayDTO {
    id: number;
    name: string;
    isPublished: boolean;
    creator: UserDTO;
    filter: GroopitFilterDisplayDTO;
}

export class NamedGroopitFilterUpdateDTO implements INamedGroopitFilterUpdateDTO {
    name!: string;
    isPublished!: boolean;
    filter!: GroopitFilterDTO;

    constructor(data?: INamedGroopitFilterUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filter = new GroopitFilterDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.isPublished = _data["IsPublished"];
            this.filter = _data["Filter"] ? GroopitFilterDTO.fromJS(_data["Filter"]) : new GroopitFilterDTO();
        }
    }

    static fromJS(data: any): NamedGroopitFilterUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NamedGroopitFilterUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["IsPublished"] = this.isPublished;
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface INamedGroopitFilterUpdateDTO {
    name: string;
    isPublished: boolean;
    filter: GroopitFilterDTO;
}

export enum AccessRight {
    None = 0,
    ViewPosts = 1,
    CreatePost = 2,
    PublisherRole = 2,
    ManagePosts = 4,
    ManageFlags = 8,
    ManageForms = 16,
    ContactMembers = 32,
    ViewMembership = 64,
    MemberRole = 67,
    ManageMembership = 128,
    ManageIntegrations = 256,
    ManageGroup = 512,
    ManageViews = 1024,
    OrganizerRole = 2047,
    ManageTenant = 2048,
    TenantOwnerRole = 4095,
}

/** The data necessary for creating a new Groopit */
export class CreateGroopitDTO implements ICreateGroopitDTO {
    components?: ComponentDataDTO[] | undefined;
    targets?: SFTargetDTO[] | undefined;

    constructor(data?: ICreateGroopitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(ComponentDataDTO.fromJS(item));
            }
            if (Array.isArray(_data["Targets"])) {
                this.targets = [] as any;
                for (let item of _data["Targets"])
                    this.targets!.push(SFTargetDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateGroopitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroopitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        if (Array.isArray(this.targets)) {
            data["Targets"] = [];
            for (let item of this.targets)
                data["Targets"].push(item.toJSON());
        }
        return data;
    }
}

/** The data necessary for creating a new Groopit */
export interface ICreateGroopitDTO {
    components?: ComponentDataDTO[] | undefined;
    targets?: SFTargetDTO[] | undefined;
}

export class PendingUploadDTO implements IPendingUploadDTO {
    image!: string;
    upload!: string;

    constructor(data?: IPendingUploadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.upload = _data["upload"];
        }
    }

    static fromJS(data: any): PendingUploadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PendingUploadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["upload"] = this.upload;
        return data;
    }
}

export interface IPendingUploadDTO {
    image: string;
    upload: string;
}

/** Update the Flag of a GroopIt. If the flag doesn't already exist, it will be added to the Groop's list of valid flags */
export class GroopItFlag implements IGroopItFlag {
    flag?: string | undefined;

    constructor(data?: IGroopItFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["Flag"];
        }
    }

    static fromJS(data: any): GroopItFlag {
        data = typeof data === 'object' ? data : {};
        let result = new GroopItFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Flag"] = this.flag;
        return data;
    }
}

/** Update the Flag of a GroopIt. If the flag doesn't already exist, it will be added to the Groop's list of valid flags */
export interface IGroopItFlag {
    flag?: string | undefined;
}

/** Like/Unlike a GroopIt. */
export class GroopItLike implements IGroopItLike {
    like?: boolean;

    constructor(data?: IGroopItLike) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.like = _data["Like"];
        }
    }

    static fromJS(data: any): GroopItLike {
        data = typeof data === 'object' ? data : {};
        let result = new GroopItLike();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Like"] = this.like;
        return data;
    }
}

/** Like/Unlike a GroopIt. */
export interface IGroopItLike {
    like?: boolean;
}

export class CommentMeta implements ICommentMeta {
    comments?: CommentDTO[] | undefined;
    topLevelCount?: number;
    /** The total count of comments (named this way for legacy clients) */
    count?: number;
    /** Whether the current user has access to Edit/Delete any comment
not just their own. */
    canManage?: boolean;
    tagged?: { [key: string]: UserDTO; } | undefined;
    /** A token that can be passed to get GET API for paging support */
    nextToken?: string | undefined;

    constructor(data?: ICommentMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Comments"])) {
                this.comments = [] as any;
                for (let item of _data["Comments"])
                    this.comments!.push(CommentDTO.fromJS(item));
            }
            this.topLevelCount = _data["TopLevelCount"];
            this.count = _data["Count"];
            this.canManage = _data["CanManage"];
            if (_data["Tagged"]) {
                this.tagged = {} as any;
                for (let key in _data["Tagged"]) {
                    if (_data["Tagged"].hasOwnProperty(key))
                        (<any>this.tagged)![key] = _data["Tagged"][key] ? UserDTO.fromJS(_data["Tagged"][key]) : new UserDTO();
                }
            }
            this.nextToken = _data["NextToken"];
        }
    }

    static fromJS(data: any): CommentMeta {
        data = typeof data === 'object' ? data : {};
        let result = new CommentMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.comments)) {
            data["Comments"] = [];
            for (let item of this.comments)
                data["Comments"].push(item.toJSON());
        }
        data["TopLevelCount"] = this.topLevelCount;
        data["Count"] = this.count;
        data["CanManage"] = this.canManage;
        if (this.tagged) {
            data["Tagged"] = {};
            for (let key in this.tagged) {
                if (this.tagged.hasOwnProperty(key))
                    (<any>data["Tagged"])[key] = this.tagged[key] ? this.tagged[key].toJSON() : <any>undefined;
            }
        }
        data["NextToken"] = this.nextToken;
        return data;
    }
}

export interface ICommentMeta {
    comments?: CommentDTO[] | undefined;
    topLevelCount?: number;
    /** The total count of comments (named this way for legacy clients) */
    count?: number;
    /** Whether the current user has access to Edit/Delete any comment
not just their own. */
    canManage?: boolean;
    tagged?: { [key: string]: UserDTO; } | undefined;
    /** A token that can be passed to get GET API for paging support */
    nextToken?: string | undefined;
}

export class CommentDTO implements ICommentDTO {
    id?: string | undefined;
    content?: string | undefined;
    creator?: UserDTO | undefined;
    created?: Date;
    edited?: Date | undefined;
    parent?: string | undefined;
    topLevelCount?: number;

    constructor(data?: ICommentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.content = _data["Content"];
            this.creator = _data["Creator"] ? UserDTO.fromJS(_data["Creator"]) : <any>undefined;
            this.created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            this.edited = _data["Edited"] ? new Date(_data["Edited"].toString()) : <any>undefined;
            this.parent = _data["Parent"];
            this.topLevelCount = _data["TopLevelCount"];
        }
    }

    static fromJS(data: any): CommentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Content"] = this.content;
        data["Creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["Edited"] = this.edited ? this.edited.toISOString() : <any>undefined;
        data["Parent"] = this.parent;
        data["TopLevelCount"] = this.topLevelCount;
        return data;
    }
}

export interface ICommentDTO {
    id?: string | undefined;
    content?: string | undefined;
    creator?: UserDTO | undefined;
    created?: Date;
    edited?: Date | undefined;
    parent?: string | undefined;
    topLevelCount?: number;
}

export class SelectListDTO implements ISelectListDTO {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISelectListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): SelectListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelectListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface ISelectListDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export class InsightsReportDTO implements IInsightsReportDTO {
    discriminator!: string;
    id!: string;
    title!: string;
    creator!: UserDTO;
    includesHiddenData!: boolean;
    timestamp!: Date;
    timestampOverride?: string | undefined;
    filter!: GroopitFilterDisplayDTO;
    sourceOverride?: string | undefined;
    groopitCount!: number;
    content!: string;
    isPublished!: boolean;

    constructor(data?: IInsightsReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.creator = new UserDTO();
            this.filter = new GroopitFilterDisplayDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["Discriminator"];
            this.id = _data["Id"];
            this.title = _data["Title"];
            this.creator = _data["Creator"] ? UserDTO.fromJS(_data["Creator"]) : new UserDTO();
            this.includesHiddenData = _data["IncludesHiddenData"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.timestampOverride = _data["TimestampOverride"];
            this.filter = _data["Filter"] ? GroopitFilterDisplayDTO.fromJS(_data["Filter"]) : new GroopitFilterDisplayDTO();
            this.sourceOverride = _data["SourceOverride"];
            this.groopitCount = _data["GroopitCount"];
            this.content = _data["Content"];
            this.isPublished = _data["IsPublished"];
        }
    }

    static fromJS(data: any): InsightsReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Discriminator"] = this.discriminator;
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["Creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["IncludesHiddenData"] = this.includesHiddenData;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["TimestampOverride"] = this.timestampOverride;
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["SourceOverride"] = this.sourceOverride;
        data["GroopitCount"] = this.groopitCount;
        data["Content"] = this.content;
        data["IsPublished"] = this.isPublished;
        return data;
    }
}

export interface IInsightsReportDTO {
    discriminator: string;
    id: string;
    title: string;
    creator: UserDTO;
    includesHiddenData: boolean;
    timestamp: Date;
    timestampOverride?: string | undefined;
    filter: GroopitFilterDisplayDTO;
    sourceOverride?: string | undefined;
    groopitCount: number;
    content: string;
    isPublished: boolean;
}

export class SummarizeResultDTO implements ISummarizeResultDTO {
    jobId?: string | undefined;
    aggregatedDetails?: string | undefined;
    status!: AsyncStatus;
    keyFindings?: string | undefined;
    headline?: string | undefined;
    summary?: string | undefined;
    groopitCount?: number;
    containsHiddenData?: boolean;
    error?: ErrorDTO | undefined;

    constructor(data?: ISummarizeResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["JobId"];
            this.aggregatedDetails = _data["AggregatedDetails"];
            this.status = _data["Status"];
            this.keyFindings = _data["KeyFindings"];
            this.headline = _data["Headline"];
            this.summary = _data["Summary"];
            this.groopitCount = _data["GroopitCount"];
            this.containsHiddenData = _data["ContainsHiddenData"];
            this.error = _data["Error"] ? ErrorDTO.fromJS(_data["Error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SummarizeResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SummarizeResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["JobId"] = this.jobId;
        data["AggregatedDetails"] = this.aggregatedDetails;
        data["Status"] = this.status;
        data["KeyFindings"] = this.keyFindings;
        data["Headline"] = this.headline;
        data["Summary"] = this.summary;
        data["GroopitCount"] = this.groopitCount;
        data["ContainsHiddenData"] = this.containsHiddenData;
        data["Error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISummarizeResultDTO {
    jobId?: string | undefined;
    aggregatedDetails?: string | undefined;
    status: AsyncStatus;
    keyFindings?: string | undefined;
    headline?: string | undefined;
    summary?: string | undefined;
    groopitCount?: number;
    containsHiddenData?: boolean;
    error?: ErrorDTO | undefined;
}

export class PatternsResultDTO implements IPatternsResultDTO {
    jobId?: string | undefined;
    containsHiddenData?: boolean;
    error?: ErrorDTO | undefined;
    groopitCount?: number;
    patterns?: string[] | undefined;
    status!: AsyncStatus;

    constructor(data?: IPatternsResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["JobId"];
            this.containsHiddenData = _data["ContainsHiddenData"];
            this.error = _data["Error"] ? ErrorDTO.fromJS(_data["Error"]) : <any>undefined;
            this.groopitCount = _data["GroopitCount"];
            if (Array.isArray(_data["Patterns"])) {
                this.patterns = [] as any;
                for (let item of _data["Patterns"])
                    this.patterns!.push(item);
            }
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): PatternsResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatternsResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["JobId"] = this.jobId;
        data["ContainsHiddenData"] = this.containsHiddenData;
        data["Error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["GroopitCount"] = this.groopitCount;
        if (Array.isArray(this.patterns)) {
            data["Patterns"] = [];
            for (let item of this.patterns)
                data["Patterns"].push(item);
        }
        data["Status"] = this.status;
        return data;
    }
}

export interface IPatternsResultDTO {
    jobId?: string | undefined;
    containsHiddenData?: boolean;
    error?: ErrorDTO | undefined;
    groopitCount?: number;
    patterns?: string[] | undefined;
    status: AsyncStatus;
}

export class CreateInsightReportDTO implements ICreateInsightReportDTO {
    aggregatedDetails?: string | undefined;
    timestamp?: Date;
    filter?: GroopitFilterDTO | undefined;
    groopitCount?: number;
    includesHiddenData?: boolean;
    keyFindings?: string | undefined;
    patterns?: string[] | undefined;
    title?: string | undefined;
    summary?: string | undefined;

    constructor(data?: ICreateInsightReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggregatedDetails = _data["AggregatedDetails"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.filter = _data["Filter"] ? GroopitFilterDTO.fromJS(_data["Filter"]) : <any>undefined;
            this.groopitCount = _data["GroopitCount"];
            this.includesHiddenData = _data["IncludesHiddenData"];
            this.keyFindings = _data["KeyFindings"];
            if (Array.isArray(_data["Patterns"])) {
                this.patterns = [] as any;
                for (let item of _data["Patterns"])
                    this.patterns!.push(item);
            }
            this.title = _data["Title"];
            this.summary = _data["Summary"];
        }
    }

    static fromJS(data: any): CreateInsightReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInsightReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AggregatedDetails"] = this.aggregatedDetails;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["GroopitCount"] = this.groopitCount;
        data["IncludesHiddenData"] = this.includesHiddenData;
        data["KeyFindings"] = this.keyFindings;
        if (Array.isArray(this.patterns)) {
            data["Patterns"] = [];
            for (let item of this.patterns)
                data["Patterns"].push(item);
        }
        data["Title"] = this.title;
        data["Summary"] = this.summary;
        return data;
    }
}

export interface ICreateInsightReportDTO {
    aggregatedDetails?: string | undefined;
    timestamp?: Date;
    filter?: GroopitFilterDTO | undefined;
    groopitCount?: number;
    includesHiddenData?: boolean;
    keyFindings?: string | undefined;
    patterns?: string[] | undefined;
    title?: string | undefined;
    summary?: string | undefined;
}

export class InsightsReportUpdateDTO implements IInsightsReportUpdateDTO {
    title!: string;
    creatorOverride?: string | undefined;
    timestampOverride?: string | undefined;
    sourceOverride?: string | undefined;
    content!: string;
    isPublished!: boolean;

    constructor(data?: IInsightsReportUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.creatorOverride = _data["CreatorOverride"];
            this.timestampOverride = _data["TimestampOverride"];
            this.sourceOverride = _data["SourceOverride"];
            this.content = _data["Content"];
            this.isPublished = _data["IsPublished"];
        }
    }

    static fromJS(data: any): InsightsReportUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsReportUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["CreatorOverride"] = this.creatorOverride;
        data["TimestampOverride"] = this.timestampOverride;
        data["SourceOverride"] = this.sourceOverride;
        data["Content"] = this.content;
        data["IsPublished"] = this.isPublished;
        return data;
    }
}

export interface IInsightsReportUpdateDTO {
    title: string;
    creatorOverride?: string | undefined;
    timestampOverride?: string | undefined;
    sourceOverride?: string | undefined;
    content: string;
    isPublished: boolean;
}

export class DataInsightDTO implements IDataInsightDTO {
    discriminator!: string;
    id!: number;
    title!: string;
    timestamp!: Date;
    timestampOverride?: string | undefined;
    filter!: GroopitFilterDisplayDTO;
    sourceOverride?: string | undefined;
    groopitCount!: number;
    isPublished!: boolean;
    analysisType!: string;
    analysis!: string;
    keyDetails!: string;
    references!: { [key: string]: string; };

    constructor(data?: IDataInsightDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filter = new GroopitFilterDisplayDTO();
            this.references = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["Discriminator"];
            this.id = _data["Id"];
            this.title = _data["Title"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.timestampOverride = _data["TimestampOverride"];
            this.filter = _data["Filter"] ? GroopitFilterDisplayDTO.fromJS(_data["Filter"]) : new GroopitFilterDisplayDTO();
            this.sourceOverride = _data["SourceOverride"];
            this.groopitCount = _data["GroopitCount"];
            this.isPublished = _data["IsPublished"];
            this.analysisType = _data["AnalysisType"];
            this.analysis = _data["Analysis"];
            this.keyDetails = _data["KeyDetails"];
            if (_data["References"]) {
                this.references = {} as any;
                for (let key in _data["References"]) {
                    if (_data["References"].hasOwnProperty(key))
                        (<any>this.references)![key] = _data["References"][key];
                }
            }
        }
    }

    static fromJS(data: any): DataInsightDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataInsightDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Discriminator"] = this.discriminator;
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["TimestampOverride"] = this.timestampOverride;
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["SourceOverride"] = this.sourceOverride;
        data["GroopitCount"] = this.groopitCount;
        data["IsPublished"] = this.isPublished;
        data["AnalysisType"] = this.analysisType;
        data["Analysis"] = this.analysis;
        data["KeyDetails"] = this.keyDetails;
        if (this.references) {
            data["References"] = {};
            for (let key in this.references) {
                if (this.references.hasOwnProperty(key))
                    (<any>data["References"])[key] = (<any>this.references)[key];
            }
        }
        return data;
    }
}

export interface IDataInsightDTO {
    discriminator: string;
    id: number;
    title: string;
    timestamp: Date;
    timestampOverride?: string | undefined;
    filter: GroopitFilterDisplayDTO;
    sourceOverride?: string | undefined;
    groopitCount: number;
    isPublished: boolean;
    analysisType: string;
    analysis: string;
    keyDetails: string;
    references: { [key: string]: string; };
}

export class DataInsightsReportResultDTO implements IDataInsightsReportResultDTO {
    report?: DataInsightDTO | undefined;
    error?: ErrorDTO | undefined;

    constructor(data?: IDataInsightsReportResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report = _data["Report"] ? DataInsightDTO.fromJS(_data["Report"]) : <any>undefined;
            this.error = _data["Error"] ? ErrorDTO.fromJS(_data["Error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataInsightsReportResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataInsightsReportResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Report"] = this.report ? this.report.toJSON() : <any>undefined;
        data["Error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDataInsightsReportResultDTO {
    report?: DataInsightDTO | undefined;
    error?: ErrorDTO | undefined;
}

export enum InsightType {
    Change = 0,
    Anomaly = 1,
    Success = 2,
    Persistent = 3,
    Custom = 4,
    CustomComparative = 5,
}

export class GroopDisplayDTO implements IGroopDisplayDTO {
    id!: string;
    name?: string | undefined;
    assignments?: AssignmentDisplaySimpleDTO[] | undefined;

    constructor(data?: IGroopDisplayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(AssignmentDisplaySimpleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroopDisplayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopDisplayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroopDisplayDTO {
    id: string;
    name?: string | undefined;
    assignments?: AssignmentDisplaySimpleDTO[] | undefined;
}

export class AssignmentDisplaySimpleDTO implements IAssignmentDisplaySimpleDTO {
    id!: string;
    title?: string | undefined;
    assignmentPhotoUrl?: string | undefined;
    componentModelIds?: number[] | undefined;

    constructor(data?: IAssignmentDisplaySimpleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            this.assignmentPhotoUrl = _data["AssignmentPhotoUrl"];
            if (Array.isArray(_data["ComponentModelIds"])) {
                this.componentModelIds = [] as any;
                for (let item of _data["ComponentModelIds"])
                    this.componentModelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AssignmentDisplaySimpleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentDisplaySimpleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["AssignmentPhotoUrl"] = this.assignmentPhotoUrl;
        if (Array.isArray(this.componentModelIds)) {
            data["ComponentModelIds"] = [];
            for (let item of this.componentModelIds)
                data["ComponentModelIds"].push(item);
        }
        return data;
    }
}

export interface IAssignmentDisplaySimpleDTO {
    id: string;
    title?: string | undefined;
    assignmentPhotoUrl?: string | undefined;
    componentModelIds?: number[] | undefined;
}

export class OutlookAddinConfiguration implements IOutlookAddinConfiguration {
    applicationUrl?: string | undefined;
    azureApplicationId?: string | undefined;

    constructor(data?: IOutlookAddinConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationUrl = _data["ApplicationUrl"];
            this.azureApplicationId = _data["AzureApplicationId"];
        }
    }

    static fromJS(data: any): OutlookAddinConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new OutlookAddinConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ApplicationUrl"] = this.applicationUrl;
        data["AzureApplicationId"] = this.azureApplicationId;
        return data;
    }
}

export interface IOutlookAddinConfiguration {
    applicationUrl?: string | undefined;
    azureApplicationId?: string | undefined;
}

export class LegacyLinkResultDto implements ILegacyLinkResultDto {
    succeeded?: boolean;
    legacyAccountMismatch?: LegacyAccountMismatchDto | undefined;

    constructor(data?: ILegacyLinkResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["Succeeded"];
            this.legacyAccountMismatch = _data["LegacyAccountMismatch"] ? LegacyAccountMismatchDto.fromJS(_data["LegacyAccountMismatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LegacyLinkResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyLinkResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Succeeded"] = this.succeeded;
        data["LegacyAccountMismatch"] = this.legacyAccountMismatch ? this.legacyAccountMismatch.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILegacyLinkResultDto {
    succeeded?: boolean;
    legacyAccountMismatch?: LegacyAccountMismatchDto | undefined;
}

export class LegacyAccountMismatchDto implements ILegacyAccountMismatchDto {
    exchangeUserId?: string | undefined;
    exchangeUrl?: string | undefined;
    requestId?: string | undefined;

    constructor(data?: ILegacyAccountMismatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exchangeUserId = _data["ExchangeUserId"];
            this.exchangeUrl = _data["ExchangeUrl"];
            this.requestId = _data["RequestId"];
        }
    }

    static fromJS(data: any): LegacyAccountMismatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyAccountMismatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExchangeUserId"] = this.exchangeUserId;
        data["ExchangeUrl"] = this.exchangeUrl;
        data["RequestId"] = this.requestId;
        return data;
    }
}

export interface ILegacyAccountMismatchDto {
    exchangeUserId?: string | undefined;
    exchangeUrl?: string | undefined;
    requestId?: string | undefined;
}

export class UserAssociationResult implements IUserAssociationResult {
    succeeded?: boolean;

    constructor(data?: IUserAssociationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["Succeeded"];
        }
    }

    static fromJS(data: any): UserAssociationResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserAssociationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Succeeded"] = this.succeeded;
        return data;
    }
}

export interface IUserAssociationResult {
    succeeded?: boolean;
}

export class UserAssociationMismatchResult extends UserAssociationResult implements IUserAssociationMismatchResult {
    requestId?: string | undefined;
    tenantId?: string | undefined;
    userId?: string | undefined;
    succeeded?: boolean;

    constructor(data?: IUserAssociationMismatchResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestId = _data["RequestId"];
            this.tenantId = _data["TenantId"];
            this.userId = _data["UserId"];
            this.succeeded = _data["Succeeded"];
        }
    }

    static fromJS(data: any): UserAssociationMismatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserAssociationMismatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RequestId"] = this.requestId;
        data["TenantId"] = this.tenantId;
        data["UserId"] = this.userId;
        data["Succeeded"] = this.succeeded;
        super.toJSON(data);
        return data;
    }
}

export interface IUserAssociationMismatchResult extends IUserAssociationResult {
    requestId?: string | undefined;
    tenantId?: string | undefined;
    userId?: string | undefined;
    succeeded?: boolean;
}

export class KeywordPromptsDTO2 implements IKeywordPromptsDTO2 {
    groopId!: string;
    keywords!: string;
    prompt!: string;

    constructor(data?: IKeywordPromptsDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groopId = _data["GroopId"];
            this.keywords = _data["Keywords"];
            this.prompt = _data["Prompt"];
        }
    }

    static fromJS(data: any): KeywordPromptsDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new KeywordPromptsDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GroopId"] = this.groopId;
        data["Keywords"] = this.keywords;
        data["Prompt"] = this.prompt;
        return data;
    }
}

export interface IKeywordPromptsDTO2 {
    groopId: string;
    keywords: string;
    prompt: string;
}

export class MatchingOutlookEmailPrompts implements IMatchingOutlookEmailPrompts {
    emailSubject!: string;
    emailBody!: string;
    groupIds!: string[];

    constructor(data?: IMatchingOutlookEmailPrompts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groupIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailSubject = _data["EmailSubject"];
            this.emailBody = _data["EmailBody"];
            if (Array.isArray(_data["GroupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["GroupIds"])
                    this.groupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MatchingOutlookEmailPrompts {
        data = typeof data === 'object' ? data : {};
        let result = new MatchingOutlookEmailPrompts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailSubject"] = this.emailSubject;
        data["EmailBody"] = this.emailBody;
        if (Array.isArray(this.groupIds)) {
            data["GroupIds"] = [];
            for (let item of this.groupIds)
                data["GroupIds"].push(item);
        }
        return data;
    }
}

export interface IMatchingOutlookEmailPrompts {
    emailSubject: string;
    emailBody: string;
    groupIds: string[];
}

export class DeviceRegistration implements IDeviceRegistration {
    platform?: string | undefined;
    handle?: string | undefined;

    constructor(data?: IDeviceRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["Platform"];
            this.handle = _data["Handle"];
        }
    }

    static fromJS(data: any): DeviceRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Platform"] = this.platform;
        data["Handle"] = this.handle;
        return data;
    }
}

export interface IDeviceRegistration {
    platform?: string | undefined;
    handle?: string | undefined;
}

export class SlackChannelResultsDTO implements ISlackChannelResultsDTO {
    channels!: SlackChannelDTO[];
    nextCursor?: string | undefined;

    constructor(data?: ISlackChannelResultsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.channels = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Channels"])) {
                this.channels = [] as any;
                for (let item of _data["Channels"])
                    this.channels!.push(SlackChannelDTO.fromJS(item));
            }
            this.nextCursor = _data["NextCursor"];
        }
    }

    static fromJS(data: any): SlackChannelResultsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SlackChannelResultsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.channels)) {
            data["Channels"] = [];
            for (let item of this.channels)
                data["Channels"].push(item.toJSON());
        }
        data["NextCursor"] = this.nextCursor;
        return data;
    }
}

export interface ISlackChannelResultsDTO {
    channels: SlackChannelDTO[];
    nextCursor?: string | undefined;
}

export class SlackNotificationLinkDTO implements ISlackNotificationLinkDTO {
    id!: number;
    creator?: UserDTO | undefined;
    timestamp!: Date;
    connection!: SlackConnectionDTO;
    channelId!: string;
    channelName?: string | undefined;
    assignmentId!: string;

    constructor(data?: ISlackNotificationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.connection = new SlackConnectionDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.creator = _data["Creator"] ? UserDTO.fromJS(_data["Creator"]) : <any>undefined;
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.connection = _data["Connection"] ? SlackConnectionDTO.fromJS(_data["Connection"]) : new SlackConnectionDTO();
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
            this.assignmentId = _data["AssignmentId"];
        }
    }

    static fromJS(data: any): SlackNotificationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SlackNotificationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["Connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        data["AssignmentId"] = this.assignmentId;
        return data;
    }
}

export interface ISlackNotificationLinkDTO {
    id: number;
    creator?: UserDTO | undefined;
    timestamp: Date;
    connection: SlackConnectionDTO;
    channelId: string;
    channelName?: string | undefined;
    assignmentId: string;
}

export class CreateSlackNotificationLinkDTO implements ICreateSlackNotificationLinkDTO {
    assignmentId?: string;
    teamId?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;

    constructor(data?: ICreateSlackNotificationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["AssignmentId"];
            this.teamId = _data["TeamId"];
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
        }
    }

    static fromJS(data: any): CreateSlackNotificationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSlackNotificationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssignmentId"] = this.assignmentId;
        data["TeamId"] = this.teamId;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        return data;
    }
}

export interface ICreateSlackNotificationLinkDTO {
    assignmentId?: string;
    teamId?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;
}

export class SlackChannelBotMembershipDTO implements ISlackChannelBotMembershipDTO {
    id!: string;
    isBotInChannel!: boolean;

    constructor(data?: ISlackChannelBotMembershipDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.isBotInChannel = _data["IsBotInChannel"];
        }
    }

    static fromJS(data: any): SlackChannelBotMembershipDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SlackChannelBotMembershipDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["IsBotInChannel"] = this.isBotInChannel;
        return data;
    }
}

export interface ISlackChannelBotMembershipDTO {
    id: string;
    isBotInChannel: boolean;
}

export class CreateSlackChannelLinkDTO implements ICreateSlackChannelLinkDTO {
    groupId?: string;
    connectionId?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;
    existingMembersOnly?: boolean;

    constructor(data?: ICreateSlackChannelLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["GroupId"];
            this.connectionId = _data["ConnectionId"];
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
            this.existingMembersOnly = _data["ExistingMembersOnly"];
        }
    }

    static fromJS(data: any): CreateSlackChannelLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSlackChannelLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GroupId"] = this.groupId;
        data["ConnectionId"] = this.connectionId;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        data["ExistingMembersOnly"] = this.existingMembersOnly;
        return data;
    }
}

export interface ICreateSlackChannelLinkDTO {
    groupId?: string;
    connectionId?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;
    existingMembersOnly?: boolean;
}

export enum TeamsUserVersion {
    Any = 0,
    KeywordPrompts = 0,
    AggregateDataFeeds = 1,
    None = -1,
}

export class GroupCategories implements IGroupCategories {
    all?: GroopDisplayDTO[] | undefined;
    recommended?: GroopDisplayDTO[] | undefined;

    constructor(data?: IGroupCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["All"])) {
                this.all = [] as any;
                for (let item of _data["All"])
                    this.all!.push(GroopDisplayDTO.fromJS(item));
            }
            if (Array.isArray(_data["Recommended"])) {
                this.recommended = [] as any;
                for (let item of _data["Recommended"])
                    this.recommended!.push(GroopDisplayDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupCategories {
        data = typeof data === 'object' ? data : {};
        let result = new GroupCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.all)) {
            data["All"] = [];
            for (let item of this.all)
                data["All"].push(item.toJSON());
        }
        if (Array.isArray(this.recommended)) {
            data["Recommended"] = [];
            for (let item of this.recommended)
                data["Recommended"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupCategories {
    all?: GroopDisplayDTO[] | undefined;
    recommended?: GroopDisplayDTO[] | undefined;
}

export class TeamsNotificationLinkDTO implements ITeamsNotificationLinkDTO {
    id!: number;
    creator?: UserDTO | undefined;
    timestamp!: Date;
    connection!: TeamsConnectionDTO;
    teamId!: string;
    teamName?: string | undefined;
    channelId!: string;
    channelName?: string | undefined;
    botNeedsInstall?: boolean;
    assignmentId!: string;

    constructor(data?: ITeamsNotificationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.connection = new TeamsConnectionDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.creator = _data["Creator"] ? UserDTO.fromJS(_data["Creator"]) : <any>undefined;
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.connection = _data["Connection"] ? TeamsConnectionDTO.fromJS(_data["Connection"]) : new TeamsConnectionDTO();
            this.teamId = _data["TeamId"];
            this.teamName = _data["TeamName"];
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
            this.botNeedsInstall = _data["BotNeedsInstall"];
            this.assignmentId = _data["AssignmentId"];
        }
    }

    static fromJS(data: any): TeamsNotificationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TeamsNotificationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["Connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
        data["TeamId"] = this.teamId;
        data["TeamName"] = this.teamName;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        data["BotNeedsInstall"] = this.botNeedsInstall;
        data["AssignmentId"] = this.assignmentId;
        return data;
    }
}

export interface ITeamsNotificationLinkDTO {
    id: number;
    creator?: UserDTO | undefined;
    timestamp: Date;
    connection: TeamsConnectionDTO;
    teamId: string;
    teamName?: string | undefined;
    channelId: string;
    channelName?: string | undefined;
    botNeedsInstall?: boolean;
    assignmentId: string;
}

export class CreateTeamsNotificationLinkDTO implements ICreateTeamsNotificationLinkDTO {
    assignmentId?: string;
    tenantId?: string | undefined;
    teamId?: string | undefined;
    teamName?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;

    constructor(data?: ICreateTeamsNotificationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["AssignmentId"];
            this.tenantId = _data["TenantId"];
            this.teamId = _data["TeamId"];
            this.teamName = _data["TeamName"];
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
        }
    }

    static fromJS(data: any): CreateTeamsNotificationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamsNotificationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssignmentId"] = this.assignmentId;
        data["TenantId"] = this.tenantId;
        data["TeamId"] = this.teamId;
        data["TeamName"] = this.teamName;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        return data;
    }
}

export interface ICreateTeamsNotificationLinkDTO {
    assignmentId?: string;
    tenantId?: string | undefined;
    teamId?: string | undefined;
    teamName?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;
}

export class CreateTeamsChannelLinkDTO implements ICreateTeamsChannelLinkDTO {
    groupId?: string;
    tenantId?: string | undefined;
    teamId?: string | undefined;
    teamName?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;
    existingMembersOnly?: boolean;

    constructor(data?: ICreateTeamsChannelLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["GroupId"];
            this.tenantId = _data["TenantId"];
            this.teamId = _data["TeamId"];
            this.teamName = _data["TeamName"];
            this.channelId = _data["ChannelId"];
            this.channelName = _data["ChannelName"];
            this.existingMembersOnly = _data["ExistingMembersOnly"];
        }
    }

    static fromJS(data: any): CreateTeamsChannelLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamsChannelLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GroupId"] = this.groupId;
        data["TenantId"] = this.tenantId;
        data["TeamId"] = this.teamId;
        data["TeamName"] = this.teamName;
        data["ChannelId"] = this.channelId;
        data["ChannelName"] = this.channelName;
        data["ExistingMembersOnly"] = this.existingMembersOnly;
        return data;
    }
}

export interface ICreateTeamsChannelLinkDTO {
    groupId?: string;
    tenantId?: string | undefined;
    teamId?: string | undefined;
    teamName?: string | undefined;
    channelId?: string | undefined;
    channelName?: string | undefined;
    existingMembersOnly?: boolean;
}

export class ScimDTO implements IScimDTO {
    tenantId!: string;
    scimEnabled!: boolean;
    scimSecretToken!: string;
    scimEndpointUrl!: string;

    constructor(data?: IScimDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["TenantId"];
            this.scimEnabled = _data["ScimEnabled"];
            this.scimSecretToken = _data["ScimSecretToken"];
            this.scimEndpointUrl = _data["ScimEndpointUrl"];
        }
    }

    static fromJS(data: any): ScimDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScimDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TenantId"] = this.tenantId;
        data["ScimEnabled"] = this.scimEnabled;
        data["ScimSecretToken"] = this.scimSecretToken;
        data["ScimEndpointUrl"] = this.scimEndpointUrl;
        return data;
    }
}

export interface IScimDTO {
    tenantId: string;
    scimEnabled: boolean;
    scimSecretToken: string;
    scimEndpointUrl: string;
}

export class CreateUserDTO implements ICreateUserDTO {
    userName!: string;
    email!: string;
    password!: string;

    constructor(data?: ICreateUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.email = _data["Email"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): CreateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Email"] = this.email;
        data["Password"] = this.password;
        return data;
    }
}

export interface ICreateUserDTO {
    userName: string;
    email: string;
    password: string;
}

export class ForgotPasswordViewModel implements IForgotPasswordViewModel {
    email!: string;

    constructor(data?: IForgotPasswordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): ForgotPasswordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordViewModel {
    email: string;
}

export class UserSelfDTO extends UserDTO implements IUserSelfDTO {
    email!: string;
    supportsChangePassword!: boolean;
    isTenantAdmin!: boolean;
    features!: Feature;

    constructor(data?: IUserSelfDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["Email"];
            this.supportsChangePassword = _data["SupportsChangePassword"];
            this.isTenantAdmin = _data["IsTenantAdmin"];
            this.features = _data["Features"];
        }
    }

    static fromJS(data: any): UserSelfDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelfDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["SupportsChangePassword"] = this.supportsChangePassword;
        data["IsTenantAdmin"] = this.isTenantAdmin;
        data["Features"] = this.features;
        super.toJSON(data);
        return data;
    }
}

export interface IUserSelfDTO extends IUserDTO {
    email: string;
    supportsChangePassword: boolean;
    isTenantAdmin: boolean;
    features: Feature;
}

/** User-specific feature enabling */
export enum Feature {
    None = 0,
    SpatialQuery = 2,
    DecimalComponent = 4,
    FileSetComponent = 8,
    AiInsights = 16,
    FlagFields = 32,
    AiSuggestedDataModels = 64,
    AiStructuredData = 128,
    River = 256,
    SuggestionsFromOutlookKeywords = 512,
    DevelopmentAccess = 1024,
    ChatWithYourData = 2048,
}

export class EditUserDTO implements IEditUserDTO {
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IEditUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): EditUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        return data;
    }
}

export interface IEditUserDTO {
    userName?: string | undefined;
    password?: string | undefined;
}

export class ChangePasswordModel implements IChangePasswordModel {
    password?: string | undefined;
    new_password?: string | undefined;

    constructor(data?: IChangePasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.new_password = _data["new_password"];
        }
    }

    static fromJS(data: any): ChangePasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["new_password"] = this.new_password;
        return data;
    }
}

export interface IChangePasswordModel {
    password?: string | undefined;
    new_password?: string | undefined;
}

export class UserAvatar implements IUserAvatar {
    avatarUrl?: string | undefined;

    constructor(data?: IUserAvatar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatarUrl = _data["AvatarUrl"];
        }
    }

    static fromJS(data: any): UserAvatar {
        data = typeof data === 'object' ? data : {};
        let result = new UserAvatar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AvatarUrl"] = this.avatarUrl;
        return data;
    }
}

export interface IUserAvatar {
    avatarUrl?: string | undefined;
}

export class EmailSettingsModel implements IEmailSettingsModel {
    emailAddress?: string | undefined;
    groopAnnouncements?: boolean;
    weeklyDigest?: boolean;
    mentions?: boolean;
    globalOptOut?: boolean;

    constructor(data?: IEmailSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["EmailAddress"];
            this.groopAnnouncements = _data["GroopAnnouncements"];
            this.weeklyDigest = _data["WeeklyDigest"];
            this.mentions = _data["Mentions"];
            this.globalOptOut = _data["GlobalOptOut"];
        }
    }

    static fromJS(data: any): EmailSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailAddress"] = this.emailAddress;
        data["GroopAnnouncements"] = this.groopAnnouncements;
        data["WeeklyDigest"] = this.weeklyDigest;
        data["Mentions"] = this.mentions;
        data["GlobalOptOut"] = this.globalOptOut;
        return data;
    }
}

export interface IEmailSettingsModel {
    emailAddress?: string | undefined;
    groopAnnouncements?: boolean;
    weeklyDigest?: boolean;
    mentions?: boolean;
    globalOptOut?: boolean;
}

export class LinkGroupDTO implements ILinkGroupDTO {
    groupId?: string;
    orgId?: string | undefined;
    orgName?: string | undefined;
    orgUrl?: string | undefined;

    constructor(data?: ILinkGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.orgId = _data["orgId"];
            this.orgName = _data["orgName"];
            this.orgUrl = _data["orgUrl"];
        }
    }

    static fromJS(data: any): LinkGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["orgId"] = this.orgId;
        data["orgName"] = this.orgName;
        data["orgUrl"] = this.orgUrl;
        return data;
    }
}

export interface ILinkGroupDTO {
    groupId?: string;
    orgId?: string | undefined;
    orgName?: string | undefined;
    orgUrl?: string | undefined;
}

export class UnlinkGroupDTO implements IUnlinkGroupDTO {
    groupId?: string;
    orgId?: string | undefined;

    constructor(data?: IUnlinkGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.orgId = _data["orgId"];
        }
    }

    static fromJS(data: any): UnlinkGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["orgId"] = this.orgId;
        return data;
    }
}

export interface IUnlinkGroupDTO {
    groupId?: string;
    orgId?: string | undefined;
}

export class MapFieldDTO implements IMapFieldDTO {
    orgId?: string | undefined;
    groupId?: string;
    assignmentId?: string;
    componentId?: number;
    fieldName?: string | undefined;

    constructor(data?: IMapFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgId = _data["orgId"];
            this.groupId = _data["groupId"];
            this.assignmentId = _data["assignmentId"];
            this.componentId = _data["componentId"];
            this.fieldName = _data["fieldName"];
        }
    }

    static fromJS(data: any): MapFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MapFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgId"] = this.orgId;
        data["groupId"] = this.groupId;
        data["assignmentId"] = this.assignmentId;
        data["componentId"] = this.componentId;
        data["fieldName"] = this.fieldName;
        return data;
    }
}

export interface IMapFieldDTO {
    orgId?: string | undefined;
    groupId?: string;
    assignmentId?: string;
    componentId?: number;
    fieldName?: string | undefined;
}

export class GroupDTO implements IGroupDTO {
    id?: string;
    name?: string | undefined;
    avatarUrl?: string | undefined;
    isSaveToSalesforceV2?: boolean;
    assignments?: AssignmentDTO2[] | undefined;

    constructor(data?: IGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.avatarUrl = _data["AvatarUrl"];
            this.isSaveToSalesforceV2 = _data["IsSaveToSalesforceV2"];
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(AssignmentDTO2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["AvatarUrl"] = this.avatarUrl;
        data["IsSaveToSalesforceV2"] = this.isSaveToSalesforceV2;
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupDTO {
    id?: string;
    name?: string | undefined;
    avatarUrl?: string | undefined;
    isSaveToSalesforceV2?: boolean;
    assignments?: AssignmentDTO2[] | undefined;
}

export class AssignmentDTO2 implements IAssignmentDTO2 {
    id!: string;
    title?: string | undefined;
    assignmentPhotoUrl!: string;
    name!: string;
    components!: ComponentModelDTO2[];

    constructor(data?: IAssignmentDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.components = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            this.assignmentPhotoUrl = _data["AssignmentPhotoUrl"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(ComponentModelDTO2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignmentDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["AssignmentPhotoUrl"] = this.assignmentPhotoUrl;
        data["Name"] = this.name;
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignmentDTO2 {
    id: string;
    title?: string | undefined;
    assignmentPhotoUrl: string;
    name: string;
    components: ComponentModelDTO2[];
}

export class ComponentModelDTO2 implements IComponentModelDTO2 {
    componentModel_Id?: number;
    type?: number;
    description?: string | undefined;
    hiddenFromMembers?: boolean;
    required?: boolean;
    isFlagField?: boolean;
    isFollowUpField?: boolean;
    parentModelComponentModel_Id?: number | undefined;
    options?: string | undefined;
    multiple?: boolean;
    userEditable?: boolean;
    dateOnly?: boolean;
    externalDataType?: string | undefined;
    externalFieldName?: string | undefined;
    externalFieldLabel?: string | undefined;
    mappedField?: string | undefined;

    constructor(data?: IComponentModelDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentModel_Id = _data["ComponentModel_Id"];
            this.type = _data["Type"];
            this.description = _data["Description"];
            this.hiddenFromMembers = _data["HiddenFromMembers"];
            this.required = _data["Required"];
            this.isFlagField = _data["IsFlagField"];
            this.isFollowUpField = _data["IsFollowUpField"];
            this.parentModelComponentModel_Id = _data["ParentModelComponentModel_Id"];
            this.options = _data["Options"];
            this.multiple = _data["Multiple"];
            this.userEditable = _data["UserEditable"];
            this.dateOnly = _data["DateOnly"];
            this.externalDataType = _data["ExternalDataType"];
            this.externalFieldName = _data["ExternalFieldName"];
            this.externalFieldLabel = _data["ExternalFieldLabel"];
            this.mappedField = _data["MappedField"];
        }
    }

    static fromJS(data: any): ComponentModelDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentModelDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ComponentModel_Id"] = this.componentModel_Id;
        data["Type"] = this.type;
        data["Description"] = this.description;
        data["HiddenFromMembers"] = this.hiddenFromMembers;
        data["Required"] = this.required;
        data["IsFlagField"] = this.isFlagField;
        data["IsFollowUpField"] = this.isFollowUpField;
        data["ParentModelComponentModel_Id"] = this.parentModelComponentModel_Id;
        data["Options"] = this.options;
        data["Multiple"] = this.multiple;
        data["UserEditable"] = this.userEditable;
        data["DateOnly"] = this.dateOnly;
        data["ExternalDataType"] = this.externalDataType;
        data["ExternalFieldName"] = this.externalFieldName;
        data["ExternalFieldLabel"] = this.externalFieldLabel;
        data["MappedField"] = this.mappedField;
        return data;
    }
}

export interface IComponentModelDTO2 {
    componentModel_Id?: number;
    type?: number;
    description?: string | undefined;
    hiddenFromMembers?: boolean;
    required?: boolean;
    isFlagField?: boolean;
    isFollowUpField?: boolean;
    parentModelComponentModel_Id?: number | undefined;
    options?: string | undefined;
    multiple?: boolean;
    userEditable?: boolean;
    dateOnly?: boolean;
    externalDataType?: string | undefined;
    externalFieldName?: string | undefined;
    externalFieldLabel?: string | undefined;
    mappedField?: string | undefined;
}

export class GetGroupsDTO implements IGetGroupsDTO {
    orgId?: string | undefined;

    constructor(data?: IGetGroupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgId = _data["orgId"];
        }
    }

    static fromJS(data: any): GetGroupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgId"] = this.orgId;
        return data;
    }
}

export interface IGetGroupsDTO {
    orgId?: string | undefined;
}

export class GroopitDTO implements IGroopitDTO {
    id?: string;
    formId?: string;
    formName?: string | undefined;
    groupId?: string;
    reportUrl?: string | undefined;
    dataBlob?: string | undefined;
    filteredDataBlob?: string | undefined;
    componentData?: ComponentDataDTO2[] | undefined;

    constructor(data?: IGroopitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.formId = _data["FormId"];
            this.formName = _data["FormName"];
            this.groupId = _data["GroupId"];
            this.reportUrl = _data["ReportUrl"];
            this.dataBlob = _data["DataBlob"];
            this.filteredDataBlob = _data["FilteredDataBlob"];
            if (Array.isArray(_data["ComponentData"])) {
                this.componentData = [] as any;
                for (let item of _data["ComponentData"])
                    this.componentData!.push(ComponentDataDTO2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroopitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroopitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FormId"] = this.formId;
        data["FormName"] = this.formName;
        data["GroupId"] = this.groupId;
        data["ReportUrl"] = this.reportUrl;
        data["DataBlob"] = this.dataBlob;
        data["FilteredDataBlob"] = this.filteredDataBlob;
        if (Array.isArray(this.componentData)) {
            data["ComponentData"] = [];
            for (let item of this.componentData)
                data["ComponentData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroopitDTO {
    id?: string;
    formId?: string;
    formName?: string | undefined;
    groupId?: string;
    reportUrl?: string | undefined;
    dataBlob?: string | undefined;
    filteredDataBlob?: string | undefined;
    componentData?: ComponentDataDTO2[] | undefined;
}

export class ComponentDataDTO2 implements IComponentDataDTO2 {
    model?: ComponentModelDTO2 | undefined;
    id?: number;
    value?: string | undefined;

    constructor(data?: IComponentDataDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? ComponentModelDTO2.fromJS(_data["model"]) : <any>undefined;
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ComponentDataDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentDataDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IComponentDataDTO2 {
    model?: ComponentModelDTO2 | undefined;
    id?: number;
    value?: string | undefined;
}

export class CreateGroopitDTO2 implements ICreateGroopitDTO2 {
    groupId?: string;
    assignmentId?: string;
    orgId?: string | undefined;
    components?: ComponentDataDTO[] | undefined;

    constructor(data?: ICreateGroopitDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.assignmentId = _data["assignmentId"];
            this.orgId = _data["orgId"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ComponentDataDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateGroopitDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroopitDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["assignmentId"] = this.assignmentId;
        data["orgId"] = this.orgId;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateGroopitDTO2 {
    groupId?: string;
    assignmentId?: string;
    orgId?: string | undefined;
    components?: ComponentDataDTO[] | undefined;
}

export class GetComponentOptionsDTO implements IGetComponentOptionsDTO {
    assignmentId?: string;
    componentId?: number;
    query?: string | undefined;
    orgId?: string | undefined;

    constructor(data?: IGetComponentOptionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["assignmentId"];
            this.componentId = _data["componentId"];
            this.query = _data["query"];
            this.orgId = _data["orgId"];
        }
    }

    static fromJS(data: any): GetComponentOptionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentOptionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentId"] = this.assignmentId;
        data["componentId"] = this.componentId;
        data["query"] = this.query;
        data["orgId"] = this.orgId;
        return data;
    }
}

export interface IGetComponentOptionsDTO {
    assignmentId?: string;
    componentId?: number;
    query?: string | undefined;
    orgId?: string | undefined;
}

export class SetLinkedObjectsDTO implements ISetLinkedObjectsDTO {
    orgId?: string | undefined;
    groopitId?: string;
    externalId?: string | undefined;
    linkedObjects?: LinkedObjectDTO[] | undefined;

    constructor(data?: ISetLinkedObjectsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgId = _data["orgId"];
            this.groopitId = _data["groopitId"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["linkedObjects"])) {
                this.linkedObjects = [] as any;
                for (let item of _data["linkedObjects"])
                    this.linkedObjects!.push(LinkedObjectDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetLinkedObjectsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetLinkedObjectsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgId"] = this.orgId;
        data["groopitId"] = this.groopitId;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.linkedObjects)) {
            data["linkedObjects"] = [];
            for (let item of this.linkedObjects)
                data["linkedObjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetLinkedObjectsDTO {
    orgId?: string | undefined;
    groopitId?: string;
    externalId?: string | undefined;
    linkedObjects?: LinkedObjectDTO[] | undefined;
}

export class LinkedObjectDTO implements ILinkedObjectDTO {
    fieldType?: string | undefined;
    fieldName?: string | undefined;
    fieldLabel?: string | undefined;
    objectId?: string | undefined;
    objectName?: string | undefined;

    constructor(data?: ILinkedObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldType = _data["fieldType"];
            this.fieldName = _data["fieldName"];
            this.fieldLabel = _data["fieldLabel"];
            this.objectId = _data["objectId"];
            this.objectName = _data["objectName"];
        }
    }

    static fromJS(data: any): LinkedObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this.fieldType;
        data["fieldName"] = this.fieldName;
        data["fieldLabel"] = this.fieldLabel;
        data["objectId"] = this.objectId;
        data["objectName"] = this.objectName;
        return data;
    }
}

export interface ILinkedObjectDTO {
    fieldType?: string | undefined;
    fieldName?: string | undefined;
    fieldLabel?: string | undefined;
    objectId?: string | undefined;
    objectName?: string | undefined;
}

export class SetGroopitExternalIdDTO implements ISetGroopitExternalIdDTO {
    orgId?: string | undefined;
    groopitId?: string;
    externalId?: string | undefined;

    constructor(data?: ISetGroopitExternalIdDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgId = _data["orgId"];
            this.groopitId = _data["groopitId"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): SetGroopitExternalIdDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetGroopitExternalIdDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgId"] = this.orgId;
        data["groopitId"] = this.groopitId;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface ISetGroopitExternalIdDTO {
    orgId?: string | undefined;
    groopitId?: string;
    externalId?: string | undefined;
}

/** Semantic representation of an EDM model. */
export abstract class IEdmModel implements IIEdmModel {
    /** Gets the collection of schema elements that are contained in this model. */
    schemaElements?: IEdmSchemaElement[] | undefined;
    /** Gets the collection of vocabulary annotations that are contained in this model. */
    vocabularyAnnotations?: IEdmVocabularyAnnotation[] | undefined;
    /** Gets the collection of models referred to by this model (mainly by the this.References). */
    referencedModels?: IEdmModel[] | undefined;
    /** Gets the collection of namespaces that schema elements use contained in this model. */
    declaredNamespaces?: string[] | undefined;
    /** Gets the model's annotations manager. */
    directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager | undefined;
    /** Gets the only one entity container of the model. */
    entityContainer?: IEdmEntityContainer | undefined;

    constructor(data?: IIEdmModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SchemaElements"])) {
                this.schemaElements = [] as any;
                for (let item of _data["SchemaElements"])
                    this.schemaElements!.push(IEdmSchemaElement.fromJS(item));
            }
            if (Array.isArray(_data["VocabularyAnnotations"])) {
                this.vocabularyAnnotations = [] as any;
                for (let item of _data["VocabularyAnnotations"])
                    this.vocabularyAnnotations!.push(IEdmVocabularyAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["ReferencedModels"])) {
                this.referencedModels = [] as any;
                for (let item of _data["ReferencedModels"])
                    this.referencedModels!.push(IEdmModel.fromJS(item));
            }
            if (Array.isArray(_data["DeclaredNamespaces"])) {
                this.declaredNamespaces = [] as any;
                for (let item of _data["DeclaredNamespaces"])
                    this.declaredNamespaces!.push(item);
            }
            this.directValueAnnotationsManager = _data["DirectValueAnnotationsManager"] ? IEdmDirectValueAnnotationsManager.fromJS(_data["DirectValueAnnotationsManager"]) : <any>undefined;
            this.entityContainer = _data["EntityContainer"] ? IEdmEntityContainer.fromJS(_data["EntityContainer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schemaElements)) {
            data["SchemaElements"] = [];
            for (let item of this.schemaElements)
                data["SchemaElements"].push(item.toJSON());
        }
        if (Array.isArray(this.vocabularyAnnotations)) {
            data["VocabularyAnnotations"] = [];
            for (let item of this.vocabularyAnnotations)
                data["VocabularyAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.referencedModels)) {
            data["ReferencedModels"] = [];
            for (let item of this.referencedModels)
                data["ReferencedModels"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNamespaces)) {
            data["DeclaredNamespaces"] = [];
            for (let item of this.declaredNamespaces)
                data["DeclaredNamespaces"].push(item);
        }
        data["DirectValueAnnotationsManager"] = this.directValueAnnotationsManager ? this.directValueAnnotationsManager.toJSON() : <any>undefined;
        data["EntityContainer"] = this.entityContainer ? this.entityContainer.toJSON() : <any>undefined;
        return data;
    }
}

/** Semantic representation of an EDM model. */
export interface IIEdmModel {
    /** Gets the collection of schema elements that are contained in this model. */
    schemaElements?: IEdmSchemaElement[] | undefined;
    /** Gets the collection of vocabulary annotations that are contained in this model. */
    vocabularyAnnotations?: IEdmVocabularyAnnotation[] | undefined;
    /** Gets the collection of models referred to by this model (mainly by the this.References). */
    referencedModels?: IEdmModel[] | undefined;
    /** Gets the collection of namespaces that schema elements use contained in this model. */
    declaredNamespaces?: string[] | undefined;
    /** Gets the model's annotations manager. */
    directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager | undefined;
    /** Gets the only one entity container of the model. */
    entityContainer?: IEdmEntityContainer | undefined;
}

/** Common base interface for all named children of EDM schema. */
export abstract class IEdmSchemaElement implements IIEdmSchemaElement {
    /** Gets the kind of this schema element. */
    schemaElementKind?: EdmSchemaElementKind;
    /** Gets the namespace this schema element belongs to. */
    namespace?: string | undefined;

    constructor(data?: IIEdmSchemaElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schemaElementKind = _data["SchemaElementKind"];
            this.namespace = _data["Namespace"];
        }
    }

    static fromJS(data: any): IEdmSchemaElement {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmSchemaElement' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SchemaElementKind"] = this.schemaElementKind;
        data["Namespace"] = this.namespace;
        return data;
    }
}

/** Common base interface for all named children of EDM schema. */
export interface IIEdmSchemaElement {
    /** Gets the kind of this schema element. */
    schemaElementKind?: EdmSchemaElementKind;
    /** Gets the namespace this schema element belongs to. */
    namespace?: string | undefined;
}

/** Defines EDM schema element types. */
export enum EdmSchemaElementKind {
    None = 0,
    TypeDefinition = 1,
    Term = 2,
    Action = 3,
    EntityContainer = 4,
    Function = 5,
}

/** Represents an EDM vocabulary annotation. */
export abstract class IEdmVocabularyAnnotation implements IIEdmVocabularyAnnotation {
    /** Gets the qualifier used to discriminate between multiple bindings of the same property or type. */
    qualifier?: string | undefined;
    /** Gets the term bound by the annotation. */
    term?: IEdmTerm | undefined;
    /** Gets the element the annotation applies to. */
    target?: IEdmVocabularyAnnotatable | undefined;
    /** Gets the expression producing the value of the annotation. */
    value?: IEdmExpression | undefined;

    constructor(data?: IIEdmVocabularyAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifier = _data["Qualifier"];
            this.term = _data["Term"] ? IEdmTerm.fromJS(_data["Term"]) : <any>undefined;
            this.target = _data["Target"] ? IEdmVocabularyAnnotatable.fromJS(_data["Target"]) : <any>undefined;
            this.value = _data["Value"] ? IEdmExpression.fromJS(_data["Value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmVocabularyAnnotation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmVocabularyAnnotation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Qualifier"] = this.qualifier;
        data["Term"] = this.term ? this.term.toJSON() : <any>undefined;
        data["Target"] = this.target ? this.target.toJSON() : <any>undefined;
        data["Value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents an EDM vocabulary annotation. */
export interface IIEdmVocabularyAnnotation {
    /** Gets the qualifier used to discriminate between multiple bindings of the same property or type. */
    qualifier?: string | undefined;
    /** Gets the term bound by the annotation. */
    term?: IEdmTerm | undefined;
    /** Gets the element the annotation applies to. */
    target?: IEdmVocabularyAnnotatable | undefined;
    /** Gets the expression producing the value of the annotation. */
    value?: IEdmExpression | undefined;
}

/** Represents an EDM term. */
export abstract class IEdmTerm implements IIEdmTerm {
    /** Gets the type of this term. */
    type?: IEdmTypeReference | undefined;
    /** Gets the AppliesTo of this term. */
    appliesTo?: string | undefined;
    /** Gets the DefaultValue of this term. */
    defaultValue?: string | undefined;

    constructor(data?: IIEdmTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"] ? IEdmTypeReference.fromJS(_data["Type"]) : <any>undefined;
            this.appliesTo = _data["AppliesTo"];
            this.defaultValue = _data["DefaultValue"];
        }
    }

    static fromJS(data: any): IEdmTerm {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmTerm' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["AppliesTo"] = this.appliesTo;
        data["DefaultValue"] = this.defaultValue;
        return data;
    }
}

/** Represents an EDM term. */
export interface IIEdmTerm {
    /** Gets the type of this term. */
    type?: IEdmTypeReference | undefined;
    /** Gets the AppliesTo of this term. */
    appliesTo?: string | undefined;
    /** Gets the DefaultValue of this term. */
    defaultValue?: string | undefined;
}

/** Represents a references to a type. */
export abstract class IEdmTypeReference implements IIEdmTypeReference {
    /** Gets a value indicating whether this type is nullable. */
    isNullable?: boolean;
    /** Gets the definition to which this type refers. */
    definition?: IEdmType | undefined;

    constructor(data?: IIEdmTypeReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isNullable = _data["IsNullable"];
            this.definition = _data["Definition"] ? IEdmType.fromJS(_data["Definition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmTypeReference {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmTypeReference' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsNullable"] = this.isNullable;
        data["Definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents a references to a type. */
export interface IIEdmTypeReference {
    /** Gets a value indicating whether this type is nullable. */
    isNullable?: boolean;
    /** Gets the definition to which this type refers. */
    definition?: IEdmType | undefined;
}

/** Represents the definition of an EDM type. */
export abstract class IEdmType implements IIEdmType {
    /** Gets the kind of this type. */
    typeKind?: EdmTypeKind;

    constructor(data?: IIEdmType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeKind = _data["TypeKind"];
        }
    }

    static fromJS(data: any): IEdmType {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmType' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TypeKind"] = this.typeKind;
        return data;
    }
}

/** Represents the definition of an EDM type. */
export interface IIEdmType {
    /** Gets the kind of this type. */
    typeKind?: EdmTypeKind;
}

/** Defines EDM metatypes. */
export enum EdmTypeKind {
    None = 0,
    Primitive = 1,
    Entity = 2,
    Complex = 3,
    Collection = 4,
    EntityReference = 5,
    Enum = 6,
    TypeDefinition = 7,
    Untyped = 8,
    Path = 9,
}

/** Represents an element that can be targeted by Vocabulary Annotations */
export abstract class IEdmVocabularyAnnotatable implements IIEdmVocabularyAnnotatable {

    constructor(data?: IIEdmVocabularyAnnotatable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IEdmVocabularyAnnotatable {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmVocabularyAnnotatable' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents an element that can be targeted by Vocabulary Annotations */
export interface IIEdmVocabularyAnnotatable {
}

/** Represents an EDM expression. */
export abstract class IEdmExpression implements IIEdmExpression {
    /** Gets the kind of this expression. */
    expressionKind?: EdmExpressionKind;

    constructor(data?: IIEdmExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressionKind = _data["ExpressionKind"];
        }
    }

    static fromJS(data: any): IEdmExpression {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmExpression' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExpressionKind"] = this.expressionKind;
        return data;
    }
}

/** Represents an EDM expression. */
export interface IIEdmExpression {
    /** Gets the kind of this expression. */
    expressionKind?: EdmExpressionKind;
}

/** Defines EDM expression kinds. */
export enum EdmExpressionKind {
    None = 0,
    BinaryConstant = 1,
    BooleanConstant = 2,
    DateTimeOffsetConstant = 3,
    DecimalConstant = 4,
    FloatingConstant = 5,
    GuidConstant = 6,
    IntegerConstant = 7,
    StringConstant = 8,
    DurationConstant = 9,
    Null = 10,
    Record = 11,
    Collection = 12,
    Path = 13,
    If = 14,
    Cast = 15,
    IsType = 16,
    FunctionApplication = 17,
    LabeledExpressionReference = 18,
    Labeled = 19,
    PropertyPath = 20,
    NavigationPropertyPath = 21,
    DateConstant = 22,
    TimeOfDayConstant = 23,
    EnumMember = 24,
    AnnotationPath = 25,
}

/** Manages getting and setting direct annotations on EDM elements. */
export abstract class IEdmDirectValueAnnotationsManager implements IIEdmDirectValueAnnotationsManager {

    constructor(data?: IIEdmDirectValueAnnotationsManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IEdmDirectValueAnnotationsManager {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmDirectValueAnnotationsManager' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Manages getting and setting direct annotations on EDM elements. */
export interface IIEdmDirectValueAnnotationsManager {
}

/** Represents an EDM entity container. */
export abstract class IEdmEntityContainer implements IIEdmEntityContainer {
    /** Gets a collection of the elements of this entity container. */
    elements?: IEdmEntityContainerElement[] | undefined;

    constructor(data?: IIEdmEntityContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Elements"])) {
                this.elements = [] as any;
                for (let item of _data["Elements"])
                    this.elements!.push(IEdmEntityContainerElement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IEdmEntityContainer {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmEntityContainer' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["Elements"] = [];
            for (let item of this.elements)
                data["Elements"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents an EDM entity container. */
export interface IIEdmEntityContainer {
    /** Gets a collection of the elements of this entity container. */
    elements?: IEdmEntityContainerElement[] | undefined;
}

/** Represents the common elements of all EDM entity container elements. */
export abstract class IEdmEntityContainerElement implements IIEdmEntityContainerElement {
    /** Gets the kind of element of this container element. */
    containerElementKind?: EdmContainerElementKind;
    /** Gets the container that contains this element. */
    container?: IEdmEntityContainer | undefined;

    constructor(data?: IIEdmEntityContainerElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerElementKind = _data["ContainerElementKind"];
            this.container = _data["Container"] ? IEdmEntityContainer.fromJS(_data["Container"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmEntityContainerElement {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmEntityContainerElement' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContainerElementKind"] = this.containerElementKind;
        data["Container"] = this.container ? this.container.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents the common elements of all EDM entity container elements. */
export interface IIEdmEntityContainerElement {
    /** Gets the kind of element of this container element. */
    containerElementKind?: EdmContainerElementKind;
    /** Gets the container that contains this element. */
    container?: IEdmEntityContainer | undefined;
}

/** Defines EDM container element types. */
export enum EdmContainerElementKind {
    None = 0,
    EntitySet = 1,
    ActionImport = 2,
    FunctionImport = 3,
    Singleton = 4,
}

/** Base class for all annotatable types in OData library. */
export abstract class ODataAnnotatable implements IODataAnnotatable {
    /** The annotation for storing @odata.type. */
    typeAnnotation?: ODataTypeAnnotation | undefined;

    constructor(data?: IODataAnnotatable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeAnnotation = _data["TypeAnnotation"] ? ODataTypeAnnotation.fromJS(_data["TypeAnnotation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataAnnotatable {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ODataAnnotatable' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TypeAnnotation"] = this.typeAnnotation ? this.typeAnnotation.toJSON() : <any>undefined;
        return data;
    }
}

/** Base class for all annotatable types in OData library. */
export interface IODataAnnotatable {
    /** The annotation for storing @odata.type. */
    typeAnnotation?: ODataTypeAnnotation | undefined;
}

/** Class representing the a service document. */
export class ODataServiceDocument extends ODataAnnotatable implements IODataServiceDocument {
    /** Gets or sets the set of entity sets in the service document. */
    entitySets?: ODataEntitySetInfo[] | undefined;
    /** Gets or sets the set of singletons in the service document. */
    singletons?: ODataSingletonInfo[] | undefined;
    /** Gets or sets the set of function imports in the service document. */
    functionImports?: ODataFunctionImportInfo[] | undefined;

    constructor(data?: IODataServiceDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["EntitySets"])) {
                this.entitySets = [] as any;
                for (let item of _data["EntitySets"])
                    this.entitySets!.push(ODataEntitySetInfo.fromJS(item));
            }
            if (Array.isArray(_data["Singletons"])) {
                this.singletons = [] as any;
                for (let item of _data["Singletons"])
                    this.singletons!.push(ODataSingletonInfo.fromJS(item));
            }
            if (Array.isArray(_data["FunctionImports"])) {
                this.functionImports = [] as any;
                for (let item of _data["FunctionImports"])
                    this.functionImports!.push(ODataFunctionImportInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ODataServiceDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ODataServiceDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entitySets)) {
            data["EntitySets"] = [];
            for (let item of this.entitySets)
                data["EntitySets"].push(item.toJSON());
        }
        if (Array.isArray(this.singletons)) {
            data["Singletons"] = [];
            for (let item of this.singletons)
                data["Singletons"].push(item.toJSON());
        }
        if (Array.isArray(this.functionImports)) {
            data["FunctionImports"] = [];
            for (let item of this.functionImports)
                data["FunctionImports"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

/** Class representing the a service document. */
export interface IODataServiceDocument extends IODataAnnotatable {
    /** Gets or sets the set of entity sets in the service document. */
    entitySets?: ODataEntitySetInfo[] | undefined;
    /** Gets or sets the set of singletons in the service document. */
    singletons?: ODataSingletonInfo[] | undefined;
    /** Gets or sets the set of function imports in the service document. */
    functionImports?: ODataFunctionImportInfo[] | undefined;
}

/** Abstract class representing an element (EntitySet, Singleton) in a service document. */
export abstract class ODataServiceDocumentElement extends ODataAnnotatable implements IODataServiceDocumentElement {
    /** Gets or sets the URI representing the Unified Resource Locator (URL) to the element. */
    url?: string | undefined;
    /** Gets or sets the name of the element; this is the entity set or singleton name in JSON and the HREF in Atom. */
    name?: string | undefined;
    /** Gets or sets the title of the element; this is the title in JSON. */
    title?: string | undefined;

    constructor(data?: IODataServiceDocumentElement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.url = _data["Url"];
            this.name = _data["Name"];
            this.title = _data["Title"];
        }
    }

    static fromJS(data: any): ODataServiceDocumentElement {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ODataServiceDocumentElement' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Url"] = this.url;
        data["Name"] = this.name;
        data["Title"] = this.title;
        super.toJSON(data);
        return data;
    }
}

/** Abstract class representing an element (EntitySet, Singleton) in a service document. */
export interface IODataServiceDocumentElement extends IODataAnnotatable {
    /** Gets or sets the URI representing the Unified Resource Locator (URL) to the element. */
    url?: string | undefined;
    /** Gets or sets the name of the element; this is the entity set or singleton name in JSON and the HREF in Atom. */
    name?: string | undefined;
    /** Gets or sets the title of the element; this is the title in JSON. */
    title?: string | undefined;
}

/** Class representing a entity set in a service document. */
export class ODataEntitySetInfo extends ODataServiceDocumentElement implements IODataEntitySetInfo {

    constructor(data?: IODataEntitySetInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ODataEntitySetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ODataEntitySetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Class representing a entity set in a service document. */
export interface IODataEntitySetInfo extends IODataServiceDocumentElement {
}

/** Annotation which stores the EDM type information of a value. */
export class ODataTypeAnnotation implements IODataTypeAnnotation {
    /** Gets the type name to serialize, for the annotated item.  */
    typeName?: string | undefined;

    constructor(data?: IODataTypeAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeName = _data["TypeName"];
        }
    }

    static fromJS(data: any): ODataTypeAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ODataTypeAnnotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TypeName"] = this.typeName;
        return data;
    }
}

/** Annotation which stores the EDM type information of a value. */
export interface IODataTypeAnnotation {
    /** Gets the type name to serialize, for the annotated item.  */
    typeName?: string | undefined;
}

/** Class representing a singleton in a service document. */
export class ODataSingletonInfo extends ODataServiceDocumentElement implements IODataSingletonInfo {

    constructor(data?: IODataSingletonInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ODataSingletonInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ODataSingletonInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Class representing a singleton in a service document. */
export interface IODataSingletonInfo extends IODataServiceDocumentElement {
}

/** Class representing a function Import in a service document. */
export class ODataFunctionImportInfo extends ODataServiceDocumentElement implements IODataFunctionImportInfo {

    constructor(data?: IODataFunctionImportInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ODataFunctionImportInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ODataFunctionImportInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Class representing a function Import in a service document. */
export interface IODataFunctionImportInfo extends IODataServiceDocumentElement {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
export interface IConfig {
  /**
   * Returns a valid value for the Authorization header.
   * Used to dynamically inject the current auth header.
   */
  getXSRFToken?: () => string;
  getAuthToken?: () => string;
  getOutlookBearerToken?: () => string;
  getOutlookHostName?: () => string;
  getOutlookHostVersion?: () => string;
}